webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_app__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_menu__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modules_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_schedule__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_auth__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_medical_record__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_patient__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_proced__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_exam__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_examination_report__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_memed__ = __webpack_require__(466);


var _mutations;






// import * as mutations from 'mutations'












__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  strict: "production" !== 'production',
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_6__modules_app__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_7__modules_menu___default.a,
    schedule: __WEBPACK_IMPORTED_MODULE_8__modules_schedule__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_9__modules_auth__["a" /* default */],
    medicalRecord: __WEBPACK_IMPORTED_MODULE_10__modules_medical_record__["a" /* default */],
    patient: __WEBPACK_IMPORTED_MODULE_11__modules_patient__["a" /* default */],
    proced: __WEBPACK_IMPORTED_MODULE_12__modules_proced__["a" /* default */],
    exam: __WEBPACK_IMPORTED_MODULE_13__modules_exam__["a" /* default */],
    examinationReport: __WEBPACK_IMPORTED_MODULE_14__modules_examination_report__["a" /* default */],
    memed: __WEBPACK_IMPORTED_MODULE_15__modules_memed__["a" /* default */]
  },
  state: {
    customer: '',
    recoveryPassword: {
      token: null
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* CUSTOMER */], function (store, obj) {
    store.customer = obj;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* RECOVERY_PASSWORD */], function (store, obj) {
    store.recoveryPassword.token = obj;
  }), _mutations)
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Toolbar_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Footer_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_auth_Login_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_migrationDialog_index__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ToolbarMenu: __WEBPACK_IMPORTED_MODULE_1__components_layout_Toolbar_vue__["a" /* default */],
    FooterMenu: __WEBPACK_IMPORTED_MODULE_2__components_layout_Footer_vue__["a" /* default */],
    AuthLogin: __WEBPACK_IMPORTED_MODULE_3__views_auth_Login_vue__["a" /* default */],
    MigrationDialog: __WEBPACK_IMPORTED_MODULE_4__components_migrationDialog_index__["a" /* default */]
  },
  data: function data() {
    return {
      show: false,
      isMobile: false,
      isTablet: false
    };
  },
  mounted: function mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
    this.homeScreen();
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    logged: function logged() {
      return this.$store.state.auth.auth.isLogged;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['getUser'])),
  methods: {
    homeScreen: function homeScreen() {
      window.console.log('homeScreen');
      window.addEventListener('beforeinstallprompt', function (e) {
        // beforeinstallprompt Event fired
        // e.userChoice will return a Promise.
        // For more details read: https://developers.google.com/web/fundamentals/getting-started/primers/promises
        e.userChoice.then(function (choiceResult) {
          if (false) console.log(choiceResult.outcome);
          if (choiceResult.outcome === 'dismissed') {
            console.log('User cancelled home screen install');
          } else {
            console.log('User added to home screen');
          }
        });
      });
    },
    onResize: function onResize() {
      // this.isMobile = window.innerWidth < 600
      if (window.innerWidth < 600) {
        this.isMobile = true;
        this.isTablet = false;
      } else if (window.innerWidth > 600 && window.innerWidth < 960) {
        this.isMobile = false;
        this.isTablet = true;
      } else if (window.innerWidth > 960) {
        this.isTablet = false;
        this.isMobile = false;
      }
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('app/setDevice', { mobile: this.isMobile, tablet: this.isTablet }).then(function () {
        // console.log()
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  name: 'App'
});

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widgets_config__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('auth', ['setSingOut']), {
    actionMenu: function actionMenu(value) {
      if (value === 'sair') {
        this.logout();
      } else if (value === 'profile') {
        this.$router.push('/profile');
      } else if (value === 'change-schedule') {
        this.$router.push('/change-schedule');
      }
    },
    logout: function logout() {
      this.setSingOut();
      this.$router.push('/auth/login');
    }
  }),
  components: {
    configWidgets: __WEBPACK_IMPORTED_MODULE_1__Widgets_config__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('schedule', ['getList', 'getAvailableAppointments']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getDevice'])),
  data: function data() {
    return {
      e2: 0,
      show: true,
      fav: true,
      menu: false,
      message: true,
      menuItems: [{ title: 'Setor/Agenda', to: '/change-schedule', icon: 'shuffle', action: 'change-schedule' }, { title: 'Perfil', to: '/profile', icon: 'account_circle', action: 'profile' }, { title: 'Sair', to: '/auth/login', icon: 'exit_to_app', action: 'sair' }],
      itemsNotification: [{ header: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('MMMM Do YYYY, h:mm a') }, {
        avatar: 'https://cdn1.iconfinder.com/data/icons/health-and-medical-glyps/128/8-512.png',
        title: 'Cadastro',
        subtitle: "<span class='grey--text text--darken-2'>Bem vindo</span> — Agora você poderá receber notificações"
      }, { divider: true, inset: true }, {
        avatar: 'https://cdn1.iconfinder.com/data/icons/health-and-medical-glyps/128/8-512.png',
        title: 'Agendamento <span class="grey--text text--lighten-1"></span>',
        subtitle: "<span class='grey--text text--darken-2'>Agendamento</span> — Melhor visualização do prontuário"
      }, { divider: true, inset: true }, {
        avatar: 'https://cdn1.iconfinder.com/data/icons/health-and-medical-glyps/128/8-512.png',
        title: 'Notícia',
        subtitle: "<span class='grey--text text--darken-2'>Consultor</span> — Consultor pessoal"
      }],
      clipped: true,
      drawer: false,
      fixed: false,
      items: [{
        icon: 'today',
        title: 'Agenda',
        to: '/schedule'
      }, {
        icon: 'dashboard',
        title: 'Dashboard',
        to: '/dashboard'
      }, {
        icon: 'account_circle',
        title: 'Prontuário',
        to: '/patient'
      }, {
        icon: 'phonelink_setup',
        title: 'Configurações',
        to: '/settings'
      }],
      miniVariant: true,
      right: true,
      rightDrawer: false,
      title: 'MeuClinic'
    };
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false
    };
  }
});

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.env = "production";
  },

  components: {},
  data: function data() {
    return {
      env: null,
      e2: 0,
      urlDataToken: null
    };
  },
  created: function created() {
    this.urlDataToken = this.getToken;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getDevice']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('memed', ['getToken']), {
    color: function color() {
      switch (this.e2) {
        case 0:
          return this.getTheme.color;
        case 1:
          return 'blue darken-1';
        case 2:
          return 'blue darken-3';
        case 3:
          return 'blue darken-4';
      }
    }
  }),
  name: 'Footer'
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_283b0b14_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(275);
function injectStyle (ssrContext) {
  __webpack_require__(274)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-283b0b14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_283b0b14_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { url } from '../../../config/api.link.connection'
// import customersTheme from '../../../config/customersTheme'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({ customer: 'customer' }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getPkg'])),
  mounted: function mounted() {
    this.$vuetify.theme.primary = this.getTheme.colorHTML; // this.getTheme.color
    if (false) {
      this.auth.username = 'andreza_82@hotmail.com';
      this.auth.password = '123456';
    }
  },

  data: function data() {
    return {
      env: Object({"NODE_ENV":"production","URL":"https://api.spitzer.io","URL_MEMED":"https://api-memed.gestaoclinic.com.br"}),
      password: 'Password',
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      usernameRules: [function (v) {
        return !!v || 'E-Mail obrigatório!';
      }],
      passwordRules: [function (v) {
        return !!v || 'Senha obrigatória!';
      }],
      valid: true,
      e1: false,
      auth: {
        username: '',
        password: '',
        id: '',
        client: '',
        name: '',
        remeberMe: false
      }
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('auth', ['setLogin']), {
    submit: function submit(e) {
      var _this = this;

      if (this.$refs.form.validate()) {
        this.setLogin(this.auth).then(function () {}).catch(function (err) {
          if (err.response.data.message) {
            _this.snackbarConfig.snackbar = true;
            _this.snackbarConfig.text = err.response.data.message;
            return false;
          }
          if (err.response.data.errors) {
            if (err.response.data.errors.username) {
              _this.snackbarConfig.snackbar = true;
              _this.snackbarConfig.text = err.response.data.errors.username.msg;
              return false;
            }
            if (err.response.data.errors.password) {
              _this.snackbarConfig.snackbar = true;
              _this.snackbarConfig.text = err.response.data.errors.username.password.msg;
              return false;
            }
          }
          _this.snackbarConfig.snackbar = true;
          _this.snackbarConfig.text = err.response.data.result.error;
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  })
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      modal: true
    };
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TOGGLE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXPAND_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SWITCH_EFFECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RECOVERY_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CUSTOMER; });
/* unused harmony export SCHEDULE */
/* unused harmony export THEME */
var TOGGLE_DEVICE = 'TOGGLE_DEVICE';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var EXPAND_MENU = 'EXPAND_MENU';

var SWITCH_EFFECT = 'SWITCH_EFFECT';

var AUTH = 'SET_USER';

var RECOVERY_PASSWORD = 'RECOVERY_PASSWORD';

var CUSTOMER = 'SET_CUSTOMER';

var SCHEDULE = 'SCHEDULE';

var THEME = 'THEME';

/***/ }),
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_localforage__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_page404__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_schedule__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_schedule_change__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_patient_index_new__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_graph__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_imagens__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_profile__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_dashboard__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_settings__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_auth_Sing_up__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_auth_Register__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_auth_UpdateSchedule__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_auth_SearchUser__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_auth_Reset_password__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_auth_Forget_password__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_auth_Login__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_surgery_center_surgery_center__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store__ = __webpack_require__(9);




var _this = this;






























__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  mode: 'history', // Demo is living in GitHub.io, so required! hash history
  history: true,
  linkActiveClass: 'is-active',
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: [{
    path: '/proposed-surgeries',
    name: 'proposed-surgeries',
    component: __WEBPACK_IMPORTED_MODULE_22__views_surgery_center_surgery_center__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/dashboard',
    name: 'dashboard',
    component: __WEBPACK_IMPORTED_MODULE_13__views_dashboard__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/settings',
    name: 'settings',
    component: __WEBPACK_IMPORTED_MODULE_14__views_settings__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/schedule',
    name: 'Schedule',
    component: __WEBPACK_IMPORTED_MODULE_7__views_schedule__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/change-schedule',
    name: 'changeSchedule',
    component: __WEBPACK_IMPORTED_MODULE_8__views_schedule_change__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/update-schedule',
    name: 'UpdateSchedule',
    component: __WEBPACK_IMPORTED_MODULE_17__views_auth_UpdateSchedule__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/patient',
    name: 'Patient',
    component: __WEBPACK_IMPORTED_MODULE_9__views_patient_index_new__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/graph',
    name: 'Gráficos',
    component: __WEBPACK_IMPORTED_MODULE_10__views_graph__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/imagem',
    name: 'Imagens',
    component: __WEBPACK_IMPORTED_MODULE_11__views_imagens__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_12__views_profile__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '*',
    redirect: '/auth/login'
  }, {
    path: '/auth/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_21__views_auth_Login__["a" /* default */],
    meta: { auth: false }
  }, {
    path: '/auth/reset-password',
    name: 'ResetPassword',
    component: __WEBPACK_IMPORTED_MODULE_19__views_auth_Reset_password__["a" /* default */],
    meta: { auth: false }
  }, {
    path: '/auth/forget-password',
    name: 'ForgetPassword',
    component: __WEBPACK_IMPORTED_MODULE_20__views_auth_Forget_password__["a" /* default */],
    meta: { auth: false }
  }, {
    path: '/auth/register',
    name: 'Register',
    component: __WEBPACK_IMPORTED_MODULE_16__views_auth_Register__["a" /* default */],
    meta: { auth: false }
  }, {
    path: '/auth/sing-up',
    name: 'Singup',
    component: __WEBPACK_IMPORTED_MODULE_15__views_auth_Sing_up__["a" /* default */],
    meta: {
      auth: false
    }
  }, {
    path: '/auth/search-user',
    name: 'SearchUser',
    component: __WEBPACK_IMPORTED_MODULE_18__views_auth_SearchUser__["a" /* default */],
    meta: { auth: false }
  }, {
    path: '/pagenotfound',
    name: 'PageNotFound',
    component: __WEBPACK_IMPORTED_MODULE_6__views_page404__["a" /* default */],
    meta: {
      auth: false
    }
  }, {
    path: '*',
    redirect: '/auth/login'
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.path === '/auth/reset-password' && to.query.token !== undefined) {
    // console.log(to.path)
    // console.log(to.query.token)
    __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('setTokenRecoveryPassword', to.query.token).then(function () {
      return console.log('aaa');
    });
  }
  var promise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (to.path !== '/pagenotfound') {
      if (__WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].state.auth.token) {
        window.axios.defaults.headers.common['x-access-token'] = __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].state.auth.token;
      }
      if (to.meta.auth === false) {
        return resolve(next());
      }
      resolve(next());
    } else {
      resolve();
    }
  });

  promise.then(function () {
    var originalPush = __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */].prototype.push;
    __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */].prototype.push = function push(location, onResolve, onReject) {
      if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
      return originalPush.call(this, location).catch(function (err) {
        return err;
      });
    };

    if (to.meta.auth === false) {
      return next();
    }

    if (to.meta.auth === true && !__WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].state.auth.auth.isLogged) {
      return next('/auth/login');
    }

    if (to.meta.auth !== undefined || to.meta.auth !== false) {
      if (!__WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].state.auth.auth.isLogged && to.path === '/auth/reset-password') {
        return next('/auth/reset-password');
      } else if (!__WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].state.auth.auth.isLogged && to.path === '/auth/login') {
        return next('/auth/login');
      }
    } else {
      return next('/auth/login');
    }
  }).then(function () {
    if (from.path === '/auth/login' || from.path === '/') {
      __WEBPACK_IMPORTED_MODULE_5_localforage___default.a.getItem('my-clinic-user', function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(err, value) {
          var decoded, arrayCredencials, auth;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (err) console.error(err);

                  if (value) {
                    _context2.next = 3;
                    break;
                  }

                  return _context2.abrupt('return', false);

                case 3:
                  decoded = atob(value.user.credentials);
                  arrayCredencials = decoded.split(':', 2);
                  auth = {
                    username: arrayCredencials[0],
                    password: arrayCredencials[1],
                    customer: 'asasasa'
                  };
                  _context2.next = 8;
                  return __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */].dispatch('auth/setSingIn', auth).then(function () {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (!response) {
                                _context.next = 4;
                                break;
                              }

                              if (!(from.path === '/auth/login')) {
                                _context.next = 4;
                                break;
                              }

                              _context.next = 4;
                              return next('/schedule');

                            case 4:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function (_x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }());

                case 8:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (err) {
        return window.console.error('err', err);
      });
    }
  }).catch(function () {
    return next('/auth/login');
  });
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_schedule_AgreementColumn__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_schedule_Type__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_patient_record_new__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_schedule_change__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_schedule_create__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { v4 as uuidv4 } from 'uuid'
// import { JitsiMeet } from '@mycure/vue-jitsi-meet'






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ChartAgreement: __WEBPACK_IMPORTED_MODULE_2__components_charts_schedule_AgreementColumn__["a" /* default */],
    ChartType: __WEBPACK_IMPORTED_MODULE_3__components_charts_schedule_Type__["a" /* default */],
    NewRecord: __WEBPACK_IMPORTED_MODULE_4__components_patient_record_new__["a" /* default */],
    ChangeSchedule: __WEBPACK_IMPORTED_MODULE_5__components_schedule_change__["a" /* default */],
    CreateSchedule: __WEBPACK_IMPORTED_MODULE_6__components_schedule_create__["a" /* default */]
    // VueJitsiMeet: JitsiMeet
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('medicalRecord', ['getListRecord', 'getAvailableAppointments']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('memed', ['getToken']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('schedule', ['getList', 'getAvailableAppointments', 'getAppointments', 'getAppointmentsSurgerycenter']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getDevice'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('medicalRecord', ['setListRecord', 'setAvailableAppointments']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('schedule', ['setList', 'setAvailableAppointments', 'setLockAppointments', 'setUnLockAppointments', 'setAppointmentsSurgerycenter', 'setSurgeries']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('patient', ['setPatient']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('memed', ['createPatientMemed']), {
    setDialogSelectCRM: function setDialogSelectCRM() {
      this.appointments(this.date, this.auth.auth.myClinic.crm);
      this.dialogSelectCRM = false;
    },
    functionEvents: function functionEvents(date) {
      // const [,, day] = date.split('-')
      // if ([12, 17, 28].includes(parseInt(day, 10))) return true
      // if ([1, 19, 22].includes(parseInt(day, 10))) return ['red', '#00f']
      return false;
    },
    getListRecordItem: function getListRecordItem(item) {
      var _this = this;

      this.setListRecord({ patient: item, customer: this.auth.auth.myClinic.customer }).then(function () {
        _this.itensRecord = _this.getListRecord;
      });
    },
    blockAppontament: function blockAppontament(item) {
      var _this2 = this;

      this.infoScheduleModalFree = false;
      if (this.detailTypeAppontament.title === 'Horário Vago') {
        this.setLockAppointments(item).then(function () {
          var period = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.period, 'MM/DD/YYYY').format('YYYY-MM-DD');
          _this2.appointments(period);
        });
      } else {
        this.setUnLockAppointments(item).then(function () {
          var period = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.period, 'MM/DD/YYYY').format('YYYY-MM-DD');
          _this2.appointments(period);
        });
      }
    },
    infoSchedule: function infoSchedule(item) {
      if (item.id === undefined || item.id === null) {
        this.infoScheduleModalFree = true;
        this.detailTypeAppontament.title = 'Horário Vago';
        this.detailTypeAppontament.desc = 'Deseja Bloquear este horário?';
        this.detailTypeAppontament.buttonOk = 'Bloquear';
        this.detailSchedule = item;
      } else if (item.type === 'Horário Bloqueado') {
        this.detailTypeAppontament.title = 'Horário Bloqueado';
        this.detailTypeAppontament.desc = 'Deseja Desbloquear o horário?';
        this.detailTypeAppontament.buttonOk = 'Desbloquear';
        this.infoScheduleModalFree = true;
        this.detailSchedule = item;
      } else {
        this.getListRecordItem(item.code);
        this.infoScheduleModal = true;
        this.detailSchedule = item;
        this.setPatient(item.code);
        item.idCustomer = this.auth.auth.myClinic.customer;
        this.createPatientMemed(item);
      }
    },
    closeNewRecord: function closeNewRecord() {
      this.newRecord = false;
    },
    schedule: function schedule() {
      this.modal = true;
    },
    closeModalInfo: function closeModalInfo() {
      this.infoScheduleModal = false;
      this.newRecord = false;
    },
    closeDialogCreate: function closeDialogCreate() {
      this.dialogCreated = false;
    },
    appointments: function appointments(date) {
      var _this3 = this;

      this.modal = false;
      var period = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD');
      this.loading = true;
      this.setList({ date: period, doctor: this.auth.auth.myClinic.crm, customer: this.auth.auth.myClinic.customer }).then(function () {
        _this3.items = _this3.getAppointments;
        _this3.items2 = _this3.getList;
        _this3.loading = false;
        _this3.date = date;
        _this3.urlDataToken = _this3.getToken;
      });

      this.setAppointmentsSurgerycenter({ date: period, doctor: this.auth.auth.myClinic.crm }).then(function () {
        _this3.items3 = _this3.getAppointmentsSurgerycenter;
      }).catch(function (err) {
        console.error(err);
        _this3.items3 = [];
      });
    },
    actionMenu: function actionMenu(value) {
      if (value === 'proposed-surgeries') {
        this.$router.push('/proposed-surgeries');
      } else if (value === 'change-schedule') {
        this.$router.push('/change-schedule');
      } else if (value === 'change-schedule') {
        this.$router.push('/change-schedule');
      }
    }
  }),
  mounted: function mounted() {
    this.$bus.$on('setDialogSelectCRM', this.setDialogSelectCRM);
    this.$bus.$on('closeDialogSchedule', this.closeDialogCreate);
    this.appointments(new Date().toISOString().substr(0, 10), this.auth.auth.myClinic.crm);
    this.env = "production";
    this.setSurgeries();
  },

  filters: {
    formatDate: function formatDate(value) {
      if (!value) return '';
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('DD-MM-YYYY');
    }
  },
  data: function data() {
    return {
      env: null,
      menuItems: [{ title: 'Clinic', to: '/change-schedule', icon: 'event', action: 'proposed-surgeries' }, { title: 'Centro Cirurgico', to: '/profile', icon: 'mdi-hospital-box', action: 'change-schedule' }, { title: 'Compromissos', to: '/auth/login', icon: 'notifications', action: 'change-schedule' }],
      urlDataToken: null,
      detailSchedule: {},
      detailTypeAppontament: {},
      infoScheduleModal: false,
      infoScheduleModalFree: false,
      dialogSelectCRM: false,
      dialogCreated: false,
      loading: false,
      miniVariant: true,
      clipped: true,
      drawer: false,
      fixed: false,
      modal: false,
      date: new Date().toISOString().substr(0, 10),
      items: [],
      items2: [],
      items3: [],
      itensRecord: [],
      newRecord: false
    };
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Charts-Convenios',
  mounted: function mounted() {
    this.dataSource();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('schedule', ['getList', 'getAvailableAppointments', 'getAppointments'])),
  props: ['categories', 'value'],
  watch: {
    getList: function getList() {
      this.dataSource();
    }
  },
  methods: {
    dataSource: function dataSource() {
      var convenios = !this.getList ? [] : this.getList.map(function (item) {
        return item.convenantDesc;
      });
      var data = convenios.filter(function (element) {
        return element !== undefined;
      });
      var base = __WEBPACK_IMPORTED_MODULE_3_lodash___default()(data).countBy().map(function (value, key) {
        return { key: key, value: value };
      }).orderBy(['value'], ['desc']).value();
      var categories = base.map(function (item) {
        return item.key;
      });
      var values = base.map(function (item) {
        return item.value;
      });
      this.setup({ categories: categories, values: values });
    },
    setup: function setup(obj) {
      var categories = obj.categories,
          values = obj.values;

      __WEBPACK_IMPORTED_MODULE_1_highcharts___default.a.chart('graficoConvenios', {
        chart: {
          type: 'column'
        },
        title: {
          text: 'Convênios'
        },
        subtitle: {
          text: 'Fonte: Risc Sistemas em Saúde'
        },
        xAxis: {
          categories: categories,
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },
        series: [{
          name: 'Quantidade',
          data: values

        }]
      });
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Charts-Convenios',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('schedule', ['getList', 'getAvailableAppointments', 'getAppointments'])),
  props: ['categories', 'value'],
  watch: {
    getList: function getList() {
      this.dataSource();
    }
  },
  methods: {
    dataSource: function dataSource() {
      var tipos = !this.getList ? [] : this.getList.map(function (item) {
        return item.type;
      });
      var dataTipos = tipos.filter(function (element) {
        return element !== undefined;
      });
      var baseTipos = __WEBPACK_IMPORTED_MODULE_3_lodash___default()(dataTipos).countBy().map(function (value, key) {
        return { key: key, value: value };
      }).orderBy(['value'], ['desc']).value();

      var categoriesTipos = baseTipos.map(function (item) {
        return item.key;
      });
      var valuesTipos = baseTipos.map(function (item) {
        return item.value;
      });
      this.setup({ categoriesTipos: categoriesTipos, valuesTipos: valuesTipos });
    },
    setup: function setup(obj) {
      var categoriesTipos = obj.categoriesTipos,
          valuesTipos = obj.valuesTipos;

      __WEBPACK_IMPORTED_MODULE_1_highcharts___default.a.chart('graficoTipos', {
        chart: {
          type: 'column'
        },
        title: {
          text: 'Tipos'
        },
        subtitle: {
          text: 'Fonte: Risc Sistemas em Saúde'
        },
        xAxis: {
          categories: categoriesTipos,
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },
        series: [{
          name: 'Quantidade',
          data: valuesTipos
        }]
      });
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fd2df91_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_vue__ = __webpack_require__(353);
function injectStyle (ssrContext) {
  __webpack_require__(352)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fd2df91"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fd2df91_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('pt-br');
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewRecord',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({ customer: 'customer', auth: 'auth' }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('medicalRecord', ['getListRecord', 'getAvailableAppointments']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('patient', ['getPatient']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getPkg'])),
  components: {},
  mounted: function mounted() {
    this.$bus.$on('getMedicalRecord', this.loadingPatient);
  },

  data: function data() {
    return {
      modal: false,
      env: Object({"NODE_ENV":"production","URL":"https://api.spitzer.io","URL_MEMED":"https://api-memed.gestaoclinic.com.br"}),
      dateRules: [function (v) {
        return !!v || 'Campo requerido!';
      }],
      descriptionRules: [function (v) {
        return !!v || 'Campo requerido!';
      }],
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      valid: false,
      patientsChart: {
        date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('DD-MM-YYYY'),
        record: null,
        patient: null,
        doctor: null,
        description: null
      }
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('medicalRecord', ['setCreateRecord']), {
    loadingPatient: function loadingPatient() {
      if (!this.getPatient) return false;
    },
    validate: function validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset: function reset() {
      this.$bus.$emit('getMedicalRecord', 'profile');
      this.$bus.$emit('closeModal', false);
      // this.$refs.form.reset()
    },
    resetValidation: function resetValidation() {
      this.$refs.form.resetValidation();
    },
    submit: function submit() {
      var _this = this;

      if (!this.getPatient.id) {
        this.snackbarConfig.snackbar = true;
        this.snackbarConfig.text = 'Selecione novamente o paciente!';
        return false;
      }
      if (this.$refs.form.validate()) {
        this.patientsChart.patient = this.getPatient.id;
        this.patientsChart.doctor = this.auth.auth.myClinic.crm;
        this.patientsChart.customer = this.customer;
        this.patientsChart.record = this.getPatient.id;
        this.setCreateRecord(this.patientsChart).then(function (result) {
          // this.$refs.form.reset()
          _this.patientsChart.description = null;
          _this.$bus.$emit('getMedicalRecord', 'profile');
          _this.$bus.$emit('closeModal', false);
          _this.$emit('close', true);
        }).catch(function (err) {
          if (err.response.data.message) {
            _this.snackbarConfig.snackbar = true;
            _this.snackbarConfig.text = err.response.data.message;
            return false;
          }
          if (err.response.data.errors) {
            if (err.response.data.errors.username) {
              _this.snackbarConfig.snackbar = true;
              _this.snackbarConfig.text = err.response.data.errors.username.msg;
              return false;
            }
            if (err.response.data.errors.password) {
              _this.snackbarConfig.snackbar = true;
              _this.snackbarConfig.text = err.response.data.errors.username.password.msg;
              return false;
            }
          }
          _this.snackbarConfig.snackbar = true;
          _this.snackbarConfig.text = err.response.data.result.error;
        });
      }
    }
  })
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_localforage__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_localforage__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getDevice']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['getRegisterUser', 'getSearchUser'])),
  data: function data() {
    return {
      newRegisters: [],
      items: [],
      valid: false,
      loadingOk: false,
      loadingButton: false,
      loader: null,
      e1: true,
      p1: true,
      custom: true,
      username: null,
      checkbox: false,
      item: {
        action: false
      }
    };
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('auth', ['setChangeSchedule']), {
    toggle: function toggle(index, item) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_localforage___default.a.setItem('my-clinic-crm', item.crm, function (err, data) {
        console.log(data, 'change agenda');
        if (err) window.console.error(err);
        _this.setChangeSchedule(item).then(function () {
          return _this.$bus.$emit('setDialogSelectCRM', false);
        });
      });
    }
  })
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getDevice']), {
    icon: function icon() {
      return this.icons[this.iconIndex];
    }
  }),
  data: function data() {
    return {
      registered: false,
      loadingOk: false,
      message: '',
      listVisible: false,
      iconIndex: 0,
      icons: ['mdi-emoticon', 'mdi-emoticon-cool', 'mdi-emoticon-dead', 'mdi-emoticon-excited', 'mdi-emoticon-happy', 'mdi-emoticon-neutral', 'mdi-emoticon-sad', 'mdi-emoticon-tongue'],
      env: null,
      date: new Date().toISOString().substr(0, 10),
      time: '11:10',
      menu: false,
      menu2: false,
      model: null,
      modal: false,
      modal2: false,
      name: '',
      email: '',
      select: null,
      items: ['Item 1', 'Item 2', 'Item 3', 'Item 4'],
      checkbox: null,
      dictionary: {
        attributes: {
          email: 'E-mail Address'
          // custom attributes
        },
        custom: {
          name: {
            required: function required() {
              return 'Name can not be empty';
            },
            max: 'The name field may not be greater than 10 characters'
            // custom messages
          },
          select: {
            required: 'Select field is required'
          }
        },
        dialog: false,
        notifications: false,
        sound: true,
        widgets: false
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('patient', ['setPatient']), {
    findOne: function findOne() {
      var _this = this;

      if (this.model === null || this.model === undefined) return;
      this.setPatient(this.model).then(function () {
        console.log(_this.model);
      });
    },
    selectPatient: function selectPatient(item) {
      this.model = item.id;
      this.findOne();
    },
    toggleMarker: function toggleMarker() {
      this.model = undefined;
      this.show(0);
      // this.marker = !this.marker
    },
    sendMessage: function sendMessage() {
      var _this2 = this;

      this.loadingOk = true;
      window.axios.get("https://api.spitzer.io" + '/my-clinic-new/patient/find', {
        params: {
          patient: this.message,
          customer: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.customer
        }
      }).then(function (response) {
        // handle success
        _this2.items = response.data.results.results.map(function (item) {
          return {
            id: item.tbCodigo,
            name: item.tbNome,
            symbol: item.tbNome.substr(0, 1),
            website_slug: 'spitzer.io',
            dateOfBirth: item.tbDtNasc
          };
        });
        _this2.listVisible = true;
        _this2.loadingOk = false;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        return _this2.isLoading = false;
      });
    },
    clearMessage: function clearMessage() {
      this.listVisible = false;
      this.message = '';
      this.navigation = 'list';
      this.show(0);
    },
    resetIcon: function resetIcon() {
      this.iconIndex = 0;
    },
    changeIcon: function changeIcon() {
      this.iconIndex === this.icons.length - 1 ? this.iconIndex = 0 : this.iconIndex++;
    },
    closedDialog: function closedDialog() {
      this.$bus.$emit('closeDialogSchedule', false);
    },
    submit: function submit() {
      this.$validator.validateAll();
    },
    clear: function clear() {
      this.name = '';
      this.email = '';
      this.select = null;
      this.checkbox = null;
      this.$validator.reset();
    }
  })
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getDevice']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['getRegisterUser', 'getSearchUser'])),
  data: function data() {
    return {
      newRegisters: [],
      items: [],
      valid: false,
      loadingOk: false,
      loadingButton: false,
      loader: null,
      e1: true,
      p1: true,
      custom: true,
      username: null,
      checkbox: false,
      item: {
        action: false
      }
    };
  },
  mounted: function mounted() {
    if (false) {
      this.username = 'andreza_82@hotmail.com';
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('auth', ['setChangeSchedule', 'setSearchEmailNew']), {
    searchEmail: function searchEmail() {
      var _this = this;

      this.$validator.validateAll();
      if (this.$refs.form.validate()) {
        this.loader = true;
        this.loadingOk = true;
        this.setSearchEmailNew(this.username).then(function () {
          _this.getSearchUser.map(function (item) {
            _this.newRegisters.push({
              crm: item.crm,
              customer: item.customerId,
              client: item.client,
              clientName: item.clientName,
              state: item.state || 'PR',
              code: item.client,
              name: item.clientName,
              codeCustomer: item.client,
              customerName: item.clientName
            });
          });
          console.log('this.newRegisters', _this.newRegisters);
          _this.loadingOk = false;
        }).catch(function (err) {
          console.error(err);
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    toggle: function toggle(index, item) {
      var _this2 = this;

      var payload = {
        code: item.code,
        codeCustomer: item.code,
        crm: item.crm,
        customer: item.customer,
        customerName: item.customerName,
        id: item._id,
        name: item.name,
        state: item.state
      };
      this.setChangeSchedule(payload).then(function () {
        return _this2.$router.push('/schedule');
      });
    }
  })
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_patient_profile__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_patient_record__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_patient_examinationReport__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_patient_attachments__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_surgery_center_list__ = __webpack_require__(371);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import store from '../../store'

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getDevice']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('patient', ['getPatient', 'getAttachment']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), {
    icon: function icon() {
      return this.icons[this.iconIndex];
    },
    changeLabel: function changeLabel() {
      var label = void 0;
      if (this.iconIndex !== 0) {
        label = 'Prontuário';
      } else {
        label = 'Nome/Dt Nasc/Celular/CPF';
      }
      return label;
    }
  }),
  components: {
    ProfilePatient: __WEBPACK_IMPORTED_MODULE_2__components_patient_profile__["a" /* default */],
    RecordPatient: __WEBPACK_IMPORTED_MODULE_3__components_patient_record__["a" /* default */],
    ImagePatient: __WEBPACK_IMPORTED_MODULE_5__components_patient_attachments__["a" /* default */],
    ExaminationReport: __WEBPACK_IMPORTED_MODULE_4__components_patient_examinationReport__["a" /* default */],
    SurgeryCenterList: __WEBPACK_IMPORTED_MODULE_6__components_surgery_center_list__["a" /* default */]
  },
  mounted: function mounted() {
    this.env = "production";
    this.focusInput();
  },

  data: function data() {
    return {
      attachPatient: false,
      message: '',
      listVisible: false,
      iconIndex: 0,
      icons: ['mdi-ab-testing', 'mdi-numeric'],
      env: null,
      navigation: 'profile',
      profile: false,
      profileData: {},
      record: false,
      examinationReport: false,
      image: false,
      proposedSurgeries: false,
      miniVariant: true,
      clipped: true,
      drawer: false,
      fixed: false,
      isLoading: false,
      items: [],
      model: null,
      search: null,
      active: null,
      loadingOk: false
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('medicalRecord', ['setListRecord', 'setAvailableAppointments']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('examinationReport', ['setListRecordExam']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('patient', ['setPatient', 'setAttachment']), {
    selectPatient: function selectPatient(item) {
      this.model = item.id;
      this.findOne();
    },
    focusInput: function focusInput() {
      this.$refs.name.focus();
    },
    toggleMarker: function toggleMarker() {
      this.model = undefined;
      this.show(0);
      // this.marker = !this.marker
    },
    sendMessage: function sendMessage() {
      var _this = this;

      console.log(this.message);
      this.loadingOk = true;
      window.axios.get("https://api.spitzer.io" + '/my-clinic-new/patient/find', {
        params: {
          patient: this.message,
          typeSearch: this.iconIndex,
          customer: this.auth.auth.myClinic.customer

        }
      }).then(function (response) {
        // handle success
        _this.items = response.data.results.results.map(function (item) {
          return {
            id: item.tbCodigo,
            name: item.tbNome,
            symbol: item.tbNome.substr(0, 1),
            website_slug: 'spitzer.io',
            dateOfBirth: item.tbDtNasc
          };
        });
        _this.listVisible = true;
        _this.loadingOk = false;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        return _this.isLoading = false;
      });
    },
    clearMessage: function clearMessage() {
      this.listVisible = false;
      this.message = '';
      this.navigation = 'list';
      this.show(0);
    },
    resetIcon: function resetIcon() {
      this.iconIndex = 0;
    },
    changeIcon: function changeIcon() {
      this.iconIndex === this.icons.length - 1 ? this.iconIndex = 0 : this.iconIndex++;
    },
    medicalRecordEvent: function medicalRecordEvent(e) {
      var _this2 = this;

      this.navigation = e;
      this.setPatient(this.model).then(function () {
        _this2.$bus.$emit('getMedicalRecord', 'profile');
      });
      this.setListRecord(this.model).then(function () {
        _this2.$bus.$emit('getMedicalRecord', _this2.navigation);
      });
      // this.setAttachment({ code: this.model, bucket: this.getPatient.bucket }).then(() => {
      //   this.$bus.$emit('getMedicalRecord', this.navigation)
      // })
    },
    next: function next() {
      var active = parseInt(this.active);
      this.active = active < 2 ? active + 1 : 0;
    },
    show: function show(type) {
      // if (this.model === undefined) return
      if (type === 0) {
        this.profile = false;
        this.record = false;
        this.image = false;
        this.examinationReport = false;
        this.model = undefined;
        this.medicalRecordEvent('examinationReport');
      } else if (type === 1) {
        this.profile = true;
        this.record = false;
        this.medicalRecordEvent('profile');
        this.image = false;
        this.examinationReport = false;
        this.medicalRecordEvent('examinationReport');
      } else if (type === 2) {
        this.profile = false;
        this.record = true;
        this.medicalRecordEvent('record');
        this.image = false;
        this.examinationReport = false;
        this.medicalRecordEvent('examinationReport');
      } else if (type === 3) {
        this.profile = false;
        this.record = false;
        this.image = false;
        this.examinationReport = true;
        this.proposedSurgeries = false;
        this.medicalRecordEvent('examinationReport');
      } else if (type === 4) {
        this.profile = false;
        this.record = false;
        this.examinationReport = false;
        this.image = true;
        this.proposedSurgeries = false;
        this.medicalRecordEvent('attachments');
      } else if (type === 5) {
        this.profile = false;
        this.record = false;
        this.examinationReport = false;
        this.image = false;
        this.proposedSurgeries = true;
        // this.medicalRecordEvent('proposed-surgeries')
      }
    },
    findOne: function findOne() {
      var _this3 = this;

      if (this.model === null || this.model === undefined) return;
      this.setPatient(this.model).then(function () {
        _this3.$bus.$emit('getMedicalRecord', 'profile');
        _this3.profile = true;
        _this3.setListRecord({ patient: _this3.model, customer: _this3.auth.auth.myClinic.customer }).then(function () {});
        _this3.setListRecordExam({ patient: _this3.model, customer: _this3.auth.auth.myClinic.customer }).then(function () {});
        _this3.setAttachment({ code: _this3.model, bucket: _this3.getPatient.bucket }).then(function () {});
        if (_this3.getPatient.bucket) {
          _this3.attachPatient = true;
        } else {
          _this3.attachPatient = false;
        }
      });
    }
  }),
  watch: {
    model: function model(val) {
      this.findOne();
    },
    navigation: function navigation(val) {},
    search: function search(val) {
      var _this4 = this;

      // Items have already been loaded
      // if (this.items.length > 0) return
      if (val === null || val === undefined) return;
      if (isNaN(val) === false) this.findOne(this.model);

      this.isLoading = true;
      console.log(this.auth.auth.myClinic.customer);
      // Lazily load input items
      window.axios.get("https://api.spitzer.io" + '/my-clinic-new/patient/find', {
        params: {
          patient: val,
          customer: this.auth.auth.myClinic.customer // store.state.customer
        }
      }).then(function (response) {
        // handle success
        _this4.items = response.data.results.results.map(function (item) {
          return {
            id: item.tbCodigo,
            name: item.tbNome,
            symbol: item.tbNome.substr(1, 0),
            website_slug: 'spitzer.io',
            dateOfBirth: item.tbDtNasc
          };
        });
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        return _this4.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('patient', ['getPatient']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getDevice'])),
  data: function data() {
    return {
      profile: true,
      miniVariant: true,
      clipped: true,
      drawer: false,
      fixed: false,
      isLoading: false,
      cards: [{ title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 12 }, { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6 }, { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }],
      item: {},
      model: null,
      search: null,
      active: null,
      text: 'Lorem ipsum dolor sit amet.'
    };
  },
  mounted: function mounted() {
    this.$bus.$on('getMedicalRecord', this.loadingRecord);
  },

  methods: {
    loadingRecord: function loadingRecord(selected) {
      if (selected === 'profile') {
        this.item = this.getPatient;
      }
    },
    next: function next() {
      var active = parseInt(this.active);
      this.active = active < 2 ? active + 1 : 0;
    },
    show: function show(type) {
      if (type === 0) {
        this.profile = false;
      } else if (type === 1) {
        this.profile = true;
        this.item = this.getPatient;
      } else if (type === 2) {
        this.profile = false;
      } else if (type === 3) {
        this.profile = false;
      }
    }
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__new__ = __webpack_require__(227);


var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('pt-br');
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NewRecord: __WEBPACK_IMPORTED_MODULE_3__new__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    cardSize: function cardSize() {
      if (!_this.getDevice.isMobile) {
        console.log('asasaa');
        return '400';
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('medicalRecord', ['getListRecord', 'getAvailableAppointments']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getDevice']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('patient', ['getPatient'])),
  data: function data() {
    return {
      cardSizeData: '',
      env: Object({"NODE_ENV":"production","URL":"https://api.spitzer.io","URL_MEMED":"https://api-memed.gestaoclinic.com.br"}),
      items: [],
      dateToday: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('DD'),
      dateMonthYear: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('MMMM YYYY'),
      dateWeek: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('dddd'),
      dialog: false
    };
  },
  mounted: function mounted() {
    this.$bus.$on('getMedicalRecord', this.loadingRecord);
    this.$bus.$on('closeModal', this.closeModal);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('medicalRecord', ['setListRecord', 'setAvailableAppointments']), {
    loadingRecord: function loadingRecord(selected) {
      if (!selected) return false;
      this.items = this.getListRecord;
    },
    closeModal: function closeModal() {
      var _this2 = this;

      this.dialog = false;
      this.setListRecord(this.getPatient.id).then(function () {
        _this2.items = _this2.getListRecord;
      });
    },
    submit: function submit(e) {
      // this.setList().then(() => {
      this.items = this.getListRecord;
      // })
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  })
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('pt-br');
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('examinationReport', ['getListRecord', 'getAvailableAppointments']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getDevice']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('patient', ['getPatient'])),
  data: function data() {
    return {
      env: Object({"NODE_ENV":"production","URL":"https://api.spitzer.io","URL_MEMED":"https://api-memed.gestaoclinic.com.br"}),
      items: [],
      dateToday: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('DD'),
      dateMonthYear: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('MMMM YYYY'),
      dateWeek: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('dddd'),
      dialog: false
    };
  },
  mounted: function mounted() {
    this.$bus.$on('getMedicalRecord', this.loadingRecord);
    this.$bus.$on('closeModal', this.closeModal);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('examinationReport', ['setListRecord', 'setAvailableAppointments']), {
    loadingRecord: function loadingRecord(selected) {
      if (selected === 'examinationReport') {
        this.items = this.getListRecord;
      }
    },
    closeModal: function closeModal() {
      var _this = this;

      this.dialog = false;
      this.setListRecord(this.getPatient.id).then(function () {
        _this.items = _this.getListRecord;
      });
    },
    submit: function submit(e) {
      // this.setList().then(() => {
      this.items = this.getListRecord;
      // })
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  })
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'



var avatars = ['?accessoriesType=Blank&avatarStyle=Circle&clotheColor=PastelGreen&clotheType=ShirtScoopNeck&eyeType=Wink&eyebrowType=UnibrowNatural&facialHairColor=Black&facialHairType=MoustacheMagnum&hairColor=Platinum&mouthType=Concerned&skinColor=Tanned&topType=Turban', '?accessoriesType=Sunglasses&avatarStyle=Circle&clotheColor=Gray02&clotheType=ShirtScoopNeck&eyeType=EyeRoll&eyebrowType=RaisedExcited&facialHairColor=Red&facialHairType=BeardMagestic&hairColor=Red&hatColor=White&mouthType=Twinkle&skinColor=DarkBrown&topType=LongHairBun', '?accessoriesType=Prescription02&avatarStyle=Circle&clotheColor=Black&clotheType=ShirtVNeck&eyeType=Surprised&eyebrowType=Angry&facialHairColor=Blonde&facialHairType=Blank&hairColor=Blonde&hatColor=PastelOrange&mouthType=Smile&skinColor=Black&topType=LongHairNotTooLong', '?accessoriesType=Round&avatarStyle=Circle&clotheColor=PastelOrange&clotheType=Overall&eyeType=Close&eyebrowType=AngryNatural&facialHairColor=Blonde&facialHairType=Blank&graphicType=Pizza&hairColor=Black&hatColor=PastelBlue&mouthType=Serious&skinColor=Light&topType=LongHairBigHair', '?accessoriesType=Kurt&avatarStyle=Circle&clotheColor=Gray01&clotheType=BlazerShirt&eyeType=Surprised&eyebrowType=Default&facialHairColor=Red&facialHairType=Blank&graphicType=Selena&hairColor=Red&hatColor=Blue02&mouthType=Twinkle&skinColor=Pale&topType=LongHairCurly'];

var pause = function pause(ms) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.env = "production";
    this.users = [];
    // this.$bus.$on('getMedicalRecord', this.fetchUsers())
  },

  data: function data() {
    return {
      env: null,
      files: {
        pdf: 'mdi-file-pdf',
        png: 'image',
        jpg: 'image',
        mpeg: 'image',
        doc: 'mdi-file-word',
        xls: 'mdi-file-excel'
      },
      active: [],
      avatar: null,
      open: [],
      users: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('patient', ['getPatient', 'getAttachment']), {
    items: function items() {
      return [{
        name: 'Anexos',
        children: this.users
      }];
    },
    selected: function selected() {
      if (!this.active.length) return undefined;

      var id = this.active[0];

      return this.users.find(function (user) {
        return user.id === id;
      });
    }
  }),

  watch: {
    selected: 'randomAvatar'
  },

  methods: {
    fetchUsers: function fetchUsers(selected) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var arrayItems, typeIcon, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (selected) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', false);

              case 2:
                console.log('chegou aqui11212', selected);
                arrayItems = void 0;
                typeIcon = void 0;

                _this.users = [];
                _context.next = 8;
                return pause(1500);

              case 8:
                _context.next = 10;
                return _this.getAttachment;

              case 10:
                response = _context.sent;
                // await axios.get(`https://sync.gestaoclinic.com.br/list?bucket=${this.getPatient.bucket}&MaxKeys=150&prefix=imagens/${this.getPatient.id}/`)
                console.log('chegou aqui', response.data.Contents);

                if (response.data.Contents) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt('return', false);

              case 14:
                _this.users = response.data.Contents.map(function (item) {
                  arrayItems = item.Key.split('_');
                  typeIcon = item.Key.split('.');
                  return {
                    path: item.Key,
                    name: __WEBPACK_IMPORTED_MODULE_4_moment___default()(arrayItems[1], 'DDMMYYYY').format('DD-MM-YYYY'),
                    id: item.ETag,
                    file: typeIcon[1],
                    icon: 'a'
                  };
                });

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    randomAvatar: function randomAvatar() {
      this.avatar = avatars[Math.floor(Math.random() * avatars.length)];
    }
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import CreateSchedule from '../../components/surgery-center/create'

/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.loading();
    this.$bus.$on('closeDialogScheduleProposed', this.closeDialogCreate);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({ customer: 'customer', auth: 'auth' }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('schedule', ['getProposedSurgeries']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getDevice'])),
  components: {
    // CreateSchedule
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('schedule', ['setProposedSurgeries']), {
    closeDialogCreate: function closeDialogCreate() {
      this.dialogCreated = false;
    },
    loading: function loading() {
      this.setProposedSurgeries({ date: new Date().toISOString().substr(0, 10), doctor: this.auth.auth.myClinic.crm, customer: this.auth.auth.user.customer });
    },
    toggle: function toggle(item) {
      console.log(item);
    },
    save: function save() {}
  }),
  data: function data() {
    return {
      selected: [2],
      proposedSurgeries: {},
      valid: false,
      dialogCreated: false,
      items: []
    };
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_highcharts__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      model: null,
      search: null
    };
  },
  computed: {
    fields: function fields() {
      var _this = this;

      if (!this.model) return [];

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.model).map(function (key) {
        return {
          key: key,
          value: _this.model[key] || 'n/a'
        };
      });
    },
    items: function items() {
      var _this2 = this;

      return this.entries.map(function (entry) {
        var Description = entry.tbNome.length > _this2.descriptionLimit ? entry.Description.slice(0, _this2.descriptionLimit) + '...' : entry.Description;
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, entry, { Description: Description }));
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, entry, { Description: Description });
      });
    }
  },
  watch: {
    search: function search(val) {
      var _this3 = this;

      // Items have already been loaded
      if (this.items.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = true;

      // Lazily load input items
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('http://localhost:8091/my-clinic-new/patient/find', {
        params: {
          patient: val,
          customer: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.customer
        }
      }).then(function (res) {
        var results = res.data.results.results;

        _this3.count = 10;
        _this3.entries = results;
      }).catch(function (err) {
        console.error(err);
      }).finally(function () {
        return _this3.isLoading = false;
      });
    }
  },
  methods: {
    teste: function teste() {
      __WEBPACK_IMPORTED_MODULE_2_highcharts___default.a.chart('container', {
        chart: {
          type: 'bar'
        },
        title: {
          text: 'Convênios'
        },
        subtitle: {
          text: 'Source: <a href="https://en.wikipedia.org/wiki/World_population">Clinic</a>'
        },
        xAxis: {
          categories: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio'],
          title: {
            text: null
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: '',
            align: 'high'
          },
          labels: {
            overflow: 'justify'
          }
        },
        tooltip: {
          valueSuffix: ' millions'
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          x: -40,
          y: 80,
          floating: true,
          borderWidth: 1,
          backgroundColor: __WEBPACK_IMPORTED_MODULE_2_highcharts___default.a.theme && __WEBPACK_IMPORTED_MODULE_2_highcharts___default.a.theme.legendBackgroundColor || '#FFFFFF',
          shadow: true
        },
        credits: {
          enabled: false
        },
        series: [{
          name: 'Unimed',
          data: [107, 31, 635, 203, 2]
        }, {
          name: 'Particular',
          data: [133, 156, 947, 408, 6]
        }, {
          name: 'Amil',
          data: [814, 841, 3714, 727, 31]
        }, {
          name: 'Clinipam',
          data: [1216, 1001, 4436, 738, 40]
        }]
      });
    }
  },
  mounted: function mounted() {
    this.teste();
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      cards: [{ title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 12 }, { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6 }, { title: 'Best airlines1', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }, { title: 'Best airlines2', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }, { title: 'Best airlines3', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }, { title: 'Best airlines4', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }, { title: 'Best airlines5', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }]
    };
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('auth', ['getUser'])),
  components: {},
  data: function data() {
    return {
      profile: {}
    };
  },
  methods: {
    loadingProfile: function loadingProfile() {
      var _this = this;

      var config = {
        params: {
          crm: this.auth.auth.myClinic.crm,
          customer: this.customer
        }
      };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.spitzer.io" + '/my-clinic-new/schedule-sync/doctors/profile', config).then(function (result) {
        _this.profile = result.data.result;
      });
    }
  },
  mounted: function mounted() {
    this.loadingProfile();
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_schedule_week_vue__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_schedule_completed__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ChartJs_LineChart__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components






// Depedencies
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CalendarWeek: __WEBPACK_IMPORTED_MODULE_1__components_schedule_week_vue__["a" /* default */],
    CalendarCompleted: __WEBPACK_IMPORTED_MODULE_2__components_schedule_completed__["a" /* default */],
    LineChart: __WEBPACK_IMPORTED_MODULE_3__components_ChartJs_LineChart__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('proced', ['getList', 'getAvailableAppointments'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('proced', ['setList', 'setAvailableAppointments'])),
  mounted: function mounted() {
    var _this = this;

    this.setList().then(function () {
      _this.items = _this.getList;
    });
    this.setAvailableAppointments().then(function () {
      _this.getAvailableAppointments.map(function (item) {
        _this.month.push(item.month);
      });
    });
    this.today = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('DD-MM-YYYY');
  },
  data: function data() {
    return {
      title: 'Dashboard',
      icon: 'dashboard',
      today: null,
      period: {
        start: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add('months', -2).date(0).format('DD-MM-YYYY'),
        end: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add('months', 2).date(0).format('DD-MM-YYYY')
      },
      month: [],
      headers: [{ text: 'Convênio', value: 'calories', align: 'left' }, { text: 'Qtde.', value: 'protein', align: 'center' }, { text: 'Valor', value: 'protein', align: 'center'
        // { text: 'CRM', value: 'iron', align: 'center' },
        // { text: 'Nome', value: 'iron', align: 'left' }
      }],
      items: [],
      visitorsPageViews: {
        data: {
          labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
          datasets: [{
            label: 'Procedimentos',
            fill: false,
            data: [150, 2450, 1599, 1100, 1450, 2550, 1540, 2370, 1334, 1284, 1200, 1890],
            borderColor: this.$vuetify.theme.primary,
            pointBorderColor: this.$vuetify.theme.primary,
            pointBackgroundColor: this.$vuetify.theme.primary,
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowBlur: 10,
            shadowColor: 'rgba(98, 0, 234, 0.5)',
            pointRadius: 4,
            pointBevelWidth: 3,
            pointBevelHighlightColor: 'rgba(255, 255, 255, 0.75)',
            pointBevelShadowColor: 'rgba(98, 0, 234, 0.5)',
            pointHoverRadius: 6,
            pointHoverBevelWidth: 4.5,
            pointHoverInnerGlowWidth: 20,
            pointHoverInnerGlowColor: 'rgba(98, 0, 234, 0.5)',
            pointHoverOuterGlowWidth: 20,
            pointHoverOuterGlowColor: this.$vuetify.theme.secondary,
            tension: 0.15
          }, {
            label: 'Exames',
            fill: false,
            data: [410, 380, 800, 789, 450, 550, 187, 470, 234, 984, 1024, 890].map(function (i) {
              return i * 3;
            }),
            borderColor: this.$vuetify.theme.secondary,
            pointBorderColor: this.$vuetify.theme.secondary,
            pointBackgroundColor: this.$vuetify.theme.secondary,
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowBlur: 10,
            shadowColor: 'rgba(233, 30, 99, 0.5)',
            pointRadius: 4,
            pointBevelWidth: 3,
            pointBevelHighlightColor: 'rgba(255, 255, 255, 0.75)',
            pointBevelShadowColor: 'rgba(233, 30, 99, 0.5)',
            pointHoverRadius: 6,
            pointHoverBevelWidth: 4.5,
            pointHoverInnerGlowWidth: 20,
            pointHoverInnerGlowColor: 'rgba(233, 30, 99, 0.5)',
            pointHoverOuterGlowWidth: 20,
            pointHoverOuterGlowColor: this.$vuetify.theme.primary,
            tension: 0.15
          }]
        }
      }
    };
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      today: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD'),
      events: []
      // events: [
      //   {
      //     title: 'João da Silva',
      //     date: moment().format('YYYY-MM-DD'),
      //     time: '09:00',
      //     duration: 45
      //   },
      //   {
      //     title: 'Reunião',
      //     date: moment().add(3, 'day').format('YYYY-MM-DD')
      //   },
      //   {
      //     title: 'Alexandre Campagnaro',
      //     date: moment().add(1, 'day').format('YYYY-MM-DD'),
      //     time: '12:30',
      //     duration: 180
      //   }
      // ]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    // convert the list of events into a map of lists keyed by date
    eventsMap: function eventsMap() {
      var map = {};
      this.events.forEach(function (e) {
        return (map[e.date] = map[e.date] || []).push(e);
      });
      return map;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    customer: 'customer',
    auth: 'auth'
  }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('schedule', ['getList', 'getAvailableAppointments', 'getAppointments']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getDevice'])),
  mounted: function mounted() {
    var _this = this;

    // this.$refs.calendar.locale = 'pt-br'
    this.$refs.calendar.scrollToTime(__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('LT'));
    this.setList({ date: __WEBPACK_IMPORTED_MODULE_1_moment___default()('2019-02-07').format('YYYY-MM-DD'), doctor: this.auth.auth.myClinic.crm }).then(function () {
      _this.getList.map(function (item) {
        _this.events.push({
          title: item.title + ' ' + item.subtitle,
          date: __WEBPACK_IMPORTED_MODULE_1_moment___default()('07/03/2019', 'DD/MM/YYYY').format('YYYY-MM-DD'),
          time: item.subtitle,
          duration: 40 // item.interval
        });
      });
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('schedule', ['setList', 'setAvailableAppointments', 'setLockAppointments', 'setUnlockAppointments']), {
    open: function open(event) {
      alert(event.title);
    }
  })
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var weekdaysDefault = [0, 1, 2, 3, 4, 5, 6];

var intervalsDefault = {
  first: 0,
  minutes: 60,
  count: 24,
  height: 40
};

var stylings = {
  default: function _default(interval) {
    return undefined;
  },
  workday: function workday(interval) {
    var inactive = interval.weekday === 0 || interval.weekday === 6 || interval.hour < 9 || interval.hour >= 17;
    var startOfHour = interval.minute === 0;
    var dark = this.dark;
    var mid = dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)';

    return {
      backgroundColor: inactive ? dark ? 'rgba(0,0,0,0.4)' : 'rgba(0,0,0,0.05)' : undefined,
      borderTop: startOfHour ? undefined : '1px dashed ' + mid
    };
  },
  past: function past(interval) {
    return {
      backgroundColor: interval.past ? this.dark ? 'rgba(0,0,0,0.4)' : 'rgba(0,0,0,0.05)' : undefined
    };
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      day: null,
      dark: false,
      startMenu: false,
      start: '2019-01-12',
      endMenu: false,
      end: '2019-01-27',
      nowMenu: false,
      minWeeks: 1,
      now: null,
      type: 'month',
      typeOptions: [{ text: 'Day', value: 'day' }, { text: '4 Day', value: '4day' }, { text: 'Week', value: 'week' }, { text: 'Month', value: 'month' }, { text: 'Custom Daily', value: 'custom-daily' }, { text: 'Custom Weekly', value: 'custom-weekly' }],
      weekdays: weekdaysDefault,
      weekdaysOptions: [{ text: 'Sunday - Saturday', value: weekdaysDefault }, { text: 'Mon, Wed, Fri', value: [1, 3, 5] }, { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] }, { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] }],
      intervals: intervalsDefault,
      intervalsOptions: [{ text: 'Default', value: intervalsDefault }, { text: 'Workday', value: { first: 16, minutes: 30, count: 20, height: 40 } }],
      maxDays: 7,
      maxDaysOptions: [{ text: '7 days', value: 7 }, { text: '5 days', value: 5 }, { text: '4 days', value: 4 }, { text: '3 days', value: 3 }],
      styleInterval: 'default',
      styleIntervalOptions: [{ text: 'Default', value: 'default' }, { text: 'Workday', value: 'workday' }, { text: 'Past', value: 'past' }],
      color: 'primary',
      colorOptions: [{ text: 'Primary', value: 'primary' }, { text: 'Secondary', value: 'secondary' }, { text: 'Accent', value: 'accent' }, { text: 'Red', value: 'red' }, { text: 'Pink', value: 'pink' }, { text: 'Purple', value: 'purple' }, { text: 'Deep Purple', value: 'deep-purple' }, { text: 'Indigo', value: 'indigo' }, { text: 'Blue', value: 'blue' }, { text: 'Light Blue', value: 'light-blue' }, { text: 'Cyan', value: 'cyan' }, { text: 'Teal', value: 'teal' }, { text: 'Green', value: 'green' }, { text: 'Light Green', value: 'light-green' }, { text: 'Lime', value: 'lime' }, { text: 'Yellow', value: 'yellow' }, { text: 'Amber', value: 'amber' }, { text: 'Orange', value: 'orange' }, { text: 'Deep Orange', value: 'deep-orange' }, { text: 'Brown', value: 'brown' }, { text: 'Blue Gray', value: 'blue-gray' }, { text: 'Gray', value: 'gray' }, { text: 'Black', value: 'black' }]
    };
  },
  computed: {
    intervalStyle: function intervalStyle() {
      return stylings[this.styleInterval].bind(this);
    },
    hasIntervals: function hasIntervals() {
      return this.type in {
        'week': 1, 'day': 1, '4day': 1, 'custom-daily': 1
      };
    },
    hasEnd: function hasEnd() {
      return this.type in {
        'custom-weekly': 1, 'custom-daily': 1
      };
    }
  },
  methods: {
    showIntervalLabel: function showIntervalLabel(interval) {
      return interval.minute === 0;
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_style__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_chartjs__ = __webpack_require__(407);






/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_3_vue_chartjs__["a" /* Line */],
  props: {
    data: Object,
    options: Object,
    gradient: {
      type: Boolean,
      default: false
    },
    gradientSet: {
      type: Array
    },
    linearStroke: {
      type: Array,
      default: function _default() {
        return [500, 0, 100, 0];
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.rerender);
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.rerender);
    if (this.gradient) {
      var linearStroke = this.linearStroke;
      var gradientStroke = this.$refs.canvas.getContext('2d').createLinearGradient(linearStroke[0], linearStroke[1], linearStroke[2], linearStroke[3]);
      if (this.gradientSet.length) {
        this.gradientSet.forEach(function (hex, index) {
          if ((typeof hex === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(hex)) === 'object' && Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["has"])(hex, 'stop') && Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["has"])(hex, 'color')) {
            var stop = hex.stop,
                color = hex.color;

            gradientStroke.addColorStop(stop, color);
          } else {
            var _stop = index > 0 ? 1 / index : 0;
            _stop = Number(_stop.toFixed(1));
            gradientStroke.addColorStop(_stop, hex);
          }
        });
        this.data.datasets.map(function (obj, index) {
          if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["has"])(obj, 'backgroundColor') === false) {
            obj.backgroundColor = gradientStroke;
          }
        });
      }
    }
    this.renderChart(this.data, this.options);
  },

  methods: {
    rerender: function rerender() {
      this.renderChart(this.data, this.options);
    }
  }
});

/***/ }),
/* 245 */,
/* 246 */,
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    submit: function submit() {
      var _this = this;

      if (this.$refs.form.validate()) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("https://api.spitzer.io" + '/my-clinic-new/auth/profile-reset-password', {
          id: this.authentication.id,
          username: this.authentication.username,
          password: this.authentication.password
        }, {
          params: {
            customer: this.customer
          }
        }).then(function (response) {
          _this.snackbarConfig.snackbar = true;
          _this.snackbarConfig.text = 'Senha Alterada com sucesso!';
        }).catch(function (err) {
          if (err.response.data.message) {
            _this.snackbarConfig.snackbar = true;
            _this.snackbarConfig.text = err.response.data.message;
            return false;
          }
          if (err.response.data.errors) {
            if (err.response.data.errors.username) {
              _this.snackbarConfig.snackbar = true;
              _this.snackbarConfig.text = err.response.data.errors.username.msg;
              return false;
            }
          }
          _this.snackbarConfig.snackbar = true;
          _this.snackbarConfig.text = err.response.data.result.error;
        });
      }
    }
  },
  mounted: function mounted() {
    this.authentication.id = this.getUser.user.id;
    this.authentication.username = this.getUser.user.username;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    customer: 'customer'
  }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getPkg']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('auth', ['getUser']), {
    progress: function progress() {
      return Math.min(100, this.authentication.password.length * 10);
    },
    color: function color() {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)];
    }
  }),
  data: function data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      env: "https://api.spitzer.io",
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      valid: true,
      e1: true,
      p1: true,
      custom: true,
      authentication: {
        id: '',
        username: '',
        password: '',
        confpass: ''
      }
    };
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.snackbarConfig.snackbar = true;
    this.snackbarConfig.text = 'Como seu E-Mail não foi encontrado, faça o cadastro manual!';
    // this.setCustomers().then((items) => {
    //   this.items = this.getCustomers
    // })
    this.items = [];
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['getCustomers']), {
    progress: function progress() {
      return Math.min(100, this.auth.password.length * 10);
    },
    color: function color() {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)];
    }
  }),
  data: function data() {
    return {
      valid: true,
      showPass: false,
      password: 'Password',
      rules: {
        required: function required(value) {
          return !!value || 'Campo obrigatório!';
        },
        min: function min(v) {
          return v.length >= 6 || 'Campo tem que ter no mínimo 6 caracteres!';
        }
      },
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      auth: {
        username: null,
        password: '',
        confpass: null,
        name: null,
        customerId: null,
        crm: null,
        myClinic: []
      },
      crmRules: [function (v) {
        return !!v || 'CRM obrigatório';
      }, function (v) {
        return (/^\d+$/.test(v) || 'Somente números!'
        );
      }, function (v) {
        return v && v.length <= 8 || 'maximo de 8 caracteres';
      }],
      nameRules: [function (v) {
        return !!v || 'Nome é obrigatório';
      }, function (v) {
        return v && v.length <= 40 || 'O nome deve conter menos de 40 caracteres';
      }],
      emailRules: [function (v) {
        return !!v || 'E-mail é obrigatório';
      }, function (v) {
        return (/.+@.+\..+/.test(v) || 'E-mail não é valido!'
        );
      }],
      items: [],
      checkbox: false,
      lazy: false
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('auth', ['setCreateUser', 'setCustomers']), {
    submit: function submit() {
      var _this = this;

      if (this.$refs.form.validate()) {
        this.getCustomers.map(function (item) {
          if (_this.auth.customerId._id === item._id) {
            _this.auth.myClinic.push({
              crm: _this.auth.crm,
              customer: _this.auth.customerId,
              client: _this.getCustomers.code,
              clientName: _this.getCustomers.name,
              state: _this.getCustomers.name || 'PR',
              code: _this.getCustomers.code,
              name: _this.getCustomers.name,
              codeCustomer: _this.getCustomers.code,
              customerName: _this.getCustomers.name
            });
            _this.setCreateUser(_this.auth).then().catch(function (err) {
              console.log('err', err.response);
              _this.snackbarConfig.snackbar = true;
              _this.snackbarConfig.text = err.response.data.result.error;
            });
          }
        });
      }
    },
    reset: function reset() {
      this.$refs.form.reset();
    },
    resetValidation: function resetValidation() {
      this.$refs.form.resetValidation();
    }
  })
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Register',
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    progress: function progress() {
      return Math.min(100, this.auth.password.length * 10);
    },
    color: function color() {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)];
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    customer: 'customer'
  }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['getRegisterUser', 'getSearchUser']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('app', ['getTheme'])),
  data: function data() {
    return {
      showPass: false,
      password: 'Password',
      rules: {
        required: function required(value) {
          return !!value || 'Campo obrigatório!';
        },
        min: function min(v) {
          return v.length >= 6 || 'Campo tem que ter no mínimo 6 caracteres!';
        }
      },
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      valid: false,
      value: '',
      loading: false,
      auth: {
        username: null,
        password: '',
        confpass: null,
        name: null,
        myClinic: []
      },
      checkbox: false,
      items: [],
      custom: true
    };
  },
  mounted: function mounted() {
    if (!this.getSearchUser.length) {
      this.$router.push('/auth/login');
    }
    this.searchSchedule();
    // const arrayProfessional = []
    // this.getSearchUser.map((element) => {
    //   element.map((item) => {
    //     arrayProfessional.push(item)
    //   })
    // })
    // this.items = test.map((item) => { // this.getSearchUser.map((item) => {
    //   item.action = true
    //   this.auth.name = item.name
    //   this.auth.username = item.username
    //   this.auth.myClinic.push({
    //     crm: item.crm,
    //     customer: item.customerId,
    //     client: item.client,
    //     clientName: item.clientName,
    //     state: item.state || 'PR',
    //     code: item.client,
    //     name: item.clientName,
    //     codeCustomer: item.client,
    //     customerName: item.clientName
    //   })
    //   return item
    // })
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setSearchEmail']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('auth', ['setCreateUser']), {
    toggle: function toggle() {},
    clear: function clear() {
      this.$refs.form.reset();
    },
    searchSchedule: function searchSchedule() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var arrayProfessional;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                arrayProfessional = [];
                _context.next = 3;
                return _this.getSearchUser.map(function (element) {
                  element.map(function (resultElement) {
                    arrayProfessional.push(resultElement);
                  });
                });

              case 3:
                _context.next = 5;
                return arrayProfessional.map(function (item) {
                  // this.getSearchUser.map((item) => {
                  item.action = true;
                  _this.auth.name = item.name;
                  _this.auth.username = item.username;
                  _this.auth.myClinic.push({
                    crm: item.crm,
                    customer: item.customerId,
                    client: item.client,
                    clientName: item.clientName,
                    state: item.state || 'PR',
                    code: item.client,
                    name: item.clientName,
                    codeCustomer: item.client,
                    customerName: item.clientName
                  });
                  return item;
                });

              case 5:
                _this.items = _context.sent;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    submit: function submit() {
      var _this2 = this;

      this.$validator.validateAll();
      if (this.auth.password !== this.auth.confpass) {
        this.snackbarConfig.snackbar = true;
        this.snackbarConfig.text = 'As senhas são divergentes!';
        return false;
      }
      this.setCreateUser(this.auth).then(function (response) {
        console.log(response);
      }).catch(function (err) {
        _this2.snackbarConfig.snackbar = true;
        _this2.snackbarConfig.text = err.response.data.result.error;
      });
      // this.$http({
      //   method: 'post',
      //   url: 'https://api.spitzer.io/my-clinic-new/auth/create',
      //   data: this.auth
      // }).then(() => {
      // }).catch((error) => {
      //   console.error(error)
      //   if (error.response.data.message === 'error') {
      //     this.snackbarConfig.snackbar = true
      //     this.snackbarConfig.text = error.response.data.result.error
      //     return false
      //   }
      // })
    }
  })
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UpdateSchedule',
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    progress: function progress() {
      return Math.min(100, this.auth.password.length * 10);
    },
    color: function color() {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)];
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    customer: 'customer'
  }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['getUser', 'getSearchUser']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('app', ['getTheme'])),
  data: function data() {
    return {
      showPass: false,
      password: 'Password',
      rules: {
        required: function required(value) {
          return !!value || 'Campo obrigatório!';
        },
        min: function min(v) {
          return v.length >= 6 || 'Campo tem que ter no mínimo 6 caracteres!';
        }
      },
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      valid: false,
      value: '',
      loading: false,
      auth: {
        myClinic: []
      },
      checkbox: false,
      items: [],
      custom: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.searchEmail();

            case 2:
              _this.searchSchedule();
              _this.loading = false;
              // const arrayProfessional = []
              // this.getSearchUser.map((element) => {
              //   element.map((item) => {
              //     arrayProfessional.push(item)
              //   })
              // })
              // this.items = test.map((item) => { // this.getSearchUser.map((item) => {
              //   item.action = true
              //   this.auth.name = item.name
              //   this.auth.username = item.username
              //   this.auth.myClinic.push({
              //     crm: item.crm,
              //     customer: item.customerId,
              //     client: item.client,
              //     clientName: item.clientName,
              //     state: item.state || 'PR',
              //     code: item.client,
              //     name: item.clientName,
              //     codeCustomer: item.client,
              //     customerName: item.clientName
              //   })
              //   return item
              // })

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setSearchEmail']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('auth', ['setUpdateSchedule', 'setSearchEmailNew']), {
    toggle: function toggle() {},
    clear: function clear() {
      this.$refs.form.reset();
    },
    searchSchedule: function searchSchedule() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var arrayProfessional;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                arrayProfessional = [];
                _context2.next = 3;
                return _this2.getSearchUser.map(function (element) {
                  element.map(function (resultElement) {
                    arrayProfessional.push(resultElement);
                  });
                });

              case 3:
                _context2.next = 5;
                return arrayProfessional.map(function (item) {
                  // this.getSearchUser.map((item) => {
                  item.action = true;
                  _this2.auth.name = item.name;
                  _this2.auth.username = item.username;
                  _this2.auth.myClinic.push({
                    crm: item.crm,
                    customer: item.customerId,
                    client: item.client,
                    clientName: item.clientName,
                    state: item.state || 'PR',
                    code: item.client,
                    name: item.clientName,
                    codeCustomer: item.client,
                    customerName: item.clientName
                  });
                  return item;
                });

              case 5:
                _this2.items = _context2.sent;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    searchEmail: function searchEmail() {
      var _this3 = this;

      this.loading = true;
      return this.setSearchEmailNew(this.getUser.username).catch(function (err) {
        console.error(err);
        _this3.snackbarConfig.snackbar = true;
        _this3.snackbarConfig.text = err.response.data.result.error;
      });
    },
    submit: function submit() {
      var _this4 = this;

      this.$validator.validateAll();
      this.setUpdateSchedule(this.auth).catch(function (err) {
        _this4.snackbarConfig.snackbar = true;
        _this4.snackbarConfig.text = err.response.data.result.error;
      });
      // this.$http({
      //   method: 'post',
      //   url: 'https://api.spitzer.io/my-clinic-new/auth/create',
      //   data: this.auth
      // }).then(() => {
      // }).catch((error) => {
      //   console.error(error)
      //   if (error.response.data.message === 'error') {
      //     this.snackbarConfig.snackbar = true
      //     this.snackbarConfig.text = error.response.data.result.error
      //     return false
      //   }
      // })
    }
  })
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Register',
  watch: {
    loader: function loader() {
      var l = this.loader;
      this[l] = !this[l];
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    customer: 'customer'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('app', ['getTheme']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['getSearchUser'])),
  data: function data() {
    return {
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      buttonEnabled: true,
      selected: [],
      sectors: [],
      items: [],
      valid: false,
      loadingOk: false,
      loadingButton: false,
      loader: null,
      e1: true,
      p1: true,
      custom: true,
      auth: {
        username: null
      },
      checkbox: false
    };
  },
  mounted: function mounted() {
    if (false) {
      this.auth.username = 'andreza_82@hotmail.com';
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('auth', ['setSearchEmail', 'setRegister', 'setSearchEmailNew']), {
    register: function register(items) {
      var _this = this;

      this.loadingOk = true;
      this.setRegister(items).then(function () {
        _this.$router.push('/auth/register');
        _this.loadingOk = false;
      });
    },
    searchEmail: function searchEmail() {
      var _this2 = this;

      this.$validator.validateAll();
      if (this.$refs.form.validate()) {
        this.loader = true;
        this.loadingOk = true;
        this.buttonEnabled = false;
        // this.setSearchEmail(this.auth.username).then((item) => {
        this.setSearchEmailNew(this.auth.username).then(function (item) {
          if (item) {
            _this2.$router.push('/auth/register');
          } else {
            _this2.loadingOk = false;
            _this2.buttonEnabled = true;
            _this2.snackbarConfig.snackbar = true;
            _this2.snackbarConfig.text = 'Nenhum registro foi encontrado, deseja fazer manualamente?';
          }
        }).catch(function (err) {
          console.error(err);
          _this2.buttonEnabled = true;
          _this2.loadingOk = false;
          _this2.snackbarConfig.snackbar = true;
          _this2.snackbarConfig.text = err.response.data.result.error;
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  })
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import localforage from 'localforage'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Reset-password',
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    customer: 'customer',
    tokenRecoveryPassword: 'tokenRecoveryPassword'
  }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getPkg']), {
    progress: function progress() {
      return Math.min(100, this.authentication.password.length * 10);
    },
    color: function color() {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)];
    }
  }),
  mounted: function mounted() {
    this.jwtDecoded();
  },

  data: function data() {
    return {
      env: "https://api.spitzer.io",
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      valid: true,
      e1: true,
      p1: true,
      custom: true,
      authentication: {
        id: '',
        username: '',
        password: '',
        confpass: ''
      }
    };
  },
  methods: {
    jwtDecoded: function jwtDecoded() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var body, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                body = {
                  id: _this.authentication.id
                };
                params = {
                  params: {
                    jwt: _this.tokenRecoveryPassword,
                    customer: _this.customer
                  }
                };
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://api.spitzer.io" + '/my-clinic-new/auth/get-recovery-token', body, params).then(function (response) {
                  _this.authentication.username = response.data.decoded.username;
                  _this.authentication.id = response.data.decoded.id;
                }).catch(function (err) {
                  window.console.error(err);
                  _this.snackbarConfig.snackbar = true;
                  _this.snackbarConfig.text = 'Token expirado!';
                  return false;
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    changeCssColor: function changeCssColor() {},
    changeLogo: function changeLogo() {},
    changeColorHTML: function changeColorHTML() {},
    submit: function submit() {
      var _this2 = this;

      if (this.authentication.password !== this.authentication.confpass) {
        this.snackbarConfig.snackbar = true;
        this.snackbarConfig.text = 'As senhas são divergentes!';
        return false;
      }

      if (this.$refs.form.validate()) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://api.spitzer.io" + '/my-clinic-new/auth/reset-password', {
          id: this.authentication.id,
          username: this.authentication.username,
          password: this.authentication.password
        }, {
          params: {
            customer: 'fsdafsad123123sd1f854fdf54d',
            token: this.tokenRecoveryPassword
          }
        }).then(function (response) {
          _this2.$router.push('/patient/login');
        }).catch(function (err) {
          if (err.response.data.message) {
            _this2.snackbarConfig.snackbar = true;
            _this2.snackbarConfig.text = err.response.data.message;
            return false;
          }
          if (err.response.data.errors) {
            if (err.response.data.errors.username) {
              _this2.snackbarConfig.snackbar = true;
              _this2.snackbarConfig.text = err.response.data.errors.username.msg;
              return false;
            }
            if (err.response.data.errors.password) {
              _this2.snackbarConfig.snackbar = true;
              _this2.snackbarConfig.text = err.response.data.errors.username.password.msg;
              return false;
            }
          }
          _this2.snackbarConfig.snackbar = true;
          _this2.snackbarConfig.text = err.response.data.result.error;
        });
      }
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import localforage from 'localforage'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Reset-password',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    customer: 'customer'
  }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getPkg']), {
    progress: function progress() {
      return Math.min(100, this.auth.password.length * 10);
    },
    color: function color() {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)];
    }
  }),
  mounted: function mounted() {},

  data: function data() {
    return {
      env: "https://api.spitzer.io",
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      valid: true,
      e1: true,
      p1: true,
      custom: true,
      auth: {
        username: ''
      }
    };
  },
  methods: {
    changeCssColor: function changeCssColor() {},
    changeLogo: function changeLogo() {},
    changeColorHTML: function changeColorHTML() {},
    submit: function submit() {
      var _this = this;

      if (this.$refs.form.validate()) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.spitzer.io" + '/my-clinic-new/auth/forget-password', {
          username: this.auth.username
        }).then(function (response) {
          _this.$router.push('/');
        }).catch(function (err) {
          if (err.response.data.message) {
            _this.snackbarConfig.snackbar = true;
            _this.snackbarConfig.text = err.response.data.message;
            return false;
          }
          if (err.response.data.errors) {
            if (err.response.data.errors.username) {
              _this.snackbarConfig.snackbar = true;
              _this.snackbarConfig.text = err.response.data.errors.username.msg;
              return false;
            }
          }
          _this.snackbarConfig.snackbar = true;
          _this.snackbarConfig.text = err.response.data.result.error;
        });
      }
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_surgery_center_create_vue__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.loading();
    this.$bus.$on('closeDialogScheduleProposed', this.closeDialogCreate);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({ customer: 'customer', auth: 'auth' }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('schedule', ['getProposedSurgeries']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getDevice'])),
  components: {
    CreateSchedule: __WEBPACK_IMPORTED_MODULE_1__components_surgery_center_create_vue__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('schedule', ['setProposedSurgeries']), {
    closeDialogCreate: function closeDialogCreate() {
      this.dialogCreated = false;
    },
    loading: function loading() {
      this.setProposedSurgeries({ date: new Date().toISOString().substr(0, 10), doctor: this.auth.auth.myClinic.crm, customer: this.auth.auth.user.customer });
    },
    toggle: function toggle(item) {
      console.log(item);
    },
    save: function save() {}
  }),
  data: function data() {
    return {
      selected: [2],
      proposedSurgeries: {},
      valid: false,
      dialogCreated: false,
      items: []
    };
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  watch: {
    date: function date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
    model: function model(val) {
      this.findOne();
    },
    navigation: function navigation(val) {},
    search: function search(val) {
      var _this = this;

      // Items have already been loaded
      // if (this.items.length > 0) return
      if (val === null || val === undefined) return;
      if (isNaN(val) === false) this.findOne(this.model);

      this.isLoading = true;

      // Lazily load input items
      window.axios.get("https://api.spitzer.io" + '/my-clinic-new/patient/find', {
        params: {
          patient: val,
          customer: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.customer
        }
      }).then(function (response) {
        // handle success
        _this.items3 = response.data.results.results.map(function (item) {
          return {
            id: item.tbCodigo,
            name: item.tbNome,
            symbol: 'BTC',
            website_slug: 'spitzer.io',
            dateOfBirth: item.tbDtNasc
          };
        });
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        return _this.isLoading = false;
      });
    }
  },
  mounted: function mounted() {
    // this.proposedSurgeries.date = moment().format('DD-MM-YYYY')
    this.proposedSurgeries.date = new Date().toISOString().substr(0, 10);
    this.proposedSurgeries.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('LT');
    this.itemsSurgeries = this.getSurgeries;
    this.itemsAnesthesia = this.getAnesthesia;
    this.loadHealthInsurance();
    this.focusInput();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({ customer: 'customer', auth: 'auth' }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('schedule', ['getSurgeries', 'getAnesthesia']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('app', ['getTheme', 'getDevice']), {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.date);
    },
    icon: function icon() {
      return this.icons[this.iconIndex];
    }
  }),
  data: function data(vm) {
    return {
      bodyData: false,
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      alertTextRequired: '',
      alertVisible: false,
      registered: false,
      loadingOk: false,
      message: '',
      listVisible: false,
      iconIndex: 0,
      icons: ['mdi-emoticon', 'mdi-emoticon-cool', 'mdi-emoticon-dead', 'mdi-emoticon-excited', 'mdi-emoticon-happy', 'mdi-emoticon-neutral', 'mdi-emoticon-sad', 'mdi-emoticon-tongue'],
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      isLoading: false,
      model: null,
      search: null,
      active: null,
      snackbar: false,
      color: 'red',
      mode: '',
      timeout: 6000,
      text: 'Erro de servidor',
      menu: false,
      modal: false,
      modal2: false,
      healthInsurances: [],
      proposedSurgeries: {
        date: new Date().toISOString().substr(0, 10),
        record: null,
        clinicalIndication: '',
        obs: '',
        anesthesia: null,
        video: false,
        debridador: false,
        instructorValue: null,
        medicalFee: null,
        assistantValue: null,
        hemocomponentes: false,
        OPME: false,
        pathologicalAnatomy: false,
        CID: '',
        surgery: [],
        patient: null,
        fornecedor: '',
        lateralidade: '',
        OPMETexto: '',
        microscopio: '',
        gender: 'M'
      },
      valid: false,
      items: [],
      itemsSurgeries: [],
      itemsAnesthesia: [],
      items2: [],
      items3: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('schedule', ['setCreateProposedSurgeries']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('patient', ['setPatient']), {
    validationsetTime: function validationsetTime() {
      var _this2 = this;

      this.alertVisible = true;
      setTimeout(function () {
        if (_this2.alertVisible === true) {
          _this2.alertVisible = false;
        }
      }, 3000);
    },
    focusInput: function focusInput() {
      this.$refs.name.focus();
    },
    loadHealthInsurance: function loadHealthInsurance() {
      var _this3 = this;

      if (!this.customer) return false;
      window.axios.get("https://api.spitzer.io" + '/my-clinic-new/schedule-sync/health-insurance', {
        headers: {
          'x-access-token': this.auth.token
        },
        params: {
          customer: this.customer
        }
      }).then(function (healthInsurance) {
        _this3.healthInsurances = healthInsurance.data.result;
        _this3.healthInsuranceLoading = true;
      }).catch(function (err) {
        _this3.snackbarConfig.snackbar = true;
        _this3.snackbarConfig.color = 'warning';
        _this3.snackbarConfig.text = 'Erro ao carregar convênios, tente novamente!';
        console.error(err);
      });
    },
    selectPatient: function selectPatient(item) {
      this.model = item.id;
      this.findOne();
    },
    toggleMarker: function toggleMarker() {
      this.model = undefined;
      this.show(0);
      // this.marker = !this.marker
    },
    sendMessage: function sendMessage() {
      var _this4 = this;

      this.loadingOk = true;
      window.axios.get("https://api.spitzer.io" + '/my-clinic-new/patient/find', {
        params: {
          patient: this.message,
          customer: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.customer
        }
      }).then(function (response) {
        // handle success
        _this4.items = response.data.results.results.map(function (item) {
          return {
            id: item.tbCodigo,
            name: item.tbNome,
            symbol: item.tbNome.substr(0, 1),
            website_slug: 'spitzer.io',
            dateOfBirth: item.tbDtNasc
          };
        });
        _this4.listVisible = true;
        _this4.loadingOk = false;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        return _this4.isLoading = false;
      });
    },
    clearMessage: function clearMessage() {
      this.listVisible = false;
      this.message = '';
      this.navigation = 'list';
      this.show(0);
    },
    resetIcon: function resetIcon() {
      this.iconIndex = 0;
    },
    changeIcon: function changeIcon() {
      this.iconIndex === this.icons.length - 1 ? this.iconIndex = 0 : this.iconIndex++;
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '/' + month + '/' + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          month = _date$split4[0],
          day = _date$split4[1],
          year = _date$split4[2];

      return day.padStart(2, '0') + '-' + month.padStart(2, '0') + '-' + year;
    },
    closedDialog: function closedDialog() {
      this.$bus.$emit('closeDialogScheduleProposed', false);
    },
    findOne: function findOne() {
      if (this.model === null || this.model === undefined) return;
      this.setPatient(this.model).then(function () {});
    },
    save: function save() {
      if (this.$refs.form.validate()) {
        if (this.proposedSurgeries.surgery.length === 0) {
          console.error('Selecione uma cirurgia!');
          this.text = 'Selecione uma cirurgia!';
          this.alertTextRequired = 'Selecione uma cirurgia!';
          this.validationsetTime();
          this.snackbar = true;
          return false;
        } else if (!this.model && this.registered) {
          this.text = 'Selecione um paciente!';
          this.snackbar = true;
          console.error('Selecione uma paciente!');
          this.alertTextRequired = 'Selecione um paciente!';
          this.validationsetTime();
          return false;
        } else if (!this.proposedSurgeries.anesthesia) {
          this.text = 'Selecione uma indicacao anestesica!';
          this.snackbar = true;
          console.error('Selecione indicacao anestesica!');
          this.alertTextRequired = 'Selecione indicacao anestesica!';
          this.validationsetTime();
          return false;
        }
        if (this.$validator.validateAll()) {
          this.proposedSurgeries.birthDay = this.proposedSurgeries.birthDay.substring(2, 4) + '-' + this.proposedSurgeries.birthDay.substring(0, 2) + '-' + this.proposedSurgeries.birthDay.substring(4, 8);
          this.proposedSurgeries.date = this.date;
          this.proposedSurgeries.record = this.model;
          this.proposedSurgeries.doctor = this.auth.auth.myClinic.crm;
          this.setCreateProposedSurgeries(this.proposedSurgeries);
        } else {
          this.snackbar = true;
        }
        this.closedDialog();
      }
    }
  })
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_friendly_iframe__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_friendly_iframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_friendly_iframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_dist_vuetify_min_css__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuetify_dist_vuetify_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('currency', function (value) {
  return 'R$' + parseFloat(value).toFixed(2);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('twoDigits', function (value) {
  if (value.toString().length <= 1) {
    return '0' + value.toString();
  }
  return value.toString();
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('capitalize', function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('lowercase', function (str) {
  return str.charAt(0).toLowerCase() + str.slice(1);
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('firstChar', function (str) {
  return str.charAt(0).toUpperCase();
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('first2Char', function (str) {
  return str.substring(0, 2).toUpperCase();
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('hljshtml', function (value) {
  return value.replace(/</g, '&lt;').replace(/>/g, '&gt;');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('truncate', function (value, args) {
  return Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["truncate"])(value, args);
});

var config = {
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true,
  i18n: null, // the vue-i18n plugin instance,
  i18nRootKey: 'validations' // the nested key under which the validation messsages will be located
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["a" /* default */], config);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vuetify___default.a, {
  theme: {
    primary: '#3f51b5',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
});

// const instance = axios.create({
//   baseURL: 'https://some-domain.com/api/',
//   timeout: 1000,
//   headers: {'X-Custom-Header': 'foobar'}
// })

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: '' + "https://api.spitzer.io"
});
window.axios = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.post['authorization'] = 'kpNzqXieqb4nXnlC2bdZRZE8xafzmV';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_friendly_iframe___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: '<App/>'
});

/***/ }),
/* 257 */,
/* 258 */,
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd7e7e62_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(472);
function injectStyle (ssrContext) {
  __webpack_require__(260)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd7e7e62_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b51b7aae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__ = __webpack_require__(271);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b51b7aae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_config_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72bd82db_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_config_vue__ = __webpack_require__(269);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_config_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72bd82db_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_config_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","dark":""}},on),[_vm._v("Open Dialog")])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Settings")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-subheader',[_vm._v("User Controls")]),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Content filtering")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Set the content filtering level to restrict apps that can be downloaded")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Password")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Require password for purchase or use password to restrict purchase")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-subheader',[_vm._v("General")]),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-action',[_c('v-checkbox',{model:{value:(_vm.notifications),callback:function ($$v) {_vm.notifications=$$v},expression:"notifications"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Notifications")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Notify me about updates to apps or games that I downloaded")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-action',[_c('v-checkbox',{model:{value:(_vm.sound),callback:function ($$v) {_vm.sound=$$v},expression:"sound"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Sound")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Auto-update apps at any time. Data charges may apply")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-action',[_c('v-checkbox',{model:{value:(_vm.widgets),callback:function ($$v) {_vm.widgets=$$v},expression:"widgets"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Auto-add widgets")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Automatically add home screen widgets")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 64,
	"./af.js": 64,
	"./ar": 65,
	"./ar-dz": 66,
	"./ar-dz.js": 66,
	"./ar-kw": 67,
	"./ar-kw.js": 67,
	"./ar-ly": 68,
	"./ar-ly.js": 68,
	"./ar-ma": 69,
	"./ar-ma.js": 69,
	"./ar-sa": 70,
	"./ar-sa.js": 70,
	"./ar-tn": 71,
	"./ar-tn.js": 71,
	"./ar.js": 65,
	"./az": 72,
	"./az.js": 72,
	"./be": 73,
	"./be.js": 73,
	"./bg": 74,
	"./bg.js": 74,
	"./bm": 75,
	"./bm.js": 75,
	"./bn": 76,
	"./bn-bd": 77,
	"./bn-bd.js": 77,
	"./bn.js": 76,
	"./bo": 78,
	"./bo.js": 78,
	"./br": 79,
	"./br.js": 79,
	"./bs": 80,
	"./bs.js": 80,
	"./ca": 81,
	"./ca.js": 81,
	"./cs": 82,
	"./cs.js": 82,
	"./cv": 83,
	"./cv.js": 83,
	"./cy": 84,
	"./cy.js": 84,
	"./da": 85,
	"./da.js": 85,
	"./de": 86,
	"./de-at": 87,
	"./de-at.js": 87,
	"./de-ch": 88,
	"./de-ch.js": 88,
	"./de.js": 86,
	"./dv": 89,
	"./dv.js": 89,
	"./el": 90,
	"./el.js": 90,
	"./en-au": 91,
	"./en-au.js": 91,
	"./en-ca": 92,
	"./en-ca.js": 92,
	"./en-gb": 93,
	"./en-gb.js": 93,
	"./en-ie": 94,
	"./en-ie.js": 94,
	"./en-il": 95,
	"./en-il.js": 95,
	"./en-in": 96,
	"./en-in.js": 96,
	"./en-nz": 97,
	"./en-nz.js": 97,
	"./en-sg": 98,
	"./en-sg.js": 98,
	"./eo": 99,
	"./eo.js": 99,
	"./es": 100,
	"./es-do": 101,
	"./es-do.js": 101,
	"./es-mx": 102,
	"./es-mx.js": 102,
	"./es-us": 103,
	"./es-us.js": 103,
	"./es.js": 100,
	"./et": 104,
	"./et.js": 104,
	"./eu": 105,
	"./eu.js": 105,
	"./fa": 106,
	"./fa.js": 106,
	"./fi": 107,
	"./fi.js": 107,
	"./fil": 108,
	"./fil.js": 108,
	"./fo": 109,
	"./fo.js": 109,
	"./fr": 110,
	"./fr-ca": 111,
	"./fr-ca.js": 111,
	"./fr-ch": 112,
	"./fr-ch.js": 112,
	"./fr.js": 110,
	"./fy": 113,
	"./fy.js": 113,
	"./ga": 114,
	"./ga.js": 114,
	"./gd": 115,
	"./gd.js": 115,
	"./gl": 116,
	"./gl.js": 116,
	"./gom-deva": 117,
	"./gom-deva.js": 117,
	"./gom-latn": 118,
	"./gom-latn.js": 118,
	"./gu": 119,
	"./gu.js": 119,
	"./he": 120,
	"./he.js": 120,
	"./hi": 121,
	"./hi.js": 121,
	"./hr": 122,
	"./hr.js": 122,
	"./hu": 123,
	"./hu.js": 123,
	"./hy-am": 124,
	"./hy-am.js": 124,
	"./id": 125,
	"./id.js": 125,
	"./is": 126,
	"./is.js": 126,
	"./it": 127,
	"./it-ch": 128,
	"./it-ch.js": 128,
	"./it.js": 127,
	"./ja": 129,
	"./ja.js": 129,
	"./jv": 130,
	"./jv.js": 130,
	"./ka": 131,
	"./ka.js": 131,
	"./kk": 132,
	"./kk.js": 132,
	"./km": 133,
	"./km.js": 133,
	"./kn": 134,
	"./kn.js": 134,
	"./ko": 135,
	"./ko.js": 135,
	"./ku": 136,
	"./ku.js": 136,
	"./ky": 137,
	"./ky.js": 137,
	"./lb": 138,
	"./lb.js": 138,
	"./lo": 139,
	"./lo.js": 139,
	"./lt": 140,
	"./lt.js": 140,
	"./lv": 141,
	"./lv.js": 141,
	"./me": 142,
	"./me.js": 142,
	"./mi": 143,
	"./mi.js": 143,
	"./mk": 144,
	"./mk.js": 144,
	"./ml": 145,
	"./ml.js": 145,
	"./mn": 146,
	"./mn.js": 146,
	"./mr": 147,
	"./mr.js": 147,
	"./ms": 148,
	"./ms-my": 149,
	"./ms-my.js": 149,
	"./ms.js": 148,
	"./mt": 150,
	"./mt.js": 150,
	"./my": 151,
	"./my.js": 151,
	"./nb": 152,
	"./nb.js": 152,
	"./ne": 153,
	"./ne.js": 153,
	"./nl": 154,
	"./nl-be": 155,
	"./nl-be.js": 155,
	"./nl.js": 154,
	"./nn": 156,
	"./nn.js": 156,
	"./oc-lnc": 157,
	"./oc-lnc.js": 157,
	"./pa-in": 158,
	"./pa-in.js": 158,
	"./pl": 159,
	"./pl.js": 159,
	"./pt": 160,
	"./pt-br": 161,
	"./pt-br.js": 161,
	"./pt.js": 160,
	"./ro": 162,
	"./ro.js": 162,
	"./ru": 163,
	"./ru.js": 163,
	"./sd": 164,
	"./sd.js": 164,
	"./se": 165,
	"./se.js": 165,
	"./si": 166,
	"./si.js": 166,
	"./sk": 167,
	"./sk.js": 167,
	"./sl": 168,
	"./sl.js": 168,
	"./sq": 169,
	"./sq.js": 169,
	"./sr": 170,
	"./sr-cyrl": 171,
	"./sr-cyrl.js": 171,
	"./sr.js": 170,
	"./ss": 172,
	"./ss.js": 172,
	"./sv": 173,
	"./sv.js": 173,
	"./sw": 174,
	"./sw.js": 174,
	"./ta": 175,
	"./ta.js": 175,
	"./te": 176,
	"./te.js": 176,
	"./tet": 177,
	"./tet.js": 177,
	"./tg": 178,
	"./tg.js": 178,
	"./th": 179,
	"./th.js": 179,
	"./tk": 180,
	"./tk.js": 180,
	"./tl-ph": 181,
	"./tl-ph.js": 181,
	"./tlh": 182,
	"./tlh.js": 182,
	"./tr": 183,
	"./tr.js": 183,
	"./tzl": 184,
	"./tzl.js": 184,
	"./tzm": 185,
	"./tzm-latn": 186,
	"./tzm-latn.js": 186,
	"./tzm.js": 185,
	"./ug-cn": 187,
	"./ug-cn.js": 187,
	"./uk": 188,
	"./uk.js": 188,
	"./ur": 189,
	"./ur.js": 189,
	"./uz": 190,
	"./uz-latn": 191,
	"./uz-latn.js": 191,
	"./uz.js": 190,
	"./vi": 192,
	"./vi.js": 192,
	"./x-pseudo": 193,
	"./x-pseudo.js": 193,
	"./yo": 194,
	"./yo.js": 194,
	"./zh-cn": 195,
	"./zh-cn.js": 195,
	"./zh-hk": 196,
	"./zh-hk.js": 196,
	"./zh-mo": 197,
	"./zh-mo.js": 197,
	"./zh-tw": 198,
	"./zh-tw.js": 198
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 270;

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-navigation-drawer',{attrs:{"persistent":"","absolute":"","disable-route-watcher":"","mini-variant":_vm.miniVariant,"clipped":_vm.clipped,"enable-resize-watcher":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',_vm._l((_vm.items),function(item,i){return _c('v-list-tile',{key:i,attrs:{"value":"true","to":item.to}},[_c('v-list-tile-action',[_c('v-icon',{domProps:{"innerHTML":_vm._s(item.icon)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.title)}})],1)],1)}),1)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"app":"","fixed":"","clipped-left":_vm.clipped}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.getDevice.isMobile),expression:"!getDevice.isMobile"}],attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.miniVariant = !_vm.miniVariant}}},[_c('v-icon',{domProps:{"innerHTML":_vm._s(_vm.miniVariant ? 'chevron_right' : 'chevron_left')}})],1),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.getDevice.isMobile),expression:"!getDevice.isMobile"}],attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.clipped = !_vm.clipped}}},[_c('v-icon',[_vm._v("web")])],1),_vm._v(" "),_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"d-flex align-center",staticStyle:{"margin-left":"auto"}},[(true)?_c('div',[_c('v-menu',{attrs:{"offset-x":"","close-on-content-click":false,"nudge-width":200,"bottom":"","left":""},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},nativeOn:{"click":function($event){_vm.show = !_vm.show}},slot:"activator"},[_c('v-badge',{attrs:{"color":this.getTheme.color,"left":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v("3")]),_vm._v(" "),_c('v-icon',[_vm._v("notifications")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-list',[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":"https://storage.googleapis.com/spitzer-io/img/Logo%20Spitzer%20icone.png","alt":"Sptizer.io"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(this.auth.auth.user.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Spitzer.io")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{class:_vm.fav ? 'red--text' : '',attrs:{"icon":""},on:{"click":function($event){_vm.fav = !_vm.fav}}},[_c('v-icon',[_vm._v("favorite")])],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-switch',{attrs:{"color":this.getTheme.color},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Notificações")])],1)],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.itemsNotification),function(item){return [(item.header)?_c('v-subheader',{domProps:{"textContent":_vm._s(item.header)}}):(item.divider)?_c('v-divider',{attrs:{"inset":item.inset}}):_c('v-list-tile',{key:item.title,attrs:{"avatar":""},on:{"click":function($event){}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":item.avatar}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.subtitle)}})],1)],1)]})],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":this.getTheme.color,"dark":""},on:{"click":function($event){_vm.menu = false}}},[_vm._v("Sair")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.menuItems),function(item){return _c('v-list-tile',{key:item.title,attrs:{"to":item.to}},[_c('v-list-tile-action',[_c('v-icon',{domProps:{"innerHTML":_vm._s(item.icon)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.title)},on:{"click":function($event){$event.preventDefault();return _vm.actionMenu(item.action)}}})],1)],1)}),1)],1)],1):_c('div',[_c('router-link',{attrs:{"to":"/login"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("exit_to_app")])],1)],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f445367c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(273);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f445367c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_c('v-card',[_c('v-bottom-nav',{attrs:{"value":true,"active":_vm.e2,"color":_vm.color,"shift":"","app":"","dark":""},on:{"update:active":function($event){_vm.e2=$event}}},[_c('router-link',{attrs:{"to":"/schedule"}},[_c('v-btn',{attrs:{"dark":""}},[_c('span',[_vm._v("Agenda")]),_vm._v(" "),_c('v-icon',[_vm._v("event")])],1)],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/dashboard"}},[_c('v-btn',{attrs:{"dark":""}},[_c('span',[_vm._v("Dashboard")]),_vm._v(" "),_c('v-icon',[_vm._v("dashboard")])],1)],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/patient"}},[_c('v-btn',{attrs:{"dark":""}},[_c('span',[_vm._v("Paciente")]),_vm._v(" "),_c('v-icon',[_vm._v("account_circle")])],1)],1),_vm._v(" "),(this.auth.auth.user.customer === '5f46a91567657c4ccd58f6a0' || _vm.env !== 'production')?_c('router-link',{attrs:{"to":"/proposed-surgeries"}},[_c('v-btn',{attrs:{"dark":""}},[_c('span',[_vm._v("Centro Cirurgico")]),_vm._v(" "),_c('v-icon',[_vm._v("mdi-hospital-box")])],1)],1):_vm._e()],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"display-1 text-no-wrap text-md-center font-weight-thin font-italic"}),_vm._v(" "),_c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"500"}},[_c('v-img',{staticClass:"grey lighten-2",attrs:{"src":"https://cdn.clinic.inf.br/public/clinic/logo.svg"}}),_vm._v(" "),_c('div',{staticClass:"backgroud-logo logo"}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"action":"#","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"E-Mail","rules":_vm.usernameRules,"required":""},model:{value:(_vm.auth.username),callback:function ($$v) {_vm.$set(_vm.auth, "username", $$v)},expression:"auth.username"}}),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"type":_vm.e1 ? 'text' : 'password',"name":"input-10-1","label":"Senha"},on:{"click:append":function($event){_vm.e1 = !_vm.e1}},model:{value:(_vm.auth.password),callback:function ($$v) {_vm.$set(_vm.auth, "password", $$v)},expression:"auth.password"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Lembre me","color":this.getTheme.color},model:{value:(_vm.auth.remeberMe),callback:function ($$v) {_vm.$set(_vm.auth, "remeberMe", $$v)},expression:"auth.remeberMe"}}),_vm._v(" "),_c('router-link',{attrs:{"to":"/auth/forget-password"}},[_c('p',{staticClass:"text-xs-right title"},[_vm._v("Esqueceu sua senha?")])]),_vm._v(" "),_c('v-btn',{attrs:{"color":this.getTheme.color,"block":"","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n                    Login\n                  ")]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":"/auth/search-user"}},[_c('v-btn',{attrs:{"block":""}},[_vm._v("Cadastrar")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('div',[_c('p',[_vm._v("© 2017 - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer.io")]),_vm._v(" - Todos os direitos reservados")]),_vm._v(" "),_c('p',[_vm._v("Versão: "+_vm._s(_vm.getPkg.pkg.version))])])])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n        "+_vm._s(_vm.snackbarConfig.text)+"\n        "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d1b8c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(277);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d1b8c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{ref:"migrationDialog",attrs:{"width":"80%","close-on-click":""},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Novidades Empolgantes!")]),_vm._v(" "),_c('v-card-text',[_c('h3',[_vm._v("O MeuClinic está evoluindo! 🚀")]),_vm._v("\nPrezado Usuário,\n"),_c('br'),_c('br'),_vm._v("\nEstamos felizes em anunciar que esta plataforma estará progredindo para uma nova versão a partir do dia "),_c('strong',[_vm._v("14/12/2023")]),_vm._v("! Esta atualização traz uma série de recursos empolgantes e melhorias para aprimorar sua experiência geral. Ouvimos seus feedbacks e trabalhamos arduamente para tornar o Clinic ainda melhor, e com uma presença marcante na WEB.\n"),_c('br'),_c('br'),_vm._v(" "),_c('h3',[_vm._v("O que há de Novo")]),_vm._v(" "),_c('ul',[_c('li',[_c('h4',[_vm._v("Novo visual")]),_vm._v("O Clinic está de cara nova, com um visual mais moderno e agradável.")]),_vm._v(" "),_c('li',[_c('h4',[_vm._v("Agenda aprimorada")]),_vm._v("Apresentamos uma nova agenda, mais clara e intuitiva.")]),_vm._v(" "),_c('li',[_c('h4',[_vm._v("Prontuário eletrônico")]),_vm._v("Faça evoluções e veja o histórico do paciente de forma mais clara.")]),_vm._v(" "),_c('li',[_c('h4',[_vm._v("Segurança")]),_vm._v("A segurança dos seus dados é nossa prioridade. Por isso, estamos migrando para uma nova plataforma, com tecnologia de ponta e muito mais segura.")])]),_vm._v(" "),_c('br'),_vm._v("\nAlém dos novos recursos, também fizemos vários aprimoramentos e correções de bugs para garantir que o MeuClinic funcione sem problemas. Seu feedback é inestimável, e agradecemos sua paciência enquanto continuamos a refinar e melhorar o aplicativo.\n"),_c('br'),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Como Atualizar")]),_vm._v("\nPara desfrutar dos recursos e melhorias mais recentes agora mesmo, basta acessar "),_c('a',{attrs:{"href":"https://meu.clinic.com.br"}},[_vm._v("meu.clinic.com.br")]),_vm._v(".\nCaso tenha alguma dúvida, entre em contato com o nosso suporte pelo e-mail "),_c('a',{attrs:{"href":"mailto:suporte@clinic.med.br"}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Queremos Seu Feedback")]),_vm._v("\nComo sempre, seu feedback é crucial para nos ajudar a moldar o futuro do MeuClinic. Se encontrar algum problema, tiver sugestões ou simplesmente quiser compartilhar seus pensamentos, não hesite em nos contatar.\n"),_c('br'),_c('br'),_vm._v("\nAgradecemos por ser parte valiosa da comunidade MeuClinic. Esperamos que você aproveite as últimas melhorias e recursos!\n"),_c('br'),_c('br'),_vm._v("\nAtenciosamente,\n"),_c('br'),_vm._v("\nClinic.\n      ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){_vm.modal = false}}},[_vm._v("Ok")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSidebar", function() { return toggleSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleDevice", function() { return toggleDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUser", function() { return setUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomer", function() { return setCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTokenRecoveryPassword", function() { return setTokenRecoveryPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expandMenu", function() { return expandMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchEffect", function() { return switchEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(203);


var toggleSidebar = function toggleSidebar(_ref, opened) {
  var commit = _ref.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* TOGGLE_SIDEBAR */], opened);
};

var toggleDevice = function toggleDevice(_ref2, device) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["f" /* TOGGLE_DEVICE */], device);
};

var setUser = function setUser(_ref3, user) {
  var commit = _ref3.commit;
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* AUTH */], user);
};

var setCustomer = function setCustomer(_ref4, customer) {
  var commit = _ref4.commit;
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* CUSTOMER */], customer);
};

var setTokenRecoveryPassword = function setTokenRecoveryPassword(_ref5, token) {
  var commit = _ref5.commit;
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* RECOVERY_PASSWORD */], token);
};

var expandMenu = function expandMenu(_ref6, menuItem) {
  var commit = _ref6.commit;

  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false;
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* EXPAND_MENU */], menuItem);
  }
};

var switchEffect = function switchEffect(_ref7, effectItem) {
  var commit = _ref7.commit;

  if (effectItem) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* SWITCH_EFFECT */], effectItem);
  }
};

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "app", function() { return app; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "device", function() { return device; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebar", function() { return sidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effect", function() { return effect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuitems", function() { return menuitems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auth", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customer", function() { return customer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tokenRecoveryPassword", function() { return tokenRecoveryPassword; });
// import { isEmpty } from 'lodash'

var app = function app(state) {
  return state.app;
};
var device = function device(state) {
  return state.app.device;
};
var sidebar = function sidebar(state) {
  return state.app.sidebar;
};
var effect = function effect(state) {
  return state.app.effect;
};
var menuitems = function menuitems(state) {
  return state.menu.items;
};
var auth = function auth(state) {
  return state.auth;
};
var customer = function customer(state) {
  return state.customer;
};
var tokenRecoveryPassword = function tokenRecoveryPassword(state) {
  return state.recoveryPassword.token;
};



/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(289);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_package__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_package__);


/* harmony default export */ __webpack_exports__["a"] = ({
  theme: {
    color: 'blue darken-2',
    colorHTML: '#1976D2'
  },
  device: {
    isMobile: false,
    isTablet: false
  },
  pkg: {
    pkg: __WEBPACK_IMPORTED_MODULE_0_package___default.a
  }

});

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = {"name":"pwa-my-clinic","version":"4.2.26","description":"Meu Clinic","author":"Alexandre Campagnaro <contato@spitzer.io>","private":true,"scripts":{"dev":"node build/dev-server.js","start":"node build/dev-server.js","build":"node build/build.js","unit":"cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit && npm run e2e","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs"},"dependencies":{"axios":"^0.24.0","chart.js":"^2.7.3","chartjs-plugin-style":"^0.3.1","highcharts":"^6.2.0","jsonwebtoken":"^8.5.1","localforage":"^1.7.3","moment":"^2.24.0","npm-check-updates":"^2.15.0","vee-validate":"^2.2.13","vue":"^2.6.10","vue-axios":"^2.1.4","vue-chartjs":"^3.4.0","vue-friendly-iframe":"^0.20.0","vue-gallery":"^2.0.1","vue-router":"^3.0.7","vuetify":"^1.5.16","vuex":"^3.1.1"},"devDependencies":{"autoprefixer":"^7.1.5","babel-core":"^6.26.0","babel-eslint":"^8.0.1","babel-loader":"^7.1.2","babel-plugin-istanbul":"^4.1.5","babel-plugin-transform-runtime":"^6.23.0","babel-preset-env":"^1.6.0","babel-preset-stage-2":"^6.24.1","babel-register":"^6.26.0","chai":"^4.2.0","chalk":"^2.4.2","chromedriver":"^2.46.0","connect-history-api-fallback":"^1.6.0","copy-webpack-plugin":"^4.6.0","cross-env":"^5.0.5","cross-spawn":"^5.1.0","css-loader":"^0.28.7","cssnano":"^3.10.0","eslint":"^4.9.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^3.0.0","eslint-loader":"^1.9.0","eslint-plugin-html":"^3.2.2","eslint-plugin-import":"^2.18.0","eslint-plugin-node":"^5.2.0","eslint-plugin-promise":"^3.6.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.17.1","extract-text-webpack-plugin":"^3.0.0","file-loader":"^1.1.5","friendly-errors-webpack-plugin":"^1.6.1","html-webpack-plugin":"^2.30.1","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.1","karma":"^1.7.1","karma-coverage":"^1.1.1","karma-mocha":"^1.3.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.5.0","karma-sinon-chai":"^1.3.2","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.31","karma-webpack":"^2.0.5","mocha":"^4.0.1","nightwatch":"^0.9.16","node-sass":"^4.12.0","opn":"^5.5.0","optimize-css-assets-webpack-plugin":"^3.2.1","ora":"^1.3.0","phantomjs-prebuilt":"^2.1.15","rimraf":"^2.6.3","sass-loader":"^7.1.0","selenium-server":"^3.141.59","semver":"^5.7.0","shelljs":"^0.7.8","sinon":"^4.0.1","sinon-chai":"^2.14.0","stylus":"^0.54.5","stylus-loader":"^3.0.2","sw-precache-webpack-plugin":"^0.11.4","uglify-es":"^3.3.10","url-loader":"^0.6.2","vue-loader":"^13.7.3","vue-style-loader":"^3.0.3","vue-template-compiler":"^2.6.10","webpack":"^3.7.1","webpack-bundle-analyzer":"^2.9.0","webpack-dev-middleware":"^1.12.0","webpack-hot-middleware":"^2.25.0","webpack-merge":"^4.1.5"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var setTheme = function setTheme(_ref, theme) {
  var commit = _ref.commit;

  commit('SET_THEME', theme);
};

var setDevice = function setDevice(_ref2, device) {
  var commit = _ref2.commit;

  commit('SET_DEVICE', device);
};
/* harmony default export */ __webpack_exports__["a"] = ({
  setTheme: setTheme,
  setDevice: setDevice
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var getTheme = function getTheme(state) {
  return state.theme;
};
var getDevice = function getDevice(state) {
  return state.device;
};
var getPkg = function getPkg(state) {
  return state.pkg;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getTheme: getTheme,
  getDevice: getDevice,
  getPkg: getPkg
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var SET_THEME = function SET_THEME(state, payLoad) {
  var color = payLoad.color,
      colorHTML = payLoad.colorHTML;

  state.theme.color = color;
  state.theme.colorHTML = colorHTML;
};

var SET_DEVICE = function SET_DEVICE(state, payLoad) {
  var mobile = payLoad.mobile,
      tablet = payLoad.tablet;

  state.device.isMobile = mobile;
  state.device.isTablet = tablet;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_THEME: SET_THEME,
  SET_DEVICE: SET_DEVICE
});

/***/ }),
/* 290 */
/***/ (function(module, exports) {

// import * as types from '../../mutation-types'

// const state = {
//   items: [
//     {
//       name: 'Horarios',
//       path: '/',
//       meta: {
//         icon: 'fa-calendar',
//         link: 'Home.vue'
//       },
//       component: lazyLoading('home', true)
//     }
//   ]
// }

// const mutations = {
//   [types.EXPAND_MENU] (state, menuItem) {
//     if (menuItem.index > -1) {
//       if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
//         state.items[menuItem.index].meta.expanded = menuItem.expanded
//       }
//     } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
//       menuItem.item.meta.expanded = menuItem.expanded
//     }
//   }
// }

// export default {
//   state,
//   mutations
// }

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(333);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  list: [],
  appointments: [],
  availableAppointments: {},
  appointmentsSurgeryCenter: [],
  proposedSurgeries: [],
  surgeries: [],
  anesthesia: []
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__features__ = __webpack_require__(331);






var setList = function setList(_ref, payload) {
  var commit = _ref.commit;

  if (payload.doctor === null) return;
  var period = __WEBPACK_IMPORTED_MODULE_2_moment___default()(payload.date, 'YYYY-MM-DD').format('MM/DD/YYYY');
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    commit('SET_LIST', []);
    commit('SET_APPOINTMENTS', []);
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.spitzer.io" + '/my-clinic-new/schedule-sync/appointments', {
      params: {
        customer: payload.customer,
        doctor: payload.doctor,
        period: period
      }
    }).then(function (response) {
      // handle success
      var items = [];
      var items2 = [];

      if (response.data && response.data.results && response.data.results.results) {
        response.data.results.results.map(function (item) {
          if (item.tbTipo === 'C') {
            items2.push({
              id: item.id,
              icon: 'notifications',
              iconClass: 'orange lighten-1 white--text',
              title: item.name || 'Compromissos',
              subtitle: item.tbHora ? item.tbHora.substring(0, 5) : item.hour ? item.hour.substring(11, 16) : '00:00',
              type: 'Compromisso',
              interval: item.interval
            });
          }
          items.push({
            id: item.tbID || item.id,
            convenant: item.tbCodConv || item.healthInsuranceCode,
            convenantDesc: item.tbConvenio || item.healthInsuranceDescription,
            descType: item.tbDescTipoCons || item.typeDescription,
            icon: __WEBPACK_IMPORTED_MODULE_4__features__["a" /* default */].typeStatusIcons(item.tbTipo || item.type, item.statusCode || item.tbStatus),
            iconClass: __WEBPACK_IMPORTED_MODULE_4__features__["a" /* default */].iconClass(item.tbTipo || item.type, item.statusCode || item.tbStatus),
            title: item.tbNome || item.name || 'Vago',
            subtitle: item.tbHora ? item.tbHora.substring(0, 5) : item.hour ? item.hour.substring(11, 16) : '00:00',
            type: __WEBPACK_IMPORTED_MODULE_4__features__["a" /* default */].typeProcedure(item.tbTipo || item.type),
            typeDesc: item.tbTipoDesc || item.typeDescription,
            mobile: item.tbCelular || item.mobile,
            typeAppontement: item.tbTipoAgendamento || item.typeSchedule,
            email: item.tbEmail || item.email,
            interval: item.tbIntervalo || item.interval,
            doctor: payload.doctor,
            period: period,
            code: item.tbFicha || item.record
          });
        });
      }
      commit('SET_LIST', items);
      commit('SET_APPOINTMENTS', items2);
      resolve();
    }).catch(function (error) {
      // handle error
      console.error('err', error);
      reject(error);
    }).then(function () {
      // always executed
    });
  });
};

var setAppointmentsSurgerycenter = function setAppointmentsSurgerycenter(_ref2, payload) {
  var commit = _ref2.commit;

  if (payload.doctor === null) return;
  var period = __WEBPACK_IMPORTED_MODULE_2_moment___default()(payload.date, 'YYYY-MM-DD').format('MM/DD/YYYY');
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.spitzer.io" + '/my-clinic-new/schedule-sync/appointments-surgery-center', {
      params: {
        customer: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.customer,
        doctor: payload.doctor,
        period: period
      }
    }).then(function (response) {
      var items3 = [];

      if (response.data && response.data.results && response.data.results.results) {
        response.data.results.results.map(function (item) {
          items3.push({
            id: item.tbNumSaidaSala,
            icon: 'add',
            iconClass: 'red lighten-1 white--text',
            title: item.tbNome || 'Cirurgia',
            subtitle: __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.tbData, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            type: 'Cirurgia',
            interval: item.tbNumSaidaSala
          });
        });
      }
      return resolve(commit('SET_APPOINTMENTSSURGERYCENTER', items3));
    }).catch(function (error) {
      console.error('err', error);
      reject(error);
    });
  });
};

var setAvailableAppointments = function setAvailableAppointments(_ref3, schedule) {
  var commit = _ref3.commit;

  commit('SET_AVAILABLEAPPOINTMENTS', schedule);
};

var setProposedSurgeries = function setProposedSurgeries(_ref4, payload) {
  var commit = _ref4.commit;

  if (!payload.customer) return;
  var period = __WEBPACK_IMPORTED_MODULE_2_moment___default()(payload.date, 'YYYY-MM-DD').format('MM/DD/YYYY');
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.spitzer.io" + '/my-clinic-new/schedule-sync/proposed-surgeries', {
      params: {
        customer: payload.customer,
        doctor: payload.doctor,
        period: period
      }
    }).then(function (response) {
      // handle success
      var items = [];
      if (response.data && response.data.results && response.data.results.results) {
        response.data.results.results.map(function (item) {
          items.push({
            id: item.tbKeyReg,
            action: __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.tbDataHoraCirurgia, 'YYYY-MM-DD').format('DD/MM/YYYY') || '00:00',
            headline: item.tbDescStatus || 'Sem Status',
            title: item.tbNomePaciente,
            subtitle: item.tbDesc_Cirurgia
          });
        });
      }
      commit('SET_PROPOSEDSURGERIES', items);
      resolve();
    }).catch(function (error) {
      // handle error
      console.error('err', error);
      reject(error);
    }).then(function () {
      // always executed
    });
  });
};

var setLockAppointments = function setLockAppointments(_ref5, payload) {
  var commit = _ref5.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.spitzer.io" + '/my-clinic-new/schedule-sync/lock', {
      period: payload.period,
      hour: payload.subtitle,
      doctor: payload.doctor
    }, {
      params: {
        customer: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.customer
      }
    }).then(function (response) {
      resolve();
    }).catch(function (error) {
      // handle error
      console.error('err', error);
      reject(error);
    }).then(function () {
      // always executed
    });
  });
};

var setUnLockAppointments = function setUnLockAppointments(_ref6, payload) {
  var commit = _ref6.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.spitzer.io" + '/my-clinic-new/schedule-sync/un-lock', {
      period: payload.period,
      hour: payload.subtitle,
      doctor: payload.doctor
    }, {
      params: {
        customer: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.customer
      }
    }).then(function (response) {
      resolve();
    }).catch(function (error) {
      // handle error
      console.error('err', error);
      reject(error);
    }).then(function () {
      // always executed
    });
  });
};

var setSurgeries = function setSurgeries(_ref7, payload) {
  var commit = _ref7.commit;

  if (!__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.customer) return;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.spitzer.io" + '/my-clinic-new/schedule-sync/surgeries', {
      params: {
        customer: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.customer
      }
    }).then(function (response) {
      if (response.data && response.data.results && response.data.results.results) {
        var items = response.data.results.results.map(function (item) {
          if (item.type === 'cirurgia') return item;
        });
        var filter = items.filter(function (item) {
          return item != null;
        });
        commit('SET_SURGERIES', filter);
        var items2 = response.data.results.results.map(function (item) {
          if (item.type !== 'cirurgia') return item;
        });
        var filter2 = items2.filter(function (item) {
          return item != null;
        });
        commit('SET_ANESTHESIA', filter2);
      }
    }).catch(function (error) {
      // handle error
      console.error('err', error);
      reject(error);
    }).then(function () {
      // always executed
    });
  });
};

var setCreateProposedSurgeries = function setCreateProposedSurgeries(_ref8, payload) {
  var commit = _ref8.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var config = {
      params: {
        customer: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.customer
      }
    };
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.spitzer.io" + '/my-clinic-new/schedule-sync/proposed-surgeries', payload, config).then(function (response) {
      console.dir(response);
    }).catch(function (error) {
      // handle error
      console.error('err', error);
      reject(error);
    }).then(function () {
      // always executed
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setSurgeries: setSurgeries,
  setList: setList,
  setLockAppointments: setLockAppointments,
  setUnLockAppointments: setUnLockAppointments,
  setAvailableAppointments: setAvailableAppointments,
  setAppointmentsSurgerycenter: setAppointmentsSurgerycenter,
  setProposedSurgeries: setProposedSurgeries,
  setCreateProposedSurgeries: setCreateProposedSurgeries
});

/***/ }),
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var typeProcedure = function typeProcedure(type) {
  if (type === 9 || type === '9') {
    return 'Horário Bloqueado';
  } else if (type === 0 || type === '0') {
    return 'Primeira Consulta';
  } else if (type === 1 || type === '1') {
    return 'Consulta';
  } else if (type === 2 || type === '2') {
    return 'Exame';
  } else if (type === 3 || type === '3') {
    return 'Retorno';
  } else if (type === 4 || type === '4') {
    return 'Cirurgia';
  } else if (type === 5 || type === '5') {
    return 'WEB';
  } else if (type === 'C') {
    return 'Compromisso';
  } else if (type === undefined || type === null || type === '') {
    return '**Vago**';
  }
};

var iconClass = function iconClass(type, status) {
  if (status === 1) {
    return 'white white--text';
  } else if (status === 2) {
    return 'blue white--text';
  } else if (status === 3) {
    return 'red lighten-1 white--text';
  } else if (status === 4) {
    return 'blue lighten-1 white--text';
  } else if (status === 5) {
    return 'red lighten-1 white--text';
  } else if (status === 6) {
    return 'orange lighten-1 white--text';
  } else if (status === 11) {
    return 'red lighten-1 white--text';
  } else if (status === null || type === null) {
    return 'green white--text';
  } else if (status === 'C') {
    return 'orange lighten-1 white--text';
  }

  if (status === 0 && type === '9') {
    return 'cyan darken-2 white--text';
  }
};

var typeStatusIcons = function typeStatusIcons(type, status) {
  if (status === 2) {
    return 'done';
  } else if (status === 0) {
    return 'https';
  } else if (status === 3) {
    return 'cancel_presentation';
  } else if (status === 4) {
    return 'done_all';
  } else if (status === 5) {
    return 'alarm';
  } else if (status === 6) {
    return 'watch';
  } else if (status === 8) {
    return 'arrow_right_alt';
  } else if (status === 11) {
    return 'block';
  } else if (status === null) {
    return 'tab_unselected';
  }

  // if (type === '9') {
  //   return ('enhanced_encryption')
  // } else if (type === '0') {
  //   return ('error')
  // } else if ((type === null) && (status === null)) {
  //   return ('tab_unselected')
  // } else if ((type === 'C')) {
  //   return ('notifications')
  // }
  // } else if (status === '1') {
  //   return ('done_all')
};

/* harmony default export */ __webpack_exports__["a"] = ({
  typeProcedure: typeProcedure,
  iconClass: iconClass,
  typeStatusIcons: typeStatusIcons
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var getList = function getList(state) {
  return state.list;
};
var getAppointments = function getAppointments(state) {
  return state.appointments;
};
var getAvailableAppointments = function getAvailableAppointments(state) {
  return state.availableAppointments;
};
var getAppointmentsSurgerycenter = function getAppointmentsSurgerycenter(state) {
  return state.appointmentsSurgeryCenter;
};
var getProposedSurgeries = function getProposedSurgeries(state) {
  return state.proposedSurgeries;
};
var getSurgeries = function getSurgeries(state) {
  return state.surgeries;
};
var getAnesthesia = function getAnesthesia(state) {
  return state.anesthesia;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: getList,
  getAppointments: getAppointments,
  getAvailableAppointments: getAvailableAppointments,
  getAppointmentsSurgerycenter: getAppointmentsSurgerycenter,
  getProposedSurgeries: getProposedSurgeries,
  getSurgeries: getSurgeries,
  getAnesthesia: getAnesthesia
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var SET_LIST = function SET_LIST(state, schedule) {
  state.list = schedule;
};

var SET_APPOINTMENTS = function SET_APPOINTMENTS(state, payload) {
  state.appointments = payload;
};

var SET_AVAILABLEAPPOINTMENTS = function SET_AVAILABLEAPPOINTMENTS(state, payload) {
  state.commitments = payload;
};

var SET_APPOINTMENTSSURGERYCENTER = function SET_APPOINTMENTSSURGERYCENTER(state, schedule) {
  state.appointmentsSurgeryCenter = schedule;
};

var SET_PROPOSEDSURGERIES = function SET_PROPOSEDSURGERIES(state, payload) {
  state.proposedSurgeries = payload;
};

var SET_SURGERIES = function SET_SURGERIES(state, payload) {
  state.surgeries = payload;
};

var SET_ANESTHESIA = function SET_ANESTHESIA(state, payload) {
  state.anesthesia = payload;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST,
  SET_APPOINTMENTS: SET_APPOINTMENTS,
  SET_AVAILABLEAPPOINTMENTS: SET_AVAILABLEAPPOINTMENTS,
  SET_APPOINTMENTSSURGERYCENTER: SET_APPOINTMENTSSURGERYCENTER,
  SET_PROPOSEDSURGERIES: SET_PROPOSEDSURGERIES,
  SET_SURGERIES: SET_SURGERIES,
  SET_ANESTHESIA: SET_ANESTHESIA
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(440);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  auth: {
    isLogged: false,
    user: {
      code: null,
      codeCustomer: null,
      credentials: null,
      crm: null,
      customer: null,
      customerName: null,
      id: null,
      name: null,
      state: null,
      token: null,
      username: null
    },
    myClinic: {
      code: null,
      codeCustomer: null,
      crm: null,
      customer: null,
      customerName: null,
      id: null,
      name: null,
      state: null
    },
    account: {},
    profile: {}
  },
  customers: [],
  token: {},
  register: [],
  recoveryPassword: null,
  refreshToken: null,
  searchRegisterUser: []
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_localforage__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7____ = __webpack_require__(9);





var _this = this;






var setCustomerCode = function setCustomerCode(_ref, payload) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var config = {
      headers: {
        'x-access-token': payload.token
      }
    };
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("https://api.spitzer.io" + '/customers/' + payload.customer, config).then(function (resultToken) {
      resolve(resultToken.data.result.code);
    }).catch(function (err) {
      console.error(err);
      reject(err);
    });
  });
};

var setCustomers = function setCustomers(_ref2, user) {
  var commit = _ref2.commit;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }());
};

var setSearchEmail = function setSearchEmail(_ref4, user) {
  var commit = _ref4.commit;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("https://api.spitzer.io" + '/my-clinic-new/auth/search-user', { username: user }, {
                params: {
                  customer: 'this.customer'
                }
              }).then(function (emailUser) {
                if (emailUser.data.result.length) {
                  emailUser.data.result.map(function (item) {
                    if (item.results.length) {
                      resolve(commit('SET_SEARCHEMAIL', item.results));
                    }
                  });
                }
                // if (emailUser.data.result[0].results.length > 0) {
                //   return resolve(commit('SET_SEARCHEMAIL', emailUser.data.result[0].results))
                // } else {
                //   return routes.push('/auth/sing-up')
                // }
              }).catch(function (err) {
                reject(err);
              });

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }());
};

var setSearchEmailNew = function setSearchEmailNew(_ref6, user) {
  var commit = _ref6.commit;

  commit('SET_SEARCHEMAIL', []);
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
      var emailUser, userArray;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("https://api.spitzer.io" + '/my-clinic-new/auth/search-user-new', { username: user }, {
                params: {
                  customer: Math.random().toString(36).slice(2)
                }
              }).catch(function (err) {
                return reject(err);
              });

            case 2:
              emailUser = _context3.sent;
              userArray = [];

              if (!emailUser.data.result.length) {
                _context3.next = 13;
                break;
              }

              _context3.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(emailUser.data.result.map(function (item) {
                if (item.results.length) userArray.push(item.results);
              }));

            case 7:
              if (!userArray.length) {
                _context3.next = 12;
                break;
              }

              commit('SET_SEARCHEMAIL', userArray);
              return _context3.abrupt('return', resolve(true));

            case 12:
              return _context3.abrupt('return', resolve(false));

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x5, _x6) {
      return _ref7.apply(this, arguments);
    };
  }());
};

var setCreateUser = function setCreateUser(_ref8, payload) {
  var commit = _ref8.commit;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function () {
    var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("https://api.spitzer.io" + '/my-clinic-new/auth/create', payload, {
                params: {
                  customer: 'this.customer'
                }
              }).then(function (user) {
                __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push('/auth/login');
                return resolve(commit('SET_CREATEUSER', user));
              }).catch(function (err) {
                return reject(err);
              });

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x7, _x8) {
      return _ref9.apply(this, arguments);
    };
  }());
};

var setUpdateSchedule = function setUpdateSchedule(_ref10, payload) {
  var commit = _ref10.commit;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function () {
    var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("https://api.spitzer.io" + '/my-clinic-new/auth/update-schedule', payload, {
                params: {
                  customer: 'this.customer'
                }
              }).then(function (user) {
                __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push('/auth/login');
                return resolve(commit('SET_CREATEUSER', user));
              }).catch(function (err) {
                return reject(err);
              });

            case 2:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function (_x9, _x10) {
      return _ref11.apply(this, arguments);
    };
  }());
};

var setLogin = function setLogin(_ref12, payload) {
  var commit = _ref12.commit;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var username = payload.username,
        password = payload.password,
        customer = payload.customer,
        remeberMe = payload.remeberMe;

    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("https://api.spitzer.io" + '/my-clinic-new/auth/login', {
      username: username,
      password: password
    }, {
      params: {
        customer: customer
      }
    }).then(function (response) {
      var getCRM = undefined; // await localforage.getItem('my-clinic-crm')
      var customers = [];
      response.data.result.auth.map(function (item) {
        if (item.myClinic && item.myClinic.length) {
          item.myClinic.map(function (myClinicItem) {
            customers.push({
              isLogged: true,
              user: {
                id: item._id,
                username: item.username,
                name: item.name,
                crm: getCRM || myClinicItem.crm,
                customer: myClinicItem.customerId || myClinicItem.customer,
                credentials: btoa(username + ':' + password),
                codeCustomer: myClinicItem.code,
                state: myClinicItem.state || 'PR',
                code: myClinicItem.code,
                customerName: myClinicItem.customerName || myClinicItem.name,
                token: response.data.result.token
              },
              myClinic: {
                code: myClinicItem.code,
                codeCustomer: myClinicItem.code,
                crm: getCRM || myClinicItem.crm,
                customer: myClinicItem.customerId || myClinicItem.customer,
                customerName: myClinicItem.customerName || myClinicItem.name,
                id: item._id,
                name: item.name,
                state: myClinicItem.state || 'PR'
              },
              account: {
                myClinic: item.myClinic
              },
              profile: {
                username: item.username,
                name: item.name
              }
            });
          });
        }
      });
      if (!getCRM) __WEBPACK_IMPORTED_MODULE_4_localforage___default.a.setItem('my-clinic-crm', customers[0].myClinic.crm);
      commit('SET_TOKEN', response.data.result.token);

      commit('SET_USER', JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(customers[0])));
      commit('SET_CUSTOMERS', customers);

      // store.dispatch('auth/setCustomerCode', auth[0].user).then((resultCustomerCode) => {
      //   console.log('resultCustomerCode', resultCustomerCode)
      //   auth[0].user.codeCustomer = resultCustomerCode
      // })

      // store.dispatch('memed/setToken', auth[0].user).then(() => {
      // }).catch(() => {
      //   store.dispatch('memed/createMemed', auth[0].user)
      // })

      __WEBPACK_IMPORTED_MODULE_7____["a" /* default */].dispatch('setCustomer', customers[0].user.customer, {});

      if (remeberMe) {
        __WEBPACK_IMPORTED_MODULE_4_localforage___default.a.setItem('my-clinic-user', customers[0], function (err) {
          if (err) window.console.error(err);
          __WEBPACK_IMPORTED_MODULE_4_localforage___default.a.setItem('my-clinic-customer', customers[0].user.customer).then(function () {});
          __WEBPACK_IMPORTED_MODULE_4_localforage___default.a.setItem('my-clinic-token', response.data.result.token, function (err) {
            if (err) window.console.error(err);
          });
        });
      }
      resolve(__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push('/schedule'));
    }).catch(function (err) {
      window.console.error('errologin', err);
      reject(err);
    });
  });
};

var setSingIn = function setSingIn(_ref13, payload) {
  var commit = _ref13.commit;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var username = payload.username,
        password = payload.password,
        customer = payload.customer;

    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("https://api.spitzer.io" + '/my-clinic-new/auth/login', {
      username: username,
      password: password
    }, {
      params: {
        customer: customer
      }
    }).then(function (response) {
      var auth = response.data.result.auth.map(function (item) {
        return {
          isLogged: true,
          user: {
            id: item._id,
            username: item.username,
            name: item.name,
            crm: item.myClinic[0].crm,
            customer: item.myClinic[0].customerId || item.myClinic[0].customer,
            credentials: btoa(username + ':' + password),
            codeCustomer: item.myClinic[0].code,
            state: item.myClinic[0].state || 'PR',
            code: item.myClinic[0].code,
            customerName: item.myClinic[0].customerName || item.myClinic[0].name
          },
          myClinic: {
            code: item.myClinic[0].code,
            codeCustomer: item.myClinic[0].code,
            crm: item.myClinic[0].crm,
            customer: item.myClinic[0].customerId || item.myClinic[0].customer,
            customerName: item.myClinic[0].customerName || item.myClinic[0].name,
            id: item._id,
            name: item.name,
            state: item.myClinic[0].state || 'PR'
          },
          profile: {}
        };
      });
      commit('SET_TOKEN', response.data.result.token);
      commit('SET_USER', auth[0]);
      commit('SET_CUSTOMERS', auth);
      __WEBPACK_IMPORTED_MODULE_7____["a" /* default */].dispatch('setCustomer', auth[0].user.customer, {});
      resolve(__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push('/schedule'));
    }).catch(function (err) {
      window.console.error('errologin', err);
      reject(err);
    });
  });
};

var setSingOut = function setSingOut(_ref14, user) {
  var commit = _ref14.commit;

  var auth = {
    isLogged: false,
    user: {
      id: null,
      username: null,
      name: null,
      crm: null,
      customer: null
    },
    profile: {}
  };
  commit('SET_TOKEN', null);
  commit('SET_USER', auth);
  __WEBPACK_IMPORTED_MODULE_4_localforage___default.a.removeItem('my-clinic-customer');
  __WEBPACK_IMPORTED_MODULE_4_localforage___default.a.removeItem('my-clinic-token');
  __WEBPACK_IMPORTED_MODULE_4_localforage___default.a.removeItem('my-clinic-user');
};

var setUser = function setUser(_ref15, user) {
  var commit = _ref15.commit;

  commit('SET_USER', user);
};

var setRegister = function setRegister(_ref16, user) {
  var commit = _ref16.commit;

  commit('SET_REGISTER', user);
};

var setToken = function setToken(_ref17, token) {
  var commit = _ref17.commit;

  commit('SET_TOKEN', token);
};

var setRecoveryPassword = function setRecoveryPassword(_ref18, token) {
  var commit = _ref18.commit;

  commit('SET_RECOVERY_PASSWORD', token);
};

var setChangeSchedule = function setChangeSchedule(_ref19, payload) {
  var commit = _ref19.commit;

  commit('SET_CHANGE_SCHEDULE', payload);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setUser: setUser,
  setToken: setToken,
  setLogin: setLogin,
  setRecoveryPassword: setRecoveryPassword,
  setSingOut: setSingOut,
  setSearchEmail: setSearchEmail,
  setCreateUser: setCreateUser,
  setUpdateSchedule: setUpdateSchedule,
  setRegister: setRegister,
  setSingIn: setSingIn,
  setCustomers: setCustomers,
  setCustomerCode: setCustomerCode,
  setChangeSchedule: setChangeSchedule,
  setSearchEmailNew: setSearchEmailNew
});

/***/ }),
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6c6527_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page404_vue__ = __webpack_require__(344);
function injectStyle (ssrContext) {
  __webpack_require__(343)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b6c6527"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6c6527_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"logo"},[_c('p',[_vm._v("OOPS! - Volte para a pagina da Hospital/Clinica e tente novamente!")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(345)}}),_vm._v(" "),_c('div',{staticClass:"sub"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404-1.11ec77f.png";

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d98230_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(358);
function injectStyle (ssrContext) {
  __webpack_require__(347)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05d98230"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d98230_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgreementColumn_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b85907e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgreementColumn_vue__ = __webpack_require__(349);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgreementColumn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b85907e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgreementColumn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"graficoConvenios"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Type_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30ffef84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Type_vue__ = __webpack_require__(351);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Type_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30ffef84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Type_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"graficoTipos"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Data","rules":_vm.dateRules,"required":""},model:{value:(_vm.patientsChart.date),callback:function ($$v) {_vm.$set(_vm.patientsChart, "date", $$v)},expression:"patientsChart.date"}}),_vm._v(" "),_c('v-textarea',{attrs:{"name":"input-7-1","rules":_vm.descriptionRules,"box":"","label":"Prontuário","auto-grow":"","value":""},model:{value:(_vm.patientsChart.description),callback:function ($$v) {_vm.$set(_vm.patientsChart, "description", $$v)},expression:"patientsChart.description"}})],1),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n              Salvar\n              ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_change_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d6755dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_vue__ = __webpack_require__(355);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_change_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d6755dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',[_c('v-layout',[_c('v-flex',[_c('p',{staticClass:"display-1 text-no-wrap text-md-center font-weight-thin font-italic"}),_vm._v(" "),_c('v-card',[_c('v-card',[_c('v-toolbar',{attrs:{"color":this.getTheme.color,"dark":""}},[_c('v-toolbar-title',[_vm._v("Selecionar Agenda")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},_vm._l((_vm.auth.customers),function(item,index){return _c('div',{key:index},[_c('v-list-tile',{attrs:{"avatar":"","ripple":""},on:{"click":function($event){return _vm.toggle(index, item.myClinic)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Clinica/Hosp.: "+_vm._s(item.myClinic.customerName))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v("Nome: "+_vm._s(item.myClinic.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',[_vm._v("CRM/ID:")]),_vm._v(" "+_vm._s(item.myClinic.crm))])],1),_vm._v(" "),_c('v-list-tile-action')],1),_vm._v(" "),(index + 1 < _vm.auth.customers.length)?_c('v-divider',{key:index}):_vm._e()],1)}),0)],1),_vm._v(" "),_c('v-card-actions')],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5963ac20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_create_vue__ = __webpack_require__(357);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5963ac20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closedDialog()}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Agendamento")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){return _vm.closedDialog()}}},[_vm._v("Salvar")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","offset-sm3":""}},[_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-subheader',[_vm._v("Horário")]),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Selecione a hora")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('v-flex',{attrs:{"xs11":"","sm5":""}},[_c('v-dialog',{ref:"dialog",attrs:{"return-value":_vm.time,"persistent":"","lazy":"","full-width":"","width":"290px"},on:{"update:returnValue":function($event){_vm.time=$event},"update:return-value":function($event){_vm.time=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Picker in dialog","prepend-icon":"access_time","readonly":""},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},on))]}}]),model:{value:(_vm.modal2),callback:function ($$v) {_vm.modal2=$$v},expression:"modal2"}},[_vm._v(" "),(_vm.modal2)?_c('v-time-picker',{attrs:{"full-width":""},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.modal2 = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.dialog.save(_vm.time)}}},[_vm._v("OK")])],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Selecione a Data")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.date,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Click para abrir a caixa","prepend-icon":"event","readonly":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},on))]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.menu.save(_vm.date)}}},[_vm._v("OK")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('form',[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","offset-sm3":""}},[_c('v-checkbox',{attrs:{"label":"Paciente Cadastrado?"},model:{value:(_vm.registered),callback:function ($$v) {_vm.registered=$$v},expression:"registered"}}),_vm._v(" "),(!_vm.registered)?_c('v-text-field',{attrs:{"label":"Nome"}}):_vm._e(),_vm._v(" "),(_vm.registered)?_c('v-text-field',{attrs:{"append-icon":_vm.model ? 'arrow_back' : '',"append-outer-icon":_vm.message ? 'mdi-send' : 'search',"prepend-icon":_vm.icon,"box":"","clear-icon":"mdi-close-circle","clearable":"","label":"Paciente/Dt Nascimento","type":"text"},on:{"click:append":_vm.toggleMarker,"click:append-outer":_vm.sendMessage,"click:prepend":_vm.changeIcon,"click:clear":_vm.clearMessage},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}}):_vm._e(),_vm._v(" "),_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingOk === true),expression:"loadingOk === true"}],attrs:{"indeterminate":true}}),_vm._v(" "),(!_vm.model)?_c('v-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.listVisible),expression:"listVisible"}],attrs:{"two-line":""}},[_vm._l((_vm.items),function(item,index){return [(item.header)?_c('v-subheader',{key:item.header},[_vm._v("\n            Selecione o nome\n            ")]):(item.divider)?_c('v-divider',{key:index,attrs:{"inset":item.inset}}):_c('v-list-tile',{key:item.id,attrs:{"avatar":""},on:{"click":function($event){return _vm.selectPatient(item)}}},[_c('v-list-tile-avatar',{attrs:{"color":"indigo"}},[_c('span',{staticClass:"white--text headline"},[_vm._v(_vm._s(item.symbol))])]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.dateOfBirth)}})],1)],1)]})],2):_vm._e(),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"error-messages":_vm.errors.collect('email'),"label":"Celular","data-vv-name":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.items,"error-messages":_vm.errors.collect('select'),"label":"Convênio","data-vv-name":"select","required":""},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}}),_vm._v(" "),_c('v-btn',{on:{"click":_vm.submit}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{on:{"click":_vm.clear}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"content-selector",attrs:{"fluid":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[(_vm.env !== 'production')?_c('v-btn',{staticStyle:{"margin-bottom":"50px","margin-right":"10px"},attrs:{"dark":"","fixed":"","bottom":"","color":"pink","right":"","fab":""},on:{"click":function($event){_vm.dialogCreated = true}}},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"persistent":"","mini-variant":_vm.miniVariant,"clipped":_vm.clipped,"enable-resize-watcher":"","fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',_vm._l((_vm.items),function(item,i){return _c('v-list-tile',{key:i,attrs:{"value":"true"}},[_c('v-list-tile-action',[_c('v-icon',{domProps:{"innerHTML":_vm._s(item.icon)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.title)}})],1)],1)}),1)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"color":this.getTheme.color,"dark":""}},[_c('v-toolbar-title',{staticStyle:{"cursor":"pointer"}},[_c('span',{on:{"click":function($event){return _vm.schedule()}}},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.date,_vm.date)))]),_vm._v(" | "),_c('span',{on:{"click":function($event){_vm.dialogSelectCRM = true}}},[_vm._v("CRM: "+_vm._s(_vm.auth.auth.myClinic.crm))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.schedule()}}},[_c('v-icon',[_vm._v("event")])],1)],1),_vm._v(" "),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-subheader',{attrs:{"inset":""}},[_vm._v("Compromissos")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('v-list-tile',{key:item.title,attrs:{"avatar":""},on:{"click":function($event){}}},[_c('v-list-tile-avatar',[_c('v-icon',{class:[item.iconClass]},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.subtitle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Tipo: "+_vm._s(_vm.detailSchedule.typeDesc || _vm.detailSchedule.typeAppontement))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","ripple":""},on:{"click":function($event){return _vm.infoSchedule()}}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("info")])],1)],1)],1)}),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-subheader',{staticStyle:{"cursor":"pointer"},attrs:{"inset":""},on:{"click":function($event){return _vm.schedule()}}},[_vm._v("Horários - Clinic")]),_vm._v(" "),_vm._l((_vm.items2),function(item){return _c('v-list-tile',{key:item.subtitle,attrs:{"avatar":""},on:{"click":function($event){}}},[_c('v-list-tile-avatar',[_c('v-icon',{class:[item.iconClass]},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.subtitle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Tipo: "+_vm._s(item.type))]),_vm._v(" "),(item.typeAppontement)?_c('v-list-tile-sub-title',[_vm._v("Tipo Agend.: "+_vm._s(item.typeAppontement))]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","ripple":""},on:{"click":function($event){return _vm.infoSchedule(item)}}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("info")])],1)],1)],1)}),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-subheader',{staticStyle:{"cursor":"pointer"},attrs:{"inset":""},on:{"click":function($event){return _vm.schedule()}}},[_vm._v("Horários - Centro Cirúrgico")]),_vm._v(" "),_vm._l((_vm.items3),function(item){return _c('v-list-tile',{key:item.subtitle,attrs:{"avatar":""},on:{"click":function($event){}}},[_c('v-list-tile-avatar',[_c('v-icon',{class:[item.iconClass]},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.subtitle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Tipo: "+_vm._s(item.type))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","ripple":""},on:{"click":function($event){return _vm.infoSchedule(item)}}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("info")])],1)],1)],1)})],2)],1),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.getList.length),expression:"getList.length"}]},[_c('chart-agreement')],1),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.getList.length),expression:"getList.length"}]},[_c('chart-type')],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":_vm.getDevice.isMobile,"hide-overlay":_vm.getDevice.isMobile,"transition":"dialog-bottom-transition"},model:{value:(_vm.infoScheduleModal),callback:function ($$v) {_vm.infoScheduleModal=$$v},expression:"infoScheduleModal"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closeModalInfo()}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Dados")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){return _vm.closeModalInfo()}}},[_vm._v("Sair")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-tabs',{attrs:{"centered":"","color":this.getTheme.color,"dark":"","icons-and-text":""}},[_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-1"},on:{"click":function($event){return _vm.getListRecordItem(_vm.detailSchedule.code)}}},[_vm._v("\n              Perfil\n              "),_c('v-icon',[_vm._v("account_box")])],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-2"},on:{"click":function($event){return _vm.getListRecordItem(_vm.detailSchedule.code)}}},[_vm._v("\n              Prontuário\n              "),_c('v-icon',[_vm._v("favorite")])],1),_vm._v(" "),_c('v-tab',{attrs:{"target":"_blank","href":'https://telemedicina.gestaoclinic.com.br/?token=' + _vm.auth.auth.user.crm + '&idExterno=' + _vm.detailSchedule.code}},[_vm._v("\n              Telemedicina\n              "),_c('v-icon',[_vm._v("duo")])],1),_vm._v(" "),_c('v-tab-item',{key:1,attrs:{"value":'tab-1'}},[_c('v-card',[_c('v-img',{attrs:{"src":"https://cdn.onlinewebfonts.com/svg/img_568657.png","height":"350px"}},[_c('v-layout',{attrs:{"column":"","fill-height":""}},[_c('v-card-title'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-title',{staticClass:"white--text pl-5 pt-5"},[_c('div',{staticClass:"display-1 pl-5 pt-5"},[_vm._v(_vm._s(_vm.detailSchedule.title))])])],1)],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":this.getTheme.color}},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{attrs:{"href":'tel:' + _vm.detailSchedule.mobile}},[_vm._v(_vm._s(_vm.detailSchedule.mobile))])]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Celular")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('a',{attrs:{"href":'sms:' + _vm.detailSchedule.mobile}},[_c('v-icon',[_vm._v("chat")])],1)])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":this.getTheme.color}},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{attrs:{"href":'tel:' + _vm.detailSchedule.mobile}},[_vm._v(_vm._s(_vm.detailSchedule.mobile))])]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Celular")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('a',{attrs:{"target":"_blank","href":'https://wa.me/' + _vm.detailSchedule.mobile + '?text=Link para acessar Telemedicina'}},[_c('i',{staticClass:"fab fa-whatsapp fa-lg"})])])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":this.getTheme.color}},[_vm._v("bookmark")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailSchedule.typeDesc || _vm.detailSchedule.typeAppontement))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Tipo Agendamento")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":this.getTheme.color}},[_vm._v("mail")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailSchedule.email || 'nao@informado.com'))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("E-Mail")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('a',{attrs:{"href":'mailto:' + _vm.detailSchedule.email}},[_c('v-icon',[_vm._v("mail")])],1)])],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":this.getTheme.color}},[_vm._v("local_hospital")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Convênio")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.detailSchedule.convenantDesc))])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:2,attrs:{"value":'tab-2'}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.newRecord),expression:"!newRecord"}],staticClass:"btn-record",attrs:{"absolute":"","top":"","color":"pink","right":"","fab":""},on:{"click":function($event){_vm.newRecord = true}}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.newRecord),expression:"newRecord"}]},[_c('new-record',{on:{"close":function($event){return _vm.closeNewRecord()}}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.newRecord),expression:"!newRecord"}]},[(!_vm.getDevice.isMobile)?_c('v-timeline',_vm._l((_vm.itensRecord),function(item,i){return _c('v-timeline-item',{key:i,attrs:{"color":item.color,"small":""},scopedSlots:_vm._u([{key:"opposite",fn:function(){return [_c('span',{class:("headline font-weight-bold " + (item.color) + "--text"),domProps:{"textContent":_vm._s(item.date)}})]},proxy:true}],null,true)},[_vm._v(" "),_c('div',{staticClass:"py-4"},[_c('h2',{class:("headline font-weight-light mb-4 " + (item.color) + "--text")},[_vm._v(_vm._s(item.doctor))]),_vm._v(" "),_c('div',[_vm._v("\n                        "+_vm._s(item.history)+"\n                      ")])])])}),1):_vm._e(),_vm._v(" "),_vm._l((_vm.itensRecord),function(item,i){return _c('v-timeline',{directives:[{name:"show",rawName:"v-show",value:(_vm.getDevice.isMobile),expression:"getDevice.isMobile"}],key:i,attrs:{"align-top":"","dense":""}},[_c('v-timeline-item',{attrs:{"color":"pink","small":""}},[_c('v-layout',{attrs:{"pt-3":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('strong',[_vm._v(_vm._s(item.date))])]),_vm._v(" "),_c('v-flex',[_c('strong',[_vm._v(_vm._s(item.doctor))]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(item.history))])])],1)],1)],1)})],2)],1),_vm._v(" "),_c('v-tab-item',{key:3,attrs:{"value":'tab-3'}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"info","flat":""},on:{"click":function($event){return _vm.closeModalInfo()}}},[_vm._v("\n          Sair\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":_vm.getDevice.isMobile,"hide-overlay":_vm.getDevice.isMobile},model:{value:(_vm.infoScheduleModalFree),callback:function ($$v) {_vm.infoScheduleModalFree=$$v},expression:"infoScheduleModalFree"}},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.infoScheduleModalFree = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Dados")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){_vm.infoScheduleModalFree = false}}},[_vm._v("Sair")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',[_c('v-img',{attrs:{"src":"https://cdn.onlinewebfonts.com/svg/img_568657.png","height":"350px"}},[_c('v-layout',{attrs:{"column":"","fill-height":""}},[_c('v-card-title'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-title',{staticClass:"white--text pl-5 pt-5"},[_c('div',{staticClass:"display-1 pl-5 pt-5"},[_vm._v(_vm._s(_vm.detailSchedule.title))])])],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(this.detailTypeAppontament.title))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(this.detailTypeAppontament.desc))]),_vm._v(" "),_c('v-spacer')],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"orange"},on:{"click":function($event){return _vm.blockAppontament(_vm.detailSchedule)}}},[_vm._v("\n          "+_vm._s(this.detailTypeAppontament.buttonOk)+"\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"info"},on:{"click":function($event){_vm.infoScheduleModalFree = false}}},[_vm._v("\n          Sair\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{ref:"dialog",attrs:{"return-value":_vm.date,"persistent":"","lazy":"","full-width":"","width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-date-picker',{attrs:{"scrollable":"","locale":"pt-br","color":this.getTheme.color,"events":_vm.functionEvents},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":this.getTheme.color},on:{"click":function($event){_vm.modal = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":this.getTheme.color},on:{"click":function($event){return _vm.appointments(_vm.date)}}},[_vm._v("OK")])],1)],1),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('v-dialog',{model:{value:(_vm.dialogSelectCRM),callback:function ($$v) {_vm.dialogSelectCRM=$$v},expression:"dialogSelectCRM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("\n          Selecione a agenda que vai visualizar\n        ")]),_vm._v(" "),_c('v-card-text',[_c('change-schedule')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.dialogSelectCRM = false}}},[_vm._v("\n            Cancelar\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogCreated),callback:function ($$v) {_vm.dialogCreated=$$v},expression:"dialogCreated"}},[_c('create-schedule')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_change_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eeaa3d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_vue__ = __webpack_require__(360);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_change_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eeaa3d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('p',{staticClass:"display-1 text-no-wrap text-md-center font-weight-thin font-italic"}),_vm._v(" "),_c('v-card',[_c('v-card',[_c('v-toolbar',{attrs:{"color":this.getTheme.color,"dark":""}},[_c('v-toolbar-side-icon'),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Selecionar Agenda")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{attrs:{"to":"/update-schedule"}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("update")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Atualizar agendas")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},_vm._l((_vm.auth.customers),function(item,index){return _c('div',{key:index},[_c('v-list-tile',{attrs:{"avatar":"","ripple":""},on:{"click":function($event){return _vm.toggle(index, item.myClinic)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Clinica/Hosp.: "+_vm._s(item.myClinic.customerName))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v("Nome: "+_vm._s(item.myClinic.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',[_vm._v("CRM/ID:")]),_vm._v(" "+_vm._s(item.myClinic.crm))])],1),_vm._v(" "),_c('v-list-tile-action')],1),_vm._v(" "),(index + 1 < _vm.auth.customers.length)?_c('v-divider'):_vm._e()],1)}),0)],1),_vm._v(" "),_c('v-card-actions',[_c('router-link',{attrs:{"to":"/schedule"}},[_c('v-btn',{attrs:{"flat":"","color":"orange"}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_new_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50590a88_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_new_vue__ = __webpack_require__(373);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_new_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50590a88_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_new_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88998d16_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(363);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88998d16_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticClass:"mx-auto"},[_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":"","fill-height":""}},[_c('v-card-title',{staticClass:"pl-5 pt-5"},[_c('div',{staticClass:"display-1 pl-5 pt-5"},[_vm._v(_vm._s(_vm.item.name)+" ")])])],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('a',{attrs:{"href":'tel:' + _vm.item.mobile}},[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("phone")])],1)]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{attrs:{"href":'tel:' + _vm.item.mobile}},[_vm._v(_vm._s(_vm.item.mobile))])]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Celular")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('a',{attrs:{"href":'sms:' + _vm.item.mobile}},[_c('v-icon',[_vm._v("chat")])],1)])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action'),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.item.dateOfBirth))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Data Nasc.")])],1),_vm._v(" "),_c('v-list-tile-action')],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("mail")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.item.email))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("E-mail")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('a',{attrs:{"href":'mailto:' + _vm.item.email}},[_c('v-icon',[_vm._v("mail")])],1)])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action'),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.item.covenant))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Convênio")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("location_on")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.item.addrees))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.item.city))])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e82663e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(365);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e82663e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticClass:"mx-auto"},[_c('v-card',{attrs:{"dark":"","flat":""}},[_c('v-btn',{attrs:{"absolute":"","bottom":"","color":"pink","right":"","fab":""},on:{"click":function($event){_vm.dialog = true}}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-img',{attrs:{"src":"https://cdn.vuetifyjs.com/images/cards/forest.jpg","width":"100%","gradient":"to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('strong',{staticClass:"display-4 font-weight-regular mr-4"},[_vm._v(_vm._s(_vm.dateToday))]),_vm._v(" "),_c('v-layout',{attrs:{"column":"","justify-end":""}},[_c('div',{staticClass:"headline font-weight-light"},[_vm._v(_vm._s(_vm.dateWeek))]),_vm._v(" "),_c('div',{staticClass:"text-uppercase font-weight-light"},[_vm._v(_vm._s(_vm.dateMonthYear))])])],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"py-0"},_vm._l((_vm.items),function(item,i){return _c('v-timeline',{key:i,attrs:{"align-top":"","dense":""}},[_c('v-timeline-item',{attrs:{"color":"pink","small":""}},[_c('v-layout',{attrs:{"pt-3":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('strong',[_vm._v(_vm._s(item.date))])]),_vm._v(" "),_c('v-flex',[_c('strong',[_vm._v(_vm._s(item.doctor))]),_vm._v(" "),_c('pre',{staticClass:"caption"},[_vm._v(_vm._s(item.history))])])],1)],1)],1)}),1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"500","fullscreen":_vm.getDevice.isMobile,"hide-overlay":_vm.getDevice.isMobile},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Dados")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Sair")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('new-record')],1),_vm._v(" "),_c('v-divider')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62585ce2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(367);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62585ce2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticClass:"mx-auto"},[_c('v-card',{attrs:{"dark":"","flat":""}},[_c('v-img',{attrs:{"src":"https://storage.googleapis.com/spitzer-risc-logos/Laudo-Medico.jpg","width":"400","gradient":"to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('strong',{staticClass:"display-4 font-weight-regular mr-4"},[_vm._v(_vm._s(_vm.dateToday))]),_vm._v(" "),_c('v-layout',{attrs:{"column":"","justify-end":""}},[_c('div',{staticClass:"headline font-weight-light"},[_vm._v(_vm._s(_vm.dateWeek))]),_vm._v(" "),_c('div',{staticClass:"text-uppercase font-weight-light"},[_vm._v(_vm._s(_vm.dateMonthYear))])])],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"py-0"},_vm._l((_vm.items),function(item,i){return _c('v-timeline',{key:i,attrs:{"align-top":"","dense":""}},[_c('v-timeline-item',{attrs:{"color":"pink","small":""}},[_c('v-layout',{attrs:{"pt-3":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('strong',[_vm._v(_vm._s(item.date))])]),_vm._v(" "),_c('v-flex',[_c('strong',[_vm._v(" "+_vm._s(item.doctor))]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(item.history))])])],1)],1)],1)}),1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"500","fullscreen":_vm.getDevice.isMobile,"hide-overlay":_vm.getDevice.isMobile},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Dados")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Sair")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text'),_vm._v(" "),_c('v-divider')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_625dc1d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(370);
function injectStyle (ssrContext) {
  __webpack_require__(369)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-625dc1d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_625dc1d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',[_c('v-card-title',{staticClass:"indigo white--text headline"},[_vm._v("\n      Anexos do paciente\n    ")]),_vm._v(" "),_c('v-treeview',{attrs:{"active":_vm.active,"items":_vm.items,"load-children":_vm.fetchUsers,"open":_vm.open,"activatable":"","color":"warning","open-on-click":"","transition":""},on:{"update:active":function($event){_vm.active=$event},"update:open":function($event){_vm.open=$event}},scopedSlots:_vm._u([{key:"prepend",fn:function(ref){
var item = ref.item;
return [(!item.file)?_c('v-icon',{on:{"click":function($event){return _vm.fetchUsers()}}},[_vm._v("folder")]):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":'https://sync.gestaoclinic.com.br/get?bucket=' + _vm.getPatient.bucket + '&key=' + item.path,"target":"_blank"}},[_c('v-icon',[_vm._v(_vm._s(_vm.files[item.file]))])],1)]}}])}),_vm._v(" "),_c('v-divider',{attrs:{"vertical":""}}),_vm._v(" "),_c('v-scroll-y-transition',{attrs:{"mode":"out-in"}},[(_vm.selected)?_c('v-card',{key:_vm.selected.id,staticClass:"pt-6 mx-auto",attrs:{"flat":""}},[_c('h3',{staticClass:"headline mb-2"},[_vm._v("\n              Selecione as imagem para abrir em outra janela maior, caso seja pdf, xls ou doc, click no link\n            ")]),_vm._v(" "),_c('v-card-text',[(_vm.selected.file === 'jpg')?_c('div',[_c('a',{attrs:{"href":'https://sync.gestaoclinic.com.br/get?bucket=' + _vm.getPatient.bucket + '&key=' + _vm.selected.path,"target":"_blank"}},[_c('v-img',{staticClass:"mb-6",attrs:{"src":("https://sync.gestaoclinic.com.br/get?bucket=" + (_vm.getPatient.bucket) + "&key=" + (_vm.selected.path))}})],1)]):_c('div',[_c('a',{attrs:{"href":'https://sync.gestaoclinic.com.br/get?bucket=' + _vm.getPatient.bucket + '&key=' + _vm.selected.path,"target":"_blank"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v(_vm._s(_vm.files[_vm.selected.file]))]),_vm._v("\n                  Nome: "+_vm._s(_vm.selected.name)+"\n                ")],1)])]),_vm._v(" "),_c('v-divider')],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2b1b43e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__(372);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2b1b43e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"blue darken-4","dark":""}},[_c('v-toolbar-title',[_vm._v("Cirurgias propostas")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.getProposedSurgeries),function(item,index){return [_c('v-list-tile',{key:index,attrs:{"avatar":"","ripple":""},on:{"click":function($event){return _vm.toggle(index)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v("Status: "+_vm._s(item.headline))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Cirurgia: "+_vm._s(item.subtitle))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-list-tile-action-text',[_vm._v("Horário "+_vm._s(item.action))])],1)],1),_vm._v(" "),(index + 1 < _vm.items.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-bottom":"38px","margin-right":"10px"},attrs:{"color":"pink","dark":"","absolute":"","bottom":"","right":"","fab":""},on:{"click":function($event){_vm.dialogCreated = true}}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogCreated),callback:function ($$v) {_vm.dialogCreated=$$v},expression:"dialogCreated"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":this.getTheme.color,"prominent":"","tabs":"","dark":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-form',{ref:"form",attrs:{"action":"#","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.sendMessage()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sendMessage()}}},[_c('v-text-field',{ref:"name",attrs:{"color":"white","dark":"","append-icon":_vm.model ? 'arrow_back' : '',"append-outer-icon":_vm.message ? 'mdi-send' : 'search',"prepend-icon":_vm.icon,"box":"","clear-icon":"mdi-close-circle","clearable":"","label":_vm.changeLabel,"type":"text"},on:{"click:append":_vm.toggleMarker,"click:append-outer":_vm.sendMessage,"click:prepend":_vm.changeIcon,"click:clear":_vm.clearMessage},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1)],1),_vm._v(" "),(_vm.model)?_c('v-tabs',{attrs:{"slot":"extension","hide-slider":!_vm.model,"color":"transparent","slider-color":"blue-grey"},slot:"extension"},[_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-1","ripple":""},on:{"click":function($event){$event.preventDefault();return _vm.show(1)}},model:{value:(_vm.navigation),callback:function ($$v) {_vm.navigation=$$v},expression:"navigation"}},[_vm._v("Perfil")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-2","ripple":""},on:{"click":function($event){$event.preventDefault();return _vm.show(2)}},model:{value:(_vm.navigation),callback:function ($$v) {_vm.navigation=$$v},expression:"navigation"}},[_vm._v("Prontuário")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-3","ripple":""},on:{"click":function($event){$event.preventDefault();return _vm.show(3)}},model:{value:(_vm.navigation),callback:function ($$v) {_vm.navigation=$$v},expression:"navigation"}},[_vm._v("Laudos")]),_vm._v(" "),(_vm.env !== 'production')?_c('v-tab',{attrs:{"href":"#tab-4","ripple":""},on:{"click":function($event){$event.preventDefault();return _vm.show(4)}},model:{value:(_vm.navigation),callback:function ($$v) {_vm.navigation=$$v},expression:"navigation"}},[_vm._v("Anexos")]):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingOk === true),expression:"loadingOk === true"}],attrs:{"indeterminate":true}}),_vm._v(" "),(!_vm.model)?_c('v-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.listVisible),expression:"listVisible"}],attrs:{"two-line":""}},[_vm._l((_vm.items),function(item,index){return [(item.header)?_c('v-subheader',{key:item.header},[_vm._v("\n                  Selecione o nome\n                  ")]):(item.divider)?_c('v-divider',{key:index,attrs:{"inset":item.inset}}):_c('v-list-tile',{key:item.id,attrs:{"avatar":""},on:{"click":function($event){return _vm.selectPatient(item)}}},[_c('v-list-tile-avatar',{attrs:{"color":"indigo"}},[_c('span',{staticClass:"white--text headline"},[_vm._v(_vm._s(item.symbol))])]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.dateOfBirth)}})],1)],1)]})],2):_vm._e(),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.profile),expression:"profile"}],attrs:{"row":""}},[_c('profile-patient')],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.record),expression:"record"}],attrs:{"row":""}},[_c('record-patient')],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.examinationReport),expression:"examinationReport"}],attrs:{"row":""}},[_c('examination-report')],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.image),expression:"image"}],attrs:{"row":""}},[_c('image-patient')],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36ab559c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(379);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36ab559c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"color":"red lighten-2","dark":""}},[_c('v-card-title',{staticClass:"headline red lighten-3"},[_vm._v("\n    Search for Public APIs\n  ")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n    Explore hundreds of free API's ready for consumption! For more information visit\n    "),_c('a',{staticClass:"grey--text text--lighten-3",attrs:{"href":"https://github.com/toddmotto/public-apis","target":"_blank"}},[_vm._v("the Github repository")]),_vm._v(".\n  ")]),_vm._v(" "),_c('v-card-text',[_c('v-autocomplete',{attrs:{"items":_vm.items,"loading":_vm.isLoading,"search-input":_vm.search,"color":"white","hide-no-data":"","hide-selected":"","item-text":"Description","item-value":"API","label":"Public APIs","placeholder":"Start typing to Search","prepend-icon":"mdi-database-search","return-object":""},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-expand-transition',[(_vm.model)?_c('v-list',{staticClass:"red lighten-3"},_vm._l((_vm.fields),function(field,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(field.value)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"textContent":_vm._s(field.key)}})],1)],1)}),1):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.model,"color":"grey darken-3"},on:{"click":function($event){_vm.model = null}}},[_vm._v("\n      Clear\n      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-close-circle")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"min-width":"310px","max-width":"800px","height":"400px","margin":"0 auto"},attrs:{"id":"container"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdc2f32c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(381);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdc2f32c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grey lighten-3",staticStyle:{"max-width":"400px","margin":"auto"},attrs:{"id":"e3"}},[_c('v-card',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"blue-grey darken-2"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Unlimited music now")]),_vm._v(" "),_c('div',[_vm._v("Listen to your favorite artists and albums whenever and wherever, online and offline.")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","dark":""}},[_vm._v("Listen now")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"cyan darken-2"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs5":""}},[_c('v-card-media',{attrs:{"src":"https://cdn.vuetifyjs.com/images/cards/foster.jpg","height":"125px","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("Supermodel")]),_vm._v(" "),_c('div',[_vm._v("Foster the People")]),_vm._v(" "),_c('div',[_vm._v("(2014)")])])])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-3"},[_vm._v("\n                Rate this album\n                "),_c('v-spacer'),_vm._v(" "),_c('v-icon',[_vm._v("star_border")]),_vm._v(" "),_c('v-icon',[_vm._v("star_border")]),_vm._v(" "),_c('v-icon',[_vm._v("star_border")]),_vm._v(" "),_c('v-icon',[_vm._v("star_border")]),_vm._v(" "),_c('v-icon',[_vm._v("star_border")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"purple"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("Halycon Days")]),_vm._v(" "),_c('div',[_vm._v("Ellie Goulding")]),_vm._v(" "),_c('div',[_vm._v("(2013)")])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-card-media',{attrs:{"src":"https://cdn.vuetifyjs.com/images/cards/halcyon.png","height":"125px","contain":""}})],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-3"},[_vm._v("\n                Rate this album\n                "),_c('v-spacer'),_vm._v(" "),_c('v-icon',[_vm._v("star_border")]),_vm._v(" "),_c('v-icon',[_vm._v("star_border")]),_vm._v(" "),_c('v-icon',[_vm._v("star_border")]),_vm._v(" "),_c('v-icon',[_vm._v("star_border")]),_vm._v(" "),_c('v-icon',[_vm._v("star_border")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48ed64a9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(383);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48ed64a9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('v-img',{attrs:{"src":"https://storage.googleapis.com/spitzer-risc-logos/agendamento.jpg","height":"300px"}},[_c('v-layout',{attrs:{"column":"","fill-height":""}},[_c('v-card-title',[_c('v-btn',{attrs:{"dark":"","icon":""}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"dark":"","icon":""}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":""}},[_c('v-icon',[_vm._v("more_vert")])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-title',{staticClass:"white--text pl-5 pt-5"},[_c('div',{staticClass:"display-1 pl-5 pt-5"})])],1)],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("mail")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.profile.email))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Personal")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f1e9dc6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(410);
function injectStyle (ssrContext) {
  __webpack_require__(385)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f1e9dc6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_week_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_649eadcc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_week_vue__ = __webpack_require__(388);
function injectStyle (ssrContext) {
  __webpack_require__(387)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-649eadcc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_week_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_649eadcc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_week_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',[_c('v-sheet',{attrs:{"height":"400"}},[_c('v-calendar',{ref:"calendar",attrs:{"now":_vm.today,"value":_vm.today,"color":"primary","type":"week"},scopedSlots:_vm._u([{key:"dayHeader",fn:function(ref){
var date = ref.date;
return [_vm._l((_vm.eventsMap[date]),function(event){return [(!event.time)?_c('div',{key:event.title,staticClass:"my-event",domProps:{"innerHTML":_vm._s(event.title)},on:{"click":function($event){return _vm.open(event)}}}):_vm._e()]})]}},{key:"dayBody",fn:function(ref){
var date = ref.date;
var timeToY = ref.timeToY;
var minutesToPixels = ref.minutesToPixels;
return [_vm._l((_vm.eventsMap[date]),function(event){return [(event.time)?_c('div',{key:event.title,staticClass:"my-event with-time",style:({ top: timeToY(event.time) + 'px', height: minutesToPixels(event.duration) + 'px' }),domProps:{"innerHTML":_vm._s(event.title)},on:{"click":function($event){return _vm.open(event)}}}):_vm._e()]})]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_completed_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10fd1b78_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_completed_vue__ = __webpack_require__(391);
function injectStyle (ssrContext) {
  __webpack_require__(390)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10fd1b78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_completed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10fd1b78_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_completed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',{attrs:{"id":"inspire"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"pa-3 mb-3 feature-pane",attrs:{"sm12":"","lg3":""}},[_c('v-btn',{attrs:{"fab":"","outline":"","small":"","absolute":"","left":"","color":"primary"},on:{"click":function($event){return _vm.$refs.calendar.prev()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n            keyboard_arrow_left\n          ")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","outline":"","small":"","absolute":"","right":"","color":"primary"},on:{"click":function($event){return _vm.$refs.calendar.next()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n            keyboard_arrow_right\n          ")])],1),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.typeOptions,"label":"Type"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Dark"},model:{value:(_vm.dark),callback:function ($$v) {_vm.dark=$$v},expression:"dark"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.colorOptions,"label":"Color"},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}}),_vm._v(" "),_c('v-menu',{ref:"startMenu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.start,"transition":"scale-transition","min-width":"290px","lazy":"","offset-y":"","full-width":""},on:{"update:returnValue":function($event){_vm.start=$event},"update:return-value":function($event){_vm.start=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Start Date","prepend-icon":"event","readonly":""},model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}},on))]}}]),model:{value:(_vm.startMenu),callback:function ($$v) {_vm.startMenu=$$v},expression:"startMenu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.startMenu = false}}},[_vm._v("\n              Cancel\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.startMenu.save(_vm.start)}}},[_vm._v("\n              OK\n            ")])],1)],1),_vm._v(" "),(_vm.hasEnd)?_c('v-menu',{ref:"endMenu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.end,"transition":"scale-transition","min-width":"290px","lazy":"","offset-y":"","full-width":""},on:{"update:returnValue":function($event){_vm.end=$event},"update:return-value":function($event){_vm.end=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"End Date","prepend-icon":"event","readonly":""},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}},on))]}}],null,false,2241163769),model:{value:(_vm.endMenu),callback:function ($$v) {_vm.endMenu=$$v},expression:"endMenu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.endMenu = false}}},[_vm._v("\n              Cancel\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.endMenu.save(_vm.end)}}},[_vm._v("\n              OK\n            ")])],1)],1):_vm._e(),_vm._v(" "),_c('v-menu',{ref:"nowMenu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.now,"transition":"scale-transition","min-width":"290px","lazy":"","offset-y":"","full-width":""},on:{"update:returnValue":function($event){_vm.now=$event},"update:return-value":function($event){_vm.now=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Today","prepend-icon":"event","readonly":""},model:{value:(_vm.now),callback:function ($$v) {_vm.now=$$v},expression:"now"}},on))]}}]),model:{value:(_vm.nowMenu),callback:function ($$v) {_vm.nowMenu=$$v},expression:"nowMenu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.now),callback:function ($$v) {_vm.now=$$v},expression:"now"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.nowMenu = false}}},[_vm._v("\n              Cancel\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.nowMenu.save(_vm.now)}}},[_vm._v("\n              OK\n            ")])],1)],1),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.weekdaysOptions,"label":"Weekdays"},model:{value:(_vm.weekdays),callback:function ($$v) {_vm.weekdays=$$v},expression:"weekdays"}}),_vm._v(" "),(_vm.type === 'custom-weekly')?_c('v-text-field',{attrs:{"label":"Minimum Weeks","type":"number"},model:{value:(_vm.minWeeks),callback:function ($$v) {_vm.minWeeks=$$v},expression:"minWeeks"}}):_vm._e(),_vm._v(" "),(_vm.hasIntervals)?_c('v-select',{attrs:{"items":_vm.intervalsOptions,"label":"Intervals"},model:{value:(_vm.intervals),callback:function ($$v) {_vm.intervals=$$v},expression:"intervals"}}):_vm._e(),_vm._v(" "),(_vm.type === 'custom-daily')?_c('v-select',{attrs:{"items":_vm.maxDaysOptions,"label":"# of Days"},model:{value:(_vm.maxDays),callback:function ($$v) {_vm.maxDays=$$v},expression:"maxDays"}}):_vm._e(),_vm._v(" "),(_vm.hasIntervals)?_c('v-select',{attrs:{"items":_vm.styleIntervalOptions,"label":"Styling"},model:{value:(_vm.styleInterval),callback:function ($$v) {_vm.styleInterval=$$v},expression:"styleInterval"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-3",attrs:{"sm12":"","lg9":""}},[_c('v-sheet',{attrs:{"height":"500"}},[_c('v-calendar',{ref:"calendar",attrs:{"type":_vm.type,"start":_vm.start,"end":_vm.end,"min-weeks":_vm.minWeeks,"max-days":_vm.maxDays,"now":_vm.now,"dark":_vm.dark,"weekdays":_vm.weekdays,"first-interval":_vm.intervals.first,"interval-minutes":_vm.intervals.minutes,"interval-count":_vm.intervals.count,"interval-height":_vm.intervals.height,"interval-style":_vm.intervalStyle,"show-interval-label":_vm.showIntervalLabel,"color":_vm.color},scopedSlots:_vm._u([{key:"day",fn:function(day){return [(day.day % 3 === 0)?_c('div',{staticClass:"day"},[_vm._v("\n                day slot "+_vm._s(day.date)+"\n              ")]):_vm._e()]}},{key:"header",fn:function(day){return [(day.weekday % 2)?_c('div',{staticClass:"day-header"},[_vm._v("\n                day-header slot "+_vm._s(day.date)+"\n              ")]):_vm._e()]}},{key:"day-body",fn:function(day){return [(day.weekday % 3 === 2)?_c('div',{staticClass:"day-body"},[_vm._v("\n                day-body slot "+_vm._s(day.date)+"\n              ")]):_vm._e()]}}]),model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}}),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"transparent","flat":""}},[_c('v-toolbar-title',[_vm._v("Período: "+_vm._s(_vm.period.start)+" até "+_vm._s(_vm.period.end))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("more_vert")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.covenant))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.mount))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("currency")(props.item.value)))])]}}])})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e8d287e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(412);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e8d287e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Configurações")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-list',[_c('v-card-text',[_c('v-subheader',[_vm._v("Redefinir senha")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"action":"#","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"E-Mail","rules":[function (v) { return !!v || 'Você deve informar um e-mail!'; }],"required":"","disabled":""},model:{value:(_vm.authentication.username),callback:function ($$v) {_vm.$set(_vm.authentication, "username", $$v)},expression:"authentication.username"}}),_vm._v(" "),_c('v-text-field',{ref:"password",staticClass:"password",attrs:{"name":"input-10-1","label":"Entre com sua senha","hint":"Deve conter mais de 6 caracteres","min":"6","rules":[function (v) { return !!v || 'Você deve informar a sua senha!'; }],"required":"","append-icon":_vm.p1 ? 'visibility_off' : 'visibility',"type":_vm.p1 ? 'password' : 'text',"counter":"","color":"cyan darken","loading":""},on:{"click:append":function($event){_vm.p1 = !_vm.p1}},model:{value:(_vm.authentication.password),callback:function ($$v) {_vm.$set(_vm.authentication, "password", $$v)},expression:"authentication.password"}},[(_vm.custom)?_c('v-progress-linear',{attrs:{"slot":"progress","value":_vm.progress,"height":"8","color":_vm.color},slot:"progress"}):_vm._e()],1),_vm._v(" "),_c('v-text-field',{staticClass:"password",attrs:{"type":"password","label":"Confirme sua senha","rules":[function (v) { return !!v || 'Você deve informar a senha!'; }],"required":""},model:{value:(_vm.authentication.confpass),callback:function ($$v) {_vm.$set(_vm.authentication, "confpass", $$v)},expression:"authentication.confpass"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":"","disabled":!_vm.valid},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n              Alterar senha\n            ")])],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n        "+_vm._s(_vm.snackbarConfig.text)+"\n        "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sing_up_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19527adc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sing_up_vue__ = __webpack_require__(414);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sing_up_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19527adc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sing_up_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"display-1 text-no-wrap text-md-center font-weight-thin font-italic"}),_vm._v(" "),_c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"500"}},[_c('v-img',{staticClass:"grey lighten-2",attrs:{"src":"https://storage.googleapis.com/spitzer-risc-logos/new-clinic-little.png","lazy-src":"https://picsum.photos/id/11/10/6"}}),_vm._v(" "),_c('div',{staticClass:"backgroud-logo logo"}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-select',{ref:"customerId",attrs:{"items":_vm.items,"item-text":"name","item-value":"id","rules":[function (v) { return !!v || 'Clinica/Hospital é Obrigatório!'; }],"label":"Clinica/Hospital","required":"","return-object":""},model:{value:(_vm.auth.customerId),callback:function ($$v) {_vm.$set(_vm.auth, "customerId", $$v)},expression:"auth.customerId"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.emailRules,"label":"E-mail","required":""},model:{value:(_vm.auth.username),callback:function ($$v) {_vm.$set(_vm.auth, "username", $$v)},expression:"auth.username"}}),_vm._v(" "),_c('v-text-field',{attrs:{"counter":8,"rules":_vm.crmRules,"label":"CRM","required":""},model:{value:(_vm.auth.crm),callback:function ($$v) {_vm.$set(_vm.auth, "crm", $$v)},expression:"auth.crm"}}),_vm._v(" "),_c('v-text-field',{attrs:{"counter":40,"rules":_vm.nameRules,"label":"Nome","required":""},model:{value:(_vm.auth.name),callback:function ($$v) {_vm.$set(_vm.auth, "name", $$v)},expression:"auth.name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":_vm.showPass ? 'visibility' : 'visibility_off',"rules":[_vm.rules.required, _vm.rules.min],"type":_vm.showPass ? 'text' : 'password',"name":"password","label":"Senha","hint":"O ideal é ter mais de 8 caracteres!","counter":"","loading":""},on:{"click:append":function($event){_vm.showPass = !_vm.showPass}},scopedSlots:_vm._u([{key:"progress",fn:function(){return [_c('v-progress-linear',{attrs:{"value":_vm.progress,"color":_vm.color,"height":"7"}})]},proxy:true}]),model:{value:(_vm.auth.password),callback:function ($$v) {_vm.$set(_vm.auth, "password", $$v)},expression:"auth.password"}}),_vm._v(" "),_c('v-text-field',{staticClass:"password",attrs:{"type":"password","label":"Confirme sua senha","rules":[function (v) { return !!v || 'Você deve informar a senha!'; }],"required":""},model:{value:(_vm.auth.confpass),callback:function ($$v) {_vm.$set(_vm.auth, "confpass", $$v)},expression:"auth.confpass"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"rules":[function (v) { return !!v || 'para continuar deve se concordar!'; }],"label":"Você concorda?","required":""},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":"","disabled":!_vm.valid},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n                      Registrar\n                    ")]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":"/auth/login"}},[_c('v-btn',{attrs:{"block":""}},[_vm._v("Retornar para Login")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('div',[_c('p',[_vm._v("© 2017 - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer.io")]),_vm._v(" - Todos os direitos reservados")])])])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n        "+_vm._s(_vm.snackbarConfig.text)+"\n        "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a1685aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(417);
function injectStyle (ssrContext) {
  __webpack_require__(416)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a1685aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a1685aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":"","lg4":""}},[_c('p',{staticClass:"display-1 text-no-wrap text-md-center font-weight-thin font-italic"}),_vm._v(" "),_c('v-card',[_c('v-toolbar',{attrs:{"color":this.getTheme.color,"dark":""}},[_c('v-toolbar-side-icon'),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Selecionar Agenda")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.selectedAll()}}},[_c('v-icon',[_vm._v("check_box")])],1)],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.items),function(item,index){return [_c('v-list-tile',{key:item.title,attrs:{"avatar":"","ripple":""},on:{"click":function($event){return _vm.toggle(index)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Clinica/Hosp.: "+_vm._s(item.clientName))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v("Nome: "+_vm._s(item.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("CRM: "+_vm._s(item.crm))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-list-tile-action-text',[_c('v-checkbox',{model:{value:(item.action),callback:function ($$v) {_vm.$set(item, "action", $$v)},expression:"item.action"}})],1)],1)],1),_vm._v(" "),(index + 1 < _vm.items.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1),_vm._v(" "),_c('v-card',{staticClass:"card-main"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],attrs:{"indeterminate":true}}),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"action":"#","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"E-Mail","rules":[function (v) { return !!v || 'Você deve informar um número de telefone!'; }],"required":"","disabled":""},model:{value:(_vm.auth.username),callback:function ($$v) {_vm.$set(_vm.auth, "username", $$v)},expression:"auth.username"}}),_vm._v(" "),_c('v-checkbox',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"label":"Tamanho da senha"},model:{value:(_vm.custom),callback:function ($$v) {_vm.custom=$$v},expression:"custom"}}),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":_vm.showPass ? 'visibility' : 'visibility_off',"rules":[_vm.rules.required, _vm.rules.min],"type":_vm.showPass ? 'text' : 'password',"name":"password","label":"Senha","hint":"O ideal é ter mais de 8 caracteres!","counter":"","loading":""},on:{"click:append":function($event){_vm.showPass = !_vm.showPass}},scopedSlots:_vm._u([{key:"progress",fn:function(){return [(_vm.custom)?_c('v-progress-linear',{attrs:{"value":_vm.progress,"color":_vm.color,"height":"7"}}):_vm._e()]},proxy:true}]),model:{value:(_vm.auth.password),callback:function ($$v) {_vm.$set(_vm.auth, "password", $$v)},expression:"auth.password"}}),_vm._v(" "),_c('v-text-field',{staticClass:"password",attrs:{"type":"password","label":"Confirme sua senha","rules":[function (v) { return !!v || 'Você deve informar a senha!'; }],"required":""},model:{value:(_vm.auth.confpass),callback:function ($$v) {_vm.$set(_vm.auth, "confpass", $$v)},expression:"auth.confpass"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":"","disabled":!_vm.valid},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n                          Registrar\n                        ")]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":"/auth/login"}},[_c('v-btn',{attrs:{"block":""}},[_vm._v("Retornar para Login")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('div',[_vm._v("© 2017 - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer.io")]),_vm._v(" - Todos os direitos reservados")])])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarConfig.text)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateSchedule_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f42d77e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateSchedule_vue__ = __webpack_require__(420);
function injectStyle (ssrContext) {
  __webpack_require__(419)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f42d77e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateSchedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f42d77e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateSchedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":"","lg4":""}},[_c('p',{staticClass:"display-1 text-no-wrap text-md-center font-weight-thin font-italic"}),_vm._v(" "),_c('v-card',[_c('v-toolbar',{attrs:{"color":this.getTheme.color,"dark":""}},[_c('v-toolbar-side-icon'),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Selecionar Agendas")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.selectedAll()}}},[_c('v-icon',[_vm._v("check_box")])],1)],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.items),function(item,index){return [_c('v-list-tile',{key:item.title,attrs:{"avatar":"","ripple":""},on:{"click":function($event){return _vm.toggle(index)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Clinica/Hosp.: "+_vm._s(item.clientName))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v("Nome: "+_vm._s(item.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("CRM: "+_vm._s(item.crm))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-list-tile-action-text',[_c('v-checkbox',{model:{value:(item.action),callback:function ($$v) {_vm.$set(item, "action", $$v)},expression:"item.action"}})],1)],1)],1),_vm._v(" "),(index + 1 < _vm.items.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1),_vm._v(" "),_c('v-card',{staticClass:"card-main"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],attrs:{"indeterminate":true}}),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"action":"#","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.auth.username),expression:"auth.username"}],attrs:{"label":"E-Mail","rules":[function (v) { return !!v || 'Você deve informar um número de telefone!'; }],"required":"","disabled":""},model:{value:(_vm.auth.username),callback:function ($$v) {_vm.$set(_vm.auth, "username", $$v)},expression:"auth.username"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":"","disabled":!_vm.valid || _vm.loading},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n                          Atualizar\n                        ")])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarConfig.text)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchUser_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fbd9ecf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchUser_vue__ = __webpack_require__(423);
function injectStyle (ssrContext) {
  __webpack_require__(422)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fbd9ecf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fbd9ecf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":"","lg4":""}},[_c('p',{staticClass:"display-1 text-no-wrap text-md-center font-weight-thin font-italic"}),_vm._v(" "),_c('v-card',{staticClass:"card-main"},[_c('v-img',{staticClass:"grey lighten-2",attrs:{"src":"https://storage.googleapis.com/spitzer-risc-logos/new-clinic-little.png","lazy-src":"https://picsum.photos/id/11/10/6"}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingOk === true),expression:"loadingOk === true"}],attrs:{"indeterminate":true}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-text-field',{staticClass:"username",attrs:{"label":"E-Mail/Usuário","counter":40,"rules":[function (v) { return !!v || 'E-mail obrigatório!!'; }],"required":"","prepend-icon":"email"},model:{value:(_vm.auth.username),callback:function ($$v) {_vm.$set(_vm.auth, "username", $$v)},expression:"auth.username"}})],1),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('router-link',{attrs:{"to":"/patient/login"}},[_c('v-btn',{on:{"click":_vm.clear}},[_vm._v("Voltar")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.buttonEnabled},on:{"click":_vm.searchEmail}},[_vm._v("\n                      Avançar\n                    ")])],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n              "+_vm._s(_vm.snackbarConfig.text)+"\n              "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('div',[_vm._v("© "),_c('router-link',{attrs:{"to":"/auth/sing-up"}},[_vm._v("2017")]),_vm._v(" - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer.io")]),_vm._v(" - Todos os direitos reservados")],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_password_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_912cdaa0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_password_vue__ = __webpack_require__(425);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_912cdaa0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":"","lg4":""}},[_c('v-card',[_c('v-img',{attrs:{"src":"https://storage.googleapis.com/spitzer-io/img/Logo%20Spitzer%20icone.png","aspect-ratio":"3.50"}}),_vm._v(" "),_c('div',{staticClass:"backgroud-logo logo"}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-card-text',[_c('p',{staticClass:"text-xs-center title primary--text"},[_vm._v("Redefinir senha")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"action":"#","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"E-Mail","rules":[function (v) { return !!v || 'Você deve informar um número de telefone!'; }],"required":"","disabled":""},model:{value:(_vm.authentication.username),callback:function ($$v) {_vm.$set(_vm.authentication, "username", $$v)},expression:"authentication.username"}}),_vm._v(" "),_c('v-text-field',{ref:"password",staticClass:"password",attrs:{"name":"input-10-1","label":"Entre com sua senha","hint":"Deve conter mais de 6 caracteres","min":"6","rules":[function (v) { return !!v || 'Você deve informar a senha!'; }],"required":"","append-icon":_vm.p1 ? 'visibility_off' : 'visibility',"append-icon-cb":function () { return (_vm.p1 = !_vm.p1); },"type":_vm.p1 ? 'password' : 'text',"counter":"","color":"cyan darken","loading":""},model:{value:(_vm.authentication.password),callback:function ($$v) {_vm.$set(_vm.authentication, "password", $$v)},expression:"authentication.password"}},[(_vm.custom)?_c('v-progress-linear',{attrs:{"slot":"progress","value":_vm.progress,"height":"8","color":_vm.color},slot:"progress"}):_vm._e()],1),_vm._v(" "),_c('v-text-field',{staticClass:"password",attrs:{"type":"password","label":"Confirme sua senha","rules":[function (v) { return !!v || 'Você deve informar a senha!'; }],"required":""},model:{value:(_vm.authentication.confpass),callback:function ($$v) {_vm.$set(_vm.authentication, "confpass", $$v)},expression:"authentication.confpass"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":"","disabled":!_vm.valid},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n                Alterar senha\n              ")]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":"/patient/login"}},[_c('v-btn',{attrs:{"block":""}},[_vm._v("Login")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('div',[_c('p',[_vm._v("© 2017 - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer.io")]),_vm._v(" - Todos os direitos reservados")]),_vm._v(" "),_c('p',[_vm._v("Versão: "+_vm._s(_vm.getPkg.pkg.version))])])])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarConfig.text)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forget_password_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a3399f5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forget_password_vue__ = __webpack_require__(427);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forget_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a3399f5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forget_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('p',{staticClass:"display-1 text-no-wrap text-md-center font-weight-thin font-italic"}),_vm._v(" "),_c('v-card',[_c('v-img',{attrs:{"src":"https://storage.googleapis.com/spitzer-risc-logos/new-clinic.png"}}),_vm._v(" "),_c('div',{staticClass:"backgroud-logo logo"}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-card-text',[_c('p',{staticClass:"text-xs-center title primary--text"},[_vm._v("Recuperação de senha")]),_vm._v(" "),_c('p',{staticClass:"text-xs-center title primary--text"},[_vm._v("\n                  Para recuperar sua senha de acesso, informe no campo abaixo o email utilizado no cadastro.\n                ")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"action":"#","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"E-Mail","rules":[function (v) { return !!v || 'Informe o e-mail cadastrado!'; }],"required":""},model:{value:(_vm.auth.username),callback:function ($$v) {_vm.$set(_vm.auth, "username", $$v)},expression:"auth.username"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":this.getTheme.color,"dark":"","block":""},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n                Recuperar Senha\n              ")]),_vm._v(" "),_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":"/patient/login"}},[_c('v-btn',{attrs:{"block":""}},[_vm._v("Retornar para Login")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('div',[_c('p',[_vm._v("© 2017 - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.spitzer.io"}},[_vm._v("Spitzer.io")]),_vm._v(" - Todos os direitos reservados")]),_vm._v(" "),_c('p',[_vm._v("Versão: "+_vm._s(_vm.getPkg.pkg.version))])])])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n        "+_vm._s(_vm.snackbarConfig.text)+"\n        "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_surgery_center_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_471c1ca2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_surgery_center_vue__ = __webpack_require__(438);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_surgery_center_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_471c1ca2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_surgery_center_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f023ce3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_create_vue__ = __webpack_require__(437);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f023ce3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closedDialog()}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Agendamento")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","offset-sm3":""}},[_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-subheader',[_vm._v("Horário")]),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Selecione a hora*")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('v-flex',{attrs:{"xs11":"","sm5":""}},[_c('v-dialog',{ref:"dialog",attrs:{"return-value":_vm.proposedSurgeries.time,"persistent":"","lazy":"","full-width":"","width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.proposedSurgeries, "time", $event)},"update:return-value":function($event){return _vm.$set(_vm.proposedSurgeries, "time", $event)}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Hora para cirurgia","prepend-icon":"access_time","readonly":""},model:{value:(_vm.proposedSurgeries.time),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "time", $$v)},expression:"proposedSurgeries.time"}},on))]}}]),model:{value:(_vm.modal2),callback:function ($$v) {_vm.modal2=$$v},expression:"modal2"}},[_vm._v(" "),(_vm.modal2)?_c('v-time-picker',{attrs:{"full-width":""},model:{value:(_vm.proposedSurgeries.time),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "time", $$v)},expression:"proposedSurgeries.time"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.modal2 = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.dialog.save(_vm.proposedSurgeries.time)}}},[_vm._v("OK")])],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Selecione a Data")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('v-flex',{attrs:{"xs12":"","lg6":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Data para cirurgia","persistent-hint":"","prepend-icon":"event","readonly":""},model:{value:(_vm.computedDateFormatted),callback:function ($$v) {_vm.computedDateFormatted=$$v},expression:"computedDateFormatted"}},on))]}}]),model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_vm._v(" "),_c('p',[_vm._v("Date in ISO format: "),_c('strong',[_vm._v(_vm._s(_vm.date))])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.alertVisible,"color":"error"}},[_vm._v("\n            "+_vm._s(_vm.alertTextRequired)+"\n          ")]),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarConfig.timeout,"color":_vm.snackbarConfig.color,"multi-line":_vm.snackbarConfig.mode === 'multi-line',"vertical":_vm.snackbarConfig.mode === 'vertical'},model:{value:(_vm.snackbarConfig.snackbar),callback:function ($$v) {_vm.$set(_vm.snackbarConfig, "snackbar", $$v)},expression:"snackbarConfig.snackbar"}},[_vm._v("\n            "+_vm._s(_vm.snackbarConfig.text)+"\n            "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarConfig.snackbar = false}}},[_vm._v("Fechar")])],1),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"action":"#","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.save()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","offset-sm3":""}},[_c('v-checkbox',{attrs:{"label":"Paciente Cadastrado?"},model:{value:(_vm.registered),callback:function ($$v) {_vm.registered=$$v},expression:"registered"}}),_vm._v(" "),(!_vm.registered)?_c('v-text-field',{ref:"name",staticClass:"name",attrs:{"disabled":_vm.bodyData,"label":"Nome","counter":40,"required":!_vm.registered},model:{value:(_vm.proposedSurgeries.name),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "name", $$v)},expression:"proposedSurgeries.name"}}):_vm._e(),_vm._v(" "),(!_vm.registered)?_c('v-radio-group',{staticClass:"gender",attrs:{"row":""},model:{value:(_vm.proposedSurgeries.gender),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "gender", $$v)},expression:"proposedSurgeries.gender"}},[_c('v-radio',{attrs:{"label":"Masculino","value":"M","color":"blue"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Feminino","value":"F","color":"red"}})],1):_vm._e(),_vm._v(" "),(!_vm.registered)?_c('v-text-field',{staticClass:"cpf",attrs:{"required":!_vm.registered,"label":"CPF","rules":[function (v) { return !!v || 'CPF obrigatório!!'; }],"mask":"###.###.###-##","disabled":_vm.bodyData},model:{value:(_vm.proposedSurgeries.cpf),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "cpf", $$v)},expression:"proposedSurgeries.cpf"}}):_vm._e(),_vm._v(" "),(!_vm.registered)?_c('v-text-field',{staticClass:"birthDay",attrs:{"label":"Data Nasc.","mask":"date","rules":[function (v) { return !!v || 'Data de Nasc. obrigatória!!'; }],"required":!_vm.registered,"disabled":_vm.bodyData},model:{value:(_vm.proposedSurgeries.birthDay),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "birthDay", $$v)},expression:"proposedSurgeries.birthDay"}}):_vm._e(),_vm._v(" "),(!_vm.registered)?_c('v-select',{ref:"healthInsurance",staticClass:"healthInsurance",attrs:{"item-text":"name","item-value":"id","label":"Convênio","items":_vm.healthInsurances,"rules":[function (v) { return !!v || 'Convênio obrigatório!!'; }],"required":!_vm.registered},model:{value:(_vm.proposedSurgeries.healthInsurance),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "healthInsurance", $$v)},expression:"proposedSurgeries.healthInsurance"}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-form',{ref:"form",attrs:{"action":"#","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.sendMessage()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sendMessage()}}},[(_vm.registered)?_c('v-text-field',{attrs:{"append-icon":_vm.model ? 'arrow_back' : '',"append-outer-icon":_vm.message ? 'mdi-send' : 'search',"prepend-icon":_vm.icon,"box":"","clear-icon":"mdi-close-circle","clearable":"","label":"Paciente/Dt Nascimento","type":"text"},on:{"click:append":_vm.toggleMarker,"click:append-outer":_vm.sendMessage,"click:prepend":_vm.changeIcon,"click:clear":_vm.clearMessage},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}}):_vm._e()],1)],1),_vm._v(" "),_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingOk === true),expression:"loadingOk === true"}],attrs:{"indeterminate":true}}),_vm._v(" "),(!_vm.model)?_c('v-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.listVisible),expression:"listVisible"}],attrs:{"two-line":""}},[_vm._l((_vm.items),function(item,index){return [(item.header)?_c('v-subheader',{key:item.header},[_vm._v("\n                  Selecione o nome\n                  ")]):(item.divider)?_c('v-divider',{key:index,attrs:{"inset":item.inset}}):_c('v-list-tile',{key:item.id,attrs:{"avatar":""},on:{"click":function($event){return _vm.selectPatient(item)}}},[_c('v-list-tile-avatar',{attrs:{"color":"indigo"}},[_c('span',{staticClass:"white--text headline"},[_vm._v(_vm._s(item.symbol))])]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.dateOfBirth)}})],1)],1)]})],2):_vm._e(),_vm._v(" "),_c('v-select',{attrs:{"item-text":"title","item-value":"id","multiple":"","chips":"","hint":"Pode selecionar várias cirurgias!","persistent-hint":"","items":_vm.itemsSurgeries,"rules":[function (v) { return !!v || 'Cirurgia obrigatória!!'; }],"required":"","label":"Cirurgia(s)*"},model:{value:(_vm.proposedSurgeries.surgery),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "surgery", $$v)},expression:"proposedSurgeries.surgery"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Indicação Clínica","rules":[function (v) { return !!v || 'Indicação Clínica!!'; }],"required":""},model:{value:(_vm.proposedSurgeries.clinicalIndication),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "clinicalIndication", $$v)},expression:"proposedSurgeries.clinicalIndication"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Observacoes","required":""},model:{value:(_vm.proposedSurgeries.obs),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "obs", $$v)},expression:"proposedSurgeries.obs"}}),_vm._v(" "),_c('h3',{staticClass:"headline mb-0"},[_vm._v("Outras informacoes")]),_vm._v(" "),_c('v-select',{attrs:{"item-text":"title","item-value":"id","items":_vm.itemsAnesthesia,"label":"Indicação anestesica","required":""},model:{value:(_vm.proposedSurgeries.anesthesia),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "anesthesia", $$v)},expression:"proposedSurgeries.anesthesia"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Video","required":""},model:{value:(_vm.proposedSurgeries.video),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "video", $$v)},expression:"proposedSurgeries.video"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Debridador","required":""},model:{value:(_vm.proposedSurgeries.debridador),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "debridador", $$v)},expression:"proposedSurgeries.debridador"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Valor Instrumentação","required":""},model:{value:(_vm.proposedSurgeries.instructorValue),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "instructorValue", $$v)},expression:"proposedSurgeries.instructorValue"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Valor honorario Médico","required":""},model:{value:(_vm.proposedSurgeries.medicalFee),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "medicalFee", $$v)},expression:"proposedSurgeries.medicalFee"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Valor honorario Médico Auxiliar","required":""},model:{value:(_vm.proposedSurgeries.assistantValue),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "assistantValue", $$v)},expression:"proposedSurgeries.assistantValue"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Hemocomponentes","required":""},model:{value:(_vm.proposedSurgeries.hemocomponentes),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "hemocomponentes", $$v)},expression:"proposedSurgeries.hemocomponentes"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"OPME","required":""},model:{value:(_vm.proposedSurgeries.OPME),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "OPME", $$v)},expression:"proposedSurgeries.OPME"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"OPME Texto","required":""},model:{value:(_vm.proposedSurgeries.OPMETexto),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "OPMETexto", $$v)},expression:"proposedSurgeries.OPMETexto"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Anatomo Patologico","required":""},model:{value:(_vm.proposedSurgeries.pathologicalAnatomy),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "pathologicalAnatomy", $$v)},expression:"proposedSurgeries.pathologicalAnatomy"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"CID","required":""},model:{value:(_vm.proposedSurgeries.CID),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "CID", $$v)},expression:"proposedSurgeries.CID"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Fornecedor","required":""},model:{value:(_vm.proposedSurgeries.fornecedor),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "fornecedor", $$v)},expression:"proposedSurgeries.fornecedor"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Microscópio","required":""},model:{value:(_vm.proposedSurgeries.microscopio),callback:function ($$v) {_vm.$set(_vm.proposedSurgeries, "microscopio", $$v)},expression:"proposedSurgeries.microscopio"}}),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.alertVisible,"color":"error"}},[_vm._v("\n              "+_vm._s(_vm.alertTextRequired)+"\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary"},on:{"click":function($event){return _vm.save()}}},[_vm._v("\n              Salvar\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"blue darken-4","dark":""}},[_c('v-toolbar-title',[_vm._v("Cirurgias propostas")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.getProposedSurgeries),function(item,index){return [_c('v-list-tile',{key:index,attrs:{"avatar":"","ripple":""},on:{"click":function($event){return _vm.toggle(index)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v("Status: "+_vm._s(item.headline))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Cirurgia: "+_vm._s(item.subtitle))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-list-tile-action-text',[_vm._v("Horário "+_vm._s(item.action))])],1)],1),_vm._v(" "),(index + 1 < _vm.items.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-bottom":"38px","margin-right":"10px"},attrs:{"color":"pink","dark":"","absolute":"","bottom":"","right":"","fab":""},on:{"click":function($event){_vm.dialogCreated = true}}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogCreated),callback:function ($$v) {_vm.dialogCreated=$$v},expression:"dialogCreated"}},[_c('create-schedule')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getCustomers = function getCustomers(state) {
  return state.customers;
};

var getUser = function getUser(state) {
  return state.auth.user;
};

var getSearchUser = function getSearchUser(state) {
  return state.searchRegisterUser;
};

var getRegisterUser = function getRegisterUser(state) {
  return state.register;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getUser: getUser,
  getSearchUser: getSearchUser,
  getRegisterUser: getRegisterUser,
  getCustomers: getCustomers
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_CUSTOMERS = function SET_CUSTOMERS(state, payload) {
  state.customers = payload;
};

var SET_CHANGE_SCHEDULE = function SET_CHANGE_SCHEDULE(state, payload) {
  state.auth.myClinic = payload;
};

var SET_USER = function SET_USER(state, user) {
  state.auth = user;
};

var SET_REGISTER = function SET_REGISTER(state, register) {
  state.register = register;
};

var SET_TOKEN = function SET_TOKEN(state, token) {
  state.token = token;
};

var SET_SEARCHEMAIL = function SET_SEARCHEMAIL(state, user) {
  state.searchRegisterUser = user;
};

var SET_CREATEUSER = function SET_CREATEUSER(state, user) {
  state.createUser = user;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_USER: SET_USER,
  SET_TOKEN: SET_TOKEN,
  SET_SEARCHEMAIL: SET_SEARCHEMAIL,
  SET_CREATEUSER: SET_CREATEUSER,
  SET_REGISTER: SET_REGISTER,
  SET_CUSTOMERS: SET_CUSTOMERS,
  SET_CHANGE_SCHEDULE: SET_CHANGE_SCHEDULE
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(445);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  list: [],
  createRecord: null
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);



// import store from '../../../store'

var setListRecord = function setListRecord(_ref, payload) {
  var commit = _ref.commit;

  console.log('setListRecord payload', payload);
  if (!payload.patient) return false;
  var patient = payload.patient,
      customer = payload.customer;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.spitzer.io" + '/my-clinic-new/patient/medical-record', {
      params: {
        customer: customer, // store.state.customer,
        patient: patient
      }
    }).then(function (response) {
      // handle success
      var items = response.data.results.results.map(function (item) {
        return {
          date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.tbData, 'DD/MM/YYYY').format('DD/MM/YY'),
          hour: __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.tbHora, 'LTS').format('HH'),
          doctor: item.tbNomeMedico === null ? '' : item.tbNomeMedico.substring(0, 10),
          history: item.tbDescricao,
          color: 'purple darken-1',
          icon: 'mdi-book-variant'
        };
      });
      resolve(commit('SET_LISTRECORD', items));
    }).catch(function (error) {
      // handle error
      console.error('err', error);
      reject(error);
    }).then(function () {
      // always executed
    });
  });
};

var setCreateRecord = function setCreateRecord(_ref2, payload) {
  var commit = _ref2.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var doctor = payload.doctor,
        patient = payload.patient,
        customer = payload.customer,
        date = payload.date,
        record = payload.record,
        description = payload.description;

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.spitzer.io" + '/my-clinic-new/patient-record/create', {
      doctor: doctor,
      patient: patient,
      date: date,
      record: record,
      description: description
    }, {
      params: {
        customer: customer
      }
    }).then(function (response) {
      resolve(commit('SET_LISTRECORD', response));
    }).catch(function (err) {
      window.console.error('errologin', err);
      reject(err);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setListRecord: setListRecord,
  setCreateRecord: setCreateRecord
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var getListRecord = function getListRecord(state) {
  return state.list;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getListRecord: getListRecord
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var SET_LISTRECORD = function SET_LISTRECORD(state, payload) {
  state.list = payload;
};

var SETCREATERECORD = function SETCREATERECORD(state, payload) {
  state.createRecord = payload;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LISTRECORD: SET_LISTRECORD,
  SETCREATERECORD: SETCREATERECORD
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(450);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  patient: {},
  attachment: {}
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(9);




var _this = this;




var setAttachment = function setAttachment(_ref, payload) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
      var bucket, code, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              bucket = payload.bucket, code = payload.code;

              if (!(bucket === undefined || code === undefined)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return', false);

            case 3:
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://sync.gestaoclinic.com.br/list?bucket=' + bucket + '&MaxKeys=150&prefix=imagens/' + code);

            case 5:
              response = _context.sent;
              return _context.abrupt('return', resolve(commit('SET_ATTACHMENT', response)));

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }());
};

var setPatient = function setPatient(_ref3, payload) {
  var commit = _ref3.commit;

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!payload) return false;
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://api.spitzer.io" + '/my-clinic-new/patient/find-one', {
      params: {
        patient: payload,
        customer: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.customer
      }
    }).then(function (response) {
      // handle success
      var profileData = response.data.results.results.map(function (item) {
        return {
          id: item.tbCodigo,
          name: item.tbNome,
          symbol: 'BTC',
          website_slug: 'spitzer.io',
          dateOfBirth: item.tbDtNasc,
          mobile: item.tbCelular,
          covenant: item.tbConvenio,
          email: item.tbEmail,
          city: item.tbCidade,
          addrees: item.tbEndereco,
          rg: item.tbRG,
          cpf: item.tbCPF,
          bucket: item.tbParametro || undefined
        };
      });
      resolve(commit('SET_PATIENT', profileData[0]));
    }).catch(function (err) {
      console.log(err);
      reject(err);
    }).then(function () {
      // always executed
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setPatient: setPatient,
  setAttachment: setAttachment
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var getPatient = function getPatient(state) {
  return state.patient;
};
var getAttachment = function getAttachment(state) {
  return state.attachment;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getPatient: getPatient,
  getAttachment: getAttachment
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var SET_PATIENT = function SET_PATIENT(state, payload) {
  state.patient = payload;
};

var SET_ATTACHMENT = function SET_ATTACHMENT(state, payload) {
  state.attachment = payload;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_PATIENT: SET_PATIENT,
  SET_ATTACHMENT: SET_ATTACHMENT
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(455);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  list: [],
  availableAppointments: {}
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(9);





var setList = function setList(_ref, payload) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.spitzer.io" + '/my-clinic-new/procedure/done/value', {
      params: {
        customer: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.customer,
        doctor: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.auth.auth.user.crm,
        periodStart: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add('months', -2).date(0).format('MM-DD-YYYY'),
        periodEnd: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add('months', 2).date(0).format('MM-DD-YYYY')
      }
    }).then(function (response) {
      // handle success
      var items = response.data.results.results.map(function (item) {
        return {
          mount: item.tbQtde,
          value: item.tbValor,
          covenant: item.tbConvenio,
          doctor: item.tbMedico,
          crm: item.tbCRM
        };
      });
      resolve(commit('SET_LIST', items));
    }).catch(function (error) {
      // handle error
      console.error('err', error);
      reject(error);
    }).then(function () {
      // always executed
    });
  });
};

var setAvailableAppointments = function setAvailableAppointments(_ref2, schedule) {
  var commit = _ref2.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.spitzer.io" + '/my-clinic-new/procedure/done/amount', {
      params: {
        customer: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.customer,
        doctor: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.auth.auth.user.crm,
        periodStart: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add('months', -2).date(0).format('MM-DD-YYYY'),
        periodEnd: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add('months', 2).date(0).format('MM-DD-YYYY')
      }
    }).then(function (response) {
      // handle success
      var items = response.data.results.results.map(function (item) {
        return {
          amount: item.tbQtde,
          month: item.tbMes,
          year: item.tbAno
        };
      });
      resolve(commit('SET_AVAILABLEAPPOINTMENTS', items));
    }).catch(function (error) {
      // handle error
      console.error('err', error);
      reject(error);
    }).then(function () {
      // always executed
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setList: setList,
  setAvailableAppointments: setAvailableAppointments
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var getList = function getList(state) {
  return state.list;
};
var getAvailableAppointments = function getAvailableAppointments(state) {
  return state.availableAppointments;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: getList,
  getAvailableAppointments: getAvailableAppointments
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var SET_LIST = function SET_LIST(state, schedule) {
  state.list = schedule;
};

var SET_AVAILABLEAPPOINTMENTS = function SET_AVAILABLEAPPOINTMENTS(state, schedule) {
  state.availableAppointments = schedule;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST,
  SET_AVAILABLEAPPOINTMENTS: SET_AVAILABLEAPPOINTMENTS
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(460);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  list: [],
  availableAppointments: {}
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(9);





var setList = function setList(_ref, payload) {
  var commit = _ref.commit;

  if (!payload) return false;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.spitzer.io" + '/my-clinic-new/patient/medical-record', {
      params: {
        customer: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.customer,
        patient: payload
      }
    }).then(function (response) {
      // handle success
      var items = response.data.results.results.map(function (item) {
        return {
          date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.tbData, 'DD/MM/YYYY').format('DD/MM'),
          hour: __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.tbHora, 'LTS').format('HH'),
          doctor: item.tbNomeMedico.substring(0, 10),
          history: item.tbDescricao
        };
      });
      resolve(commit('SET_LIST', items));
    }).catch(function (error) {
      // handle error
      console.log('err', error);
      reject(error);
    }).then(function () {
      // always executed
    });
  });
};

var setAvailableAppointments = function setAvailableAppointments(_ref2, schedule) {
  var commit = _ref2.commit;

  commit('SET_AVAILABLEAPPOINTMENTS', schedule);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setList: setList,
  setAvailableAppointments: setAvailableAppointments
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var getList = function getList(state) {
  return state.list;
};
var getAvailableAppointments = function getAvailableAppointments(state) {
  return state.availableAppointments;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: getList,
  getAvailableAppointments: getAvailableAppointments
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var SET_LIST = function SET_LIST(state, schedule) {
  state.list = schedule;
};

var SET_AVAILABLEAPPOINTMENTS = function SET_AVAILABLEAPPOINTMENTS(state, schedule) {
  state.availableAppointments = schedule;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST,
  SET_AVAILABLEAPPOINTMENTS: SET_AVAILABLEAPPOINTMENTS
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(465);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  list: [],
  createRecordExam: null
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);



// import store from '../..'

var setListRecordExam = function setListRecordExam(_ref, payload) {
  var commit = _ref.commit;

  if (!payload.patient) return false;
  var patient = payload.patient,
      customer = payload.customer;

  console.log('payload', payload);
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.spitzer.io" + '/my-clinic-new/patient/examination-report', {
      params: {
        customer: customer, // store.state.customer,
        patient: patient
      }
    }).then(function (response) {
      // handle success
      var items = [];
      if (response && response.data && response.data.results && response.data.results.results) {
        items = response.data.results.results.map(function (item) {
          return {
            date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.tbData, 'YYYY/MM/DD').format('DD/MM'),
            hour: __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.tbHora, 'LTS').format('HH'),
            doctor: item.tbNomeMedico === null ? '' : item.tbNomeMedico.substring(0, 10),
            history: item.tbDescricao
          };
        });
      }
      resolve(commit('SET_LISTRECORDEXAM', items));
    }).catch(function (error) {
      // handle error
      console.error('err', error);
      reject(error);
    }).then(function () {
      // always executed
    });
  });
};

var setCreateRecordExam = function setCreateRecordExam(_ref2, payload) {
  var commit = _ref2.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var doctor = payload.doctor,
        patient = payload.patient,
        customer = payload.customer,
        date = payload.date,
        record = payload.record,
        description = payload.description;

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.spitzer.io" + '/my-clinic-new/examination-report/create', {
      doctor: doctor,
      patient: patient,
      date: date,
      record: record,
      description: description
    }, {
      params: {
        customer: customer
      }
    }).then(function (response) {
      resolve(commit('SET_LISTRECORDEXAM', response));
    }).catch(function (err) {
      window.console.error('errologin', err);
      reject(err);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setListRecordExam: setListRecordExam,
  setCreateRecordExam: setCreateRecordExam
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var getListRecord = function getListRecord(state) {
  return state.list;
};
var getRecordExam = function getRecordExam(state) {
  return state.createRecordExam;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getListRecord: getListRecord,
  getRecordExam: getRecordExam
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var SET_LISTRECORDEXAM = function SET_LISTRECORDEXAM(state, payload) {
  state.list = payload;
};

var SETCREATERECORDEXAME = function SETCREATERECORDEXAME(state, payload) {
  state.createRecordExam = payload;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SETCREATERECORDEXAME: SETCREATERECORDEXAME,
  SET_LISTRECORDEXAM: SET_LISTRECORDEXAM
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(471);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  token: null
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axiosMemed__ = __webpack_require__(469);



var setToken = function setToken(_ref, payload) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var crm = ('0000' + payload.codeCustomer).slice(-4) + '$' + payload.crm;
    var url = '/doctor/' + crm;
    __WEBPACK_IMPORTED_MODULE_1__axiosMemed__["a" /* default */].get(url).then(function (resultToken) {
      resolve(commit('SET_TOKEN', resultToken.data.token));
    }).catch(function (err) {
      console.error(err);
      reject(err);
    });
  });
};

var createMemed = function createMemed(_ref2, payload) {
  var commit = _ref2.commit;

  var dataBody = {
    data: {
      'type': 'usuarios',
      'attributes': {
        'external_id': ('0000' + payload.codeCustomer).slice(-4) + '$' + payload.crm,
        'nome': payload.name,
        'sobrenome': payload.name,
        'data_nascimento': null || payload.birthDay,
        'cpf': null || payload.cpf,
        'email': payload.username,
        'uf': 'PR' || payload.state,
        'sexo': null || payload.gender,
        'crm': payload.crm
      },
      'relationships': {
        // Cidade do profissional (recomendado, não obrigatório)
        'cidade': {
          'data': {
            'type': 'cidades',
            'id': '2853'
          }
        },
        // Especialidade do profissional: Clínica médica, Oftalmologia, etc. (recomendado para otimizarmos nossa busca)
        'especialidade': {
          'data': {
            'type': 'especialidades',
            'id': '69'
          }
        }
      }
    }
  };
  var url = '/doctor/create';
  __WEBPACK_IMPORTED_MODULE_1__axiosMemed__["a" /* default */].post(url, dataBody).then(function (resultToken) {
    setToken(payload);
  }).catch(function (err) {
    console.error(err);
  });
};

var createPatientMemed = function createPatientMemed(_ref3, payload) {
  var commit = _ref3.commit;

  console.log(payload);
  var dataBody = {
    name: payload.title,
    idExternal: payload.code,
    address: null,
    phone: payload.mobile,
    city: null,
    idCustomer: payload.idCustomer
  };
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var url = '/patients';
    __WEBPACK_IMPORTED_MODULE_1__axiosMemed__["a" /* default */].post(url, dataBody).then(function (resultToken) {
      // resolve(commit('SET_TOKEN', resultToken.data.token))
    }).catch(function (err) {
      console.error(err);
      reject(err);
    });
  });
};

var createPrescription = function createPrescription(_ref4, payload) {
  var commit = _ref4.commit;

  console.log(payload);
  // return new Promise((resolve, reject) => {
  //   const url = `/prescription`
  //   axiosMemed.post(url)
  //     .then((resultToken) => {
  //       resolve(commit('SET_TOKEN', resultToken.data.token))
  //     })
  //     .catch((err) => {
  //       console.error(err)
  //       reject(err)
  //     })
  // })
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setToken: setToken,
  createMemed: createMemed,
  createPatientMemed: createPatientMemed,
  createPrescription: createPrescription
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


// 'http://192.168.100.96:5356'

var domain = "https://api-memed.gestaoclinic.com.br";

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  domain: domain,
  baseURL: "https://api-memed.gestaoclinic.com.br"
}));

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var getToken = function getToken(state) {
  return state.token;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getToken: getToken
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var SET_TOKEN = function SET_TOKEN(state, payload) {
  state.token = payload;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_TOKEN: SET_TOKEN
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[(this.logged === true)?_c('toolbar-menu'):_vm._e(),_vm._v(" "),_c('v-content',[_c('transition',{attrs:{"name":"slide"}},[_c('router-view')],1)],1),_vm._v(" "),(this.logged === true)?_c('footer-menu'):_vm._e(),_vm._v(" "),_c('MigrationDialog')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 473 */,
/* 474 */,
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(24);



var bus = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();

function install(Vue) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
    $bus: {
      get: function get() {
        return bus;
      }
    }
  });
}

/***/ }),
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[256]);


// WEBPACK FOOTER //
// static/js/app.b96ff19d39b71837f1da.js